var t = /* @__PURE__ */ ((i) => (i.REGULAR = "regular", i.THIN = "thin", i.LIGHT = "light", i.BOLD = "bold", i.FILL = "fill", i.DUOTONE = "duotone", i))(t || {}), e = /* @__PURE__ */ ((i) => (i.ARROWS = "arrows", i.BRAND = "brands", i.COMMERCE = "commerce", i.COMMUNICATION = "communications", i.DESIGN = "design", i.DEVELOPMENT = "technology & development", i.EDITOR = "editor", i.FINANCE = "finances", i.GAMES = "games", i.HEALTH = "health & wellness", i.MAP = "maps & travel", i.MEDIA = "media", i.NATURE = "nature", i.OBJECTS = "objects", i.OFFICE = "office", i.PEOPLE = "people", i.SYSTEM = "system", i.WEATHER = "weather", i))(e || {}), a = /* @__PURE__ */ ((i) => (i.ARROWS = "arrows", i.BRAND = "brands", i.COMMERCE = "commerce", i.COMMUNICATION = "communication", i.DESIGN = "design", i.DEVELOPMENT = "technology & development", i.EDUCATION = "education", i.FINANCE = "math & finance", i.GAMES = "games", i.HEALTH = "health & wellness", i.MAP = "maps & travel", i.MEDIA = "media", i.OFFICE = "office & editing", i.PEOPLE = "people", i.SECURITY = "security & warnings", i.SYSTEM = "system & devices", i.TIME = "time", i.WEATHER = "weather & nature", i))(a || {});
const n = [
  {
    name: "acorn",
    pascal_name: "Acorn",
    categories: [e.FINANCE, e.NATURE],
    figma_category: a.WEATHER,
    tags: [
      "*new*",
      "savings",
      "nut",
      "vegetable",
      "veggies",
      "food",
      "groceries",
      "market"
    ],
    codepoint: 60314,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "address-book",
    pascal_name: "AddressBook",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["contacts", "directory", "roledex"],
    codepoint: 59128,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "address-book-tabs",
    pascal_name: "AddressBookTabs",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["*new*", "contacts", "directory", "roledex"],
    codepoint: 61006,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "air-traffic-control",
    pascal_name: "AirTrafficControl",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["airport", "travel", "transportation", "buildings"],
    codepoint: 60632,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "airplane",
    pascal_name: "Airplane",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "vehicles",
      "airports",
      "flights",
      "flying",
      "planes",
      "transit",
      "transportation",
      "traveling"
    ],
    codepoint: 57346,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "airplane-in-flight",
    pascal_name: "AirplaneInFlight",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "vehicles",
      "airports",
      "flights",
      "flying",
      "planes",
      "transit",
      "transportation",
      "traveling",
      "arrival"
    ],
    codepoint: 58622,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "airplane-landing",
    pascal_name: "AirplaneLanding",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "vehicles",
      "airports",
      "flights",
      "flying",
      "planes",
      "transit",
      "transportation",
      "traveling",
      "arrival"
    ],
    codepoint: 58626,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "airplane-takeoff",
    pascal_name: "AirplaneTakeoff",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "vehicles",
      "airports",
      "flights",
      "flying",
      "planes",
      "transit",
      "transportation",
      "traveling",
      "departure"
    ],
    codepoint: 58628,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "airplane-taxiing",
    pascal_name: "AirplaneTaxiing",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "vehicles",
      "airports",
      "flights",
      "flying",
      "planes",
      "transit",
      "transportation",
      "traveling",
      "arrival"
    ],
    codepoint: 58624,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "airplane-tilt",
    pascal_name: "AirplaneTilt",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "vehicles",
      "airports",
      "flights",
      "flying",
      "planes",
      "transit",
      "transportation",
      "traveling",
      "departure"
    ],
    codepoint: 58838,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "airplay",
    pascal_name: "Airplay",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["apple", "screencasting", "television", "tv"],
    codepoint: 57348,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "alarm",
    pascal_name: "Alarm",
    categories: [e.SYSTEM],
    figma_category: a.TIME,
    tags: ["times", "timer", "clock", "schedule", "events", "watch"],
    codepoint: 57350,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "alien",
    pascal_name: "Alien",
    categories: [e.GAMES],
    figma_category: a.GAMES,
    tags: ["ufo", "space", "flying saucer", "extra terrestrial", "sci-fi"],
    codepoint: 59558,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "align-bottom",
    pascal_name: "AlignBottom",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "flush bottom"],
    codepoint: 58630,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "align-bottom-simple",
    pascal_name: "AlignBottomSimple",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "flush bottom"],
    codepoint: 60172,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "align-center-horizontal",
    pascal_name: "AlignCenterHorizontal",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "centered", "middle"],
    codepoint: 58634,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "align-center-horizontal-simple",
    pascal_name: "AlignCenterHorizontalSimple",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "centered", "middle"],
    codepoint: 60174,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "align-center-vertical",
    pascal_name: "AlignCenterVertical",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "centered", "middle"],
    codepoint: 58636,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "align-center-vertical-simple",
    pascal_name: "AlignCenterVerticalSimple",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "centered", "middle"],
    codepoint: 60176,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "align-left",
    pascal_name: "AlignLeft",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "flush left"],
    codepoint: 58638,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "align-left-simple",
    pascal_name: "AlignLeftSimple",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "flush left"],
    codepoint: 60142,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "align-right",
    pascal_name: "AlignRight",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "flush right"],
    codepoint: 58640,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "align-right-simple",
    pascal_name: "AlignRightSimple",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "flush right"],
    codepoint: 60178,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "align-top",
    pascal_name: "AlignTop",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "flush top"],
    codepoint: 58642,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "align-top-simple",
    pascal_name: "AlignTopSimple",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["alignment", "arrangement", "layout", "flush top"],
    codepoint: 60180,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "amazon-logo",
    pascal_name: "AmazonLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["ecommerce", "shopping", "logos"],
    codepoint: 59756,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "ambulance",
    pascal_name: "Ambulance",
    categories: [e.HEALTH, e.MAP, e.OBJECTS],
    figma_category: a.HEALTH,
    tags: [
      "*new*",
      "first-aid",
      "emt",
      "medical",
      "medicine",
      "injury",
      "safety",
      "emergency",
      "doctor",
      "vehicles"
    ],
    codepoint: 58738,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "anchor",
    pascal_name: "Anchor",
    categories: [
      e.COMMUNICATION,
      e.MAP,
      e.OBJECTS
    ],
    figma_category: a.MAP,
    tags: ["nautical", "boats", "ships", "hope", "safety", "insurance"],
    codepoint: 58644,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "anchor-simple",
    pascal_name: "AnchorSimple",
    categories: [
      e.COMMUNICATION,
      e.MAP,
      e.OBJECTS
    ],
    figma_category: a.MAP,
    tags: ["nautical", "boats", "ships", "hope", "safety", "insurance"],
    codepoint: 58840,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "android-logo",
    pascal_name: "AndroidLogo",
    categories: [
      e.BRAND,
      e.DEVELOPMENT,
      e.SYSTEM
    ],
    figma_category: a.BRAND,
    tags: ["logos", "google", "mobile", "phone", "cellular", "cellphone"],
    codepoint: 57352,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "angle",
    pascal_name: "Angle",
    categories: [e.DESIGN, e.OBJECTS],
    figma_category: a.DESIGN,
    tags: [
      "*new*",
      "geometry",
      "trigonometry",
      "degrees",
      "radians",
      "measurement",
      "protractor",
      "compass",
      "arc"
    ],
    codepoint: 59324,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "angular-logo",
    pascal_name: "AngularLogo",
    categories: [e.BRAND, e.DEVELOPMENT],
    figma_category: a.BRAND,
    tags: ["framework", "javascript", "google", "web"],
    codepoint: 60288,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "aperture",
    pascal_name: "Aperture",
    categories: [e.DESIGN, e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["photography", "cameras", "pictures", "lens"],
    codepoint: 57354,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "app-store-logo",
    pascal_name: "AppStoreLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["macintosh", "imac", "iphone", "ipad", "macos", "ios"],
    codepoint: 59764,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "app-window",
    pascal_name: "AppWindow",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["windows", "software", "programs", "applications"],
    codepoint: 58842,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "apple-logo",
    pascal_name: "AppleLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["macintosh", "imac", "iphone", "ipad", "macos", "ios"],
    codepoint: 58646,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "apple-podcasts-logo",
    pascal_name: "ApplePodcastsLogo",
    categories: [e.BRAND, e.MEDIA],
    figma_category: a.BRAND,
    tags: ["macintosh", "imac", "iphone", "ipad", "macos", "ios"],
    codepoint: 60310,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "approximate-equals",
    pascal_name: "ApproximateEquals",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "≈",
      "is approximately equal to",
      "congruent",
      "equality",
      "equivalent",
      "equivalence",
      "comparison",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60842,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "archive",
    pascal_name: "Archive",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "downloaded",
      "downloading"
    ],
    codepoint: 57356,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "armchair",
    pascal_name: "Armchair",
    categories: [e.OBJECTS, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["seat", "furniture"],
    codepoint: 57362,
    published_in: 1.2,
    updated_in: 1.4
  },
  {
    name: "arrow-arc-left",
    pascal_name: "ArrowArcLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57364,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-arc-right",
    pascal_name: "ArrowArcRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57366,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-bend-double-up-left",
    pascal_name: "ArrowBendDoubleUpLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "reply-all"],
    codepoint: 57402,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-bend-double-up-right",
    pascal_name: "ArrowBendDoubleUpRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57404,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-bend-down-left",
    pascal_name: "ArrowBendDownLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57368,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-bend-down-right",
    pascal_name: "ArrowBendDownRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57370,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-bend-left-down",
    pascal_name: "ArrowBendLeftDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57372,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-bend-left-up",
    pascal_name: "ArrowBendLeftUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57374,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-bend-right-down",
    pascal_name: "ArrowBendRightDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57376,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-bend-right-up",
    pascal_name: "ArrowBendRightUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57378,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-bend-up-left",
    pascal_name: "ArrowBendUpLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "reply", "re"],
    codepoint: 57380,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-bend-up-right",
    pascal_name: "ArrowBendUpRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "forward", "fwd"],
    codepoint: 57382,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-circle-down",
    pascal_name: "ArrowCircleDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57384,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-circle-down-left",
    pascal_name: "ArrowCircleDownLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57386,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-circle-down-right",
    pascal_name: "ArrowCircleDownRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57388,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-circle-left",
    pascal_name: "ArrowCircleLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57434,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-circle-right",
    pascal_name: "ArrowCircleRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57390,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-circle-up",
    pascal_name: "ArrowCircleUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57392,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-circle-up-left",
    pascal_name: "ArrowCircleUpLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57394,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-circle-up-right",
    pascal_name: "ArrowCircleUpRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57396,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-clockwise",
    pascal_name: "ArrowClockwise",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "redo",
      "refreshing",
      "rotate",
      "spin",
      "flip"
    ],
    codepoint: 57398,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrow-counter-clockwise",
    pascal_name: "ArrowCounterClockwise",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "undo",
      "refreshing",
      "rotate",
      "spin",
      "flip"
    ],
    codepoint: 57400,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrow-down",
    pascal_name: "ArrowDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57406,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-down-left",
    pascal_name: "ArrowDownLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57408,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-down-right",
    pascal_name: "ArrowDownRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57410,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-elbow-down-left",
    pascal_name: "ArrowElbowDownLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57412,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-elbow-down-right",
    pascal_name: "ArrowElbowDownRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57414,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-elbow-left",
    pascal_name: "ArrowElbowLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57416,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-elbow-left-down",
    pascal_name: "ArrowElbowLeftDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57418,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-elbow-left-up",
    pascal_name: "ArrowElbowLeftUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57420,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-elbow-right",
    pascal_name: "ArrowElbowRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57422,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-elbow-right-down",
    pascal_name: "ArrowElbowRightDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57424,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-elbow-right-up",
    pascal_name: "ArrowElbowRightUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57426,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-elbow-up-left",
    pascal_name: "ArrowElbowUpLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57428,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-elbow-up-right",
    pascal_name: "ArrowElbowUpRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57430,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-fat-down",
    pascal_name: "ArrowFatDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "outlined"],
    codepoint: 58648,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-fat-left",
    pascal_name: "ArrowFatLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "outlined"],
    codepoint: 58650,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-fat-line-down",
    pascal_name: "ArrowFatLineDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "outlined"],
    codepoint: 58652,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-fat-line-left",
    pascal_name: "ArrowFatLineLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "outlined"],
    codepoint: 58654,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-fat-line-right",
    pascal_name: "ArrowFatLineRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "outlined"],
    codepoint: 58656,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-fat-line-up",
    pascal_name: "ArrowFatLineUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "caps lock",
      "outlined"
    ],
    codepoint: 58658,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-fat-lines-down",
    pascal_name: "ArrowFatLinesDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "outlined"],
    codepoint: 58660,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-fat-lines-left",
    pascal_name: "ArrowFatLinesLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "outlined"],
    codepoint: 58662,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-fat-lines-right",
    pascal_name: "ArrowFatLinesRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "outlined"],
    codepoint: 58664,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-fat-lines-up",
    pascal_name: "ArrowFatLinesUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "outlined"],
    codepoint: 58666,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-fat-right",
    pascal_name: "ArrowFatRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "outlined"],
    codepoint: 58668,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-fat-up",
    pascal_name: "ArrowFatUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "shift",
      "outlined"
    ],
    codepoint: 58670,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "arrow-left",
    pascal_name: "ArrowLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57432,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-line-down",
    pascal_name: "ArrowLineDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "bottom"],
    codepoint: 57436,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-line-down-left",
    pascal_name: "ArrowLineDownLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57438,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-line-down-right",
    pascal_name: "ArrowLineDownRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57440,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-line-left",
    pascal_name: "ArrowLineLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57442,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-line-right",
    pascal_name: "ArrowLineRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57444,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-line-up",
    pascal_name: "ArrowLineUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead", "top"],
    codepoint: 57446,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-line-up-left",
    pascal_name: "ArrowLineUpLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57448,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-line-up-right",
    pascal_name: "ArrowLineUpRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57450,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-right",
    pascal_name: "ArrowRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57452,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-square-down",
    pascal_name: "ArrowSquareDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57454,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-square-down-left",
    pascal_name: "ArrowSquareDownLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57456,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-square-down-right",
    pascal_name: "ArrowSquareDownRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57458,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-square-in",
    pascal_name: "ArrowSquareIn",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["import", "directional", "pointer", "pointing", "arrowhead"],
    codepoint: 58844,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "arrow-square-left",
    pascal_name: "ArrowSquareLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57460,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-square-out",
    pascal_name: "ArrowSquareOut",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "export",
      "external",
      "directional",
      "pointer",
      "pointing",
      "arrowhead"
    ],
    codepoint: 58846,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "arrow-square-right",
    pascal_name: "ArrowSquareRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57462,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-square-up",
    pascal_name: "ArrowSquareUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57464,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-square-up-left",
    pascal_name: "ArrowSquareUpLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57466,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-square-up-right",
    pascal_name: "ArrowSquareUpRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57468,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-u-down-left",
    pascal_name: "ArrowUDownLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "undo",
      "return",
      "u-turns"
    ],
    codepoint: 57470,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-u-down-right",
    pascal_name: "ArrowUDownRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "redo",
      "u-turns"
    ],
    codepoint: 57472,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-u-left-down",
    pascal_name: "ArrowULeftDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "undo",
      "return",
      "u-turns"
    ],
    codepoint: 57474,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-u-left-up",
    pascal_name: "ArrowULeftUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "redo",
      "u-turns"
    ],
    codepoint: 57476,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-u-right-down",
    pascal_name: "ArrowURightDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "undo",
      "return",
      "u-turns"
    ],
    codepoint: 57478,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-u-right-up",
    pascal_name: "ArrowURightUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "redo",
      "u-turns"
    ],
    codepoint: 57480,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-u-up-left",
    pascal_name: "ArrowUUpLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "undo",
      "return",
      "u-turns"
    ],
    codepoint: 57482,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-u-up-right",
    pascal_name: "ArrowUUpRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "redo",
      "u-turns"
    ],
    codepoint: 57484,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-up",
    pascal_name: "ArrowUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57486,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-up-left",
    pascal_name: "ArrowUpLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57488,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrow-up-right",
    pascal_name: "ArrowUpRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57490,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "arrows-clockwise",
    pascal_name: "ArrowsClockwise",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "redo",
      "refreshing",
      "sync",
      "synchronize",
      "rotate",
      "spin",
      "flip"
    ],
    codepoint: 57492,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrows-counter-clockwise",
    pascal_name: "ArrowsCounterClockwise",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "undo",
      "refreshing",
      "rotate",
      "spin",
      "flip"
    ],
    codepoint: 57494,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrows-down-up",
    pascal_name: "ArrowsDownUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["*updated*", "directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57496,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrows-horizontal",
    pascal_name: "ArrowsHorizontal",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "cursor",
      "resize",
      "expand",
      "left",
      "right"
    ],
    codepoint: 60166,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "arrows-in",
    pascal_name: "ArrowsIn",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "collapse",
      "minimize",
      "resize",
      "shrink"
    ],
    codepoint: 57498,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrows-in-cardinal",
    pascal_name: "ArrowsInCardinal",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "collapse",
      "minimize",
      "resize",
      "shrink"
    ],
    codepoint: 57500,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrows-in-line-horizontal",
    pascal_name: "ArrowsInLineHorizontal",
    categories: [e.ARROWS, e.DESIGN, e.EDITOR],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "close",
      "center",
      "align"
    ],
    codepoint: 58672,
    published_in: 1.1,
    updated_in: 2.1
  },
  {
    name: "arrows-in-line-vertical",
    pascal_name: "ArrowsInLineVertical",
    categories: [e.ARROWS, e.DESIGN, e.EDITOR],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "close",
      "center",
      "align"
    ],
    codepoint: 58674,
    published_in: 1.1,
    updated_in: 2.1
  },
  {
    name: "arrows-in-simple",
    pascal_name: "ArrowsInSimple",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "collapse",
      "minimize",
      "resize"
    ],
    codepoint: 57502,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrows-left-right",
    pascal_name: "ArrowsLeftRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["*updated*", "directional", "pointer", "pointing", "arrowhead"],
    codepoint: 57504,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrows-merge",
    pascal_name: "ArrowsMerge",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["*updated*", "arrowheads", "join", "combine"],
    codepoint: 60734,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "arrows-out",
    pascal_name: "ArrowsOut",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "expand",
      "fullscreen",
      "resize",
      "grow"
    ],
    codepoint: 57506,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrows-out-cardinal",
    pascal_name: "ArrowsOutCardinal",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "expand",
      "fullscreen",
      "resize",
      "pan",
      "move",
      "grow"
    ],
    codepoint: 57508,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrows-out-line-horizontal",
    pascal_name: "ArrowsOutLineHorizontal",
    categories: [e.ARROWS, e.DESIGN, e.EDITOR],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "open",
      "split"
    ],
    codepoint: 58676,
    published_in: 1.1,
    updated_in: 2.1
  },
  {
    name: "arrows-out-line-vertical",
    pascal_name: "ArrowsOutLineVertical",
    categories: [e.ARROWS, e.DESIGN, e.EDITOR],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "open",
      "split"
    ],
    codepoint: 58678,
    published_in: 1.1,
    updated_in: 2.1
  },
  {
    name: "arrows-out-simple",
    pascal_name: "ArrowsOutSimple",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "expand",
      "fullscreen",
      "resize"
    ],
    codepoint: 57510,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "arrows-split",
    pascal_name: "ArrowsSplit",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: ["*updated*", "arrowheads", "fork"],
    codepoint: 60732,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "arrows-vertical",
    pascal_name: "ArrowsVertical",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*updated*",
      "directional",
      "pointer",
      "cursor",
      "resize",
      "expand",
      "up",
      "down"
    ],
    codepoint: 60164,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "article",
    pascal_name: "Article",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: [
      "reading",
      "writing",
      "journals",
      "periodicals",
      "text",
      "newspaper"
    ],
    codepoint: 57512,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "article-medium",
    pascal_name: "ArticleMedium",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: [
      "*updated*",
      "reading",
      "writing",
      "journals",
      "periodicals",
      "text",
      "newspaper"
    ],
    codepoint: 58848,
    published_in: 1.2,
    updated_in: 2.1
  },
  {
    name: "article-ny-times",
    pascal_name: "ArticleNyTimes",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: [
      "*updated*",
      "reading",
      "writing",
      "journals",
      "periodicals",
      "text",
      "news",
      "newspaper",
      "nyt",
      "new york times"
    ],
    codepoint: 58850,
    published_in: 1.2,
    updated_in: 2.1
  },
  {
    name: "asclepius",
    pascal_name: "Asclepius",
    alias: { name: "caduceus", pascal_name: "Caduceus" },
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: [
      "*new*",
      "caduceus",
      "staff",
      "mythology",
      "rx",
      "medicine",
      "drugs",
      "pharmacy",
      "pharmacist",
      "pharmaceuticals",
      "doctor",
      "hospital",
      "snake",
      "mercury",
      "hermes"
    ],
    codepoint: 60980,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "asterisk",
    pascal_name: "Asterisk",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["star", "wildcard", "bullet point", "6", "emergency"],
    codepoint: 57514,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "asterisk-simple",
    pascal_name: "AsteriskSimple",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["*updated*", "star", "wildcard", "bullet point", "5", "emergency"],
    codepoint: 59442,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "at",
    pascal_name: "At",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["@", "address", "email", "at symbol", "commercial at", "arobase"],
    codepoint: 57516,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "atom",
    pascal_name: "Atom",
    categories: [e.DEVELOPMENT, e.NATURE],
    figma_category: a.WEATHER,
    tags: [
      "atomic",
      "nucleus",
      "nuclear",
      "reactor",
      "science",
      "physics",
      "electron",
      "automation",
      "react"
    ],
    codepoint: 58852,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "avocado",
    pascal_name: "Avocado",
    categories: [e.COMMERCE, e.NATURE],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "food",
      "vegetable",
      "veggie",
      "fruit",
      "groceries",
      "market"
    ],
    codepoint: 60932,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "axe",
    pascal_name: "Axe",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "tools", "carpentry", "forestry", "construction"],
    codepoint: 59900,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "baby",
    pascal_name: "Baby",
    categories: [e.PEOPLE, e.HEALTH],
    figma_category: a.PEOPLE,
    tags: ["infant", "child", "children", "toddler"],
    codepoint: 59252,
    published_in: 1.3,
    updated_in: 1.4
  },
  {
    name: "baby-carriage",
    pascal_name: "BabyCarriage",
    categories: [e.COMMERCE, e.PEOPLE],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "pram",
      "stroller",
      "infant",
      "child",
      "children",
      "toddler"
    ],
    codepoint: 59416,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "backpack",
    pascal_name: "Backpack",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["knapsack", "camping", "school", "bag"],
    codepoint: 59682,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "backspace",
    pascal_name: "Backspace",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["keyboard", "remove", "delete"],
    codepoint: 57518,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bag",
    pascal_name: "Bag",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["suitcase", "valise", "baggage", "folders", "portfolio"],
    codepoint: 57520,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bag-simple",
    pascal_name: "BagSimple",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["suitcase", "valise", "baggage", "folders", "portfolio"],
    codepoint: 58854,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "balloon",
    pascal_name: "Balloon",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["helium", "birthday", "party"],
    codepoint: 59244,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "bandaids",
    pascal_name: "Bandaids",
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: ["bandages", "medical", "medicine", "first aid", "injury"],
    codepoint: 57522,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bank",
    pascal_name: "Bank",
    categories: [e.FINANCE, e.MAP],
    figma_category: a.FINANCE,
    tags: [
      "banking",
      "checking",
      "money",
      "savings",
      "deposit",
      "withdraw",
      "places",
      "locations"
    ],
    codepoint: 57524,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "barbell",
    pascal_name: "Barbell",
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: [
      "gym",
      "weights",
      "dumbbells",
      "strength training",
      "workout",
      "exercises",
      "fitness"
    ],
    codepoint: 57526,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "barcode",
    pascal_name: "Barcode",
    categories: [e.COMMERCE, e.SYSTEM],
    figma_category: a.COMMERCE,
    tags: ["upc", "qr", "products", "shopping", "scanner"],
    codepoint: 57528,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "barn",
    pascal_name: "Barn",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "animals",
      "livestock",
      "buildings",
      "farming",
      "agriculture"
    ],
    codepoint: 60530,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "barricade",
    pascal_name: "Barricade",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["construction", "safety", "gate"],
    codepoint: 59720,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "baseball",
    pascal_name: "Baseball",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["sports", "mlb"],
    codepoint: 59162,
    published_in: 1.3,
    updated_in: 1.4
  },
  {
    name: "baseball-cap",
    pascal_name: "BaseballCap",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["clothes", "clothing", "sports", "hat"],
    codepoint: 59944,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "baseball-helmet",
    pascal_name: "BaseballHelmet",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "mlb"],
    codepoint: 61002,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "basket",
    pascal_name: "Basket",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "ecommerce",
      "market",
      "cart",
      "buying",
      "shopping",
      "groceries",
      "checkout",
      "places",
      "locations"
    ],
    codepoint: 59748,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "basketball",
    pascal_name: "Basketball",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["sports", "nba"],
    codepoint: 59172,
    published_in: 1.3,
    updated_in: 1.4
  },
  {
    name: "bathtub",
    pascal_name: "Bathtub",
    categories: [e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["bath", "shower", "bathroom", "faucet"],
    codepoint: 59422,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "battery-charging",
    pascal_name: "BatteryCharging",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power"],
    codepoint: 57530,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "battery-charging-vertical",
    pascal_name: "BatteryChargingVertical",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power"],
    codepoint: 57532,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "battery-empty",
    pascal_name: "BatteryEmpty",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power", "dead"],
    codepoint: 57534,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "battery-full",
    pascal_name: "BatteryFull",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power", "filled"],
    codepoint: 57536,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "battery-high",
    pascal_name: "BatteryHigh",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power"],
    codepoint: 57538,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "battery-low",
    pascal_name: "BatteryLow",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power"],
    codepoint: 57540,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "battery-medium",
    pascal_name: "BatteryMedium",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power"],
    codepoint: 57542,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "battery-plus",
    pascal_name: "BatteryPlus",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power"],
    codepoint: 59400,
    published_in: 1.4,
    updated_in: 2
  },
  {
    name: "battery-plus-vertical",
    pascal_name: "BatteryPlusVertical",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power"],
    codepoint: 60496,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "battery-vertical-empty",
    pascal_name: "BatteryVerticalEmpty",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power", "dead"],
    codepoint: 59334,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "battery-vertical-full",
    pascal_name: "BatteryVerticalFull",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power"],
    codepoint: 59332,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "battery-vertical-high",
    pascal_name: "BatteryVerticalHigh",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power"],
    codepoint: 59330,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "battery-vertical-low",
    pascal_name: "BatteryVerticalLow",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power"],
    codepoint: 59326,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "battery-vertical-medium",
    pascal_name: "BatteryVerticalMedium",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power"],
    codepoint: 59328,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "battery-warning",
    pascal_name: "BatteryWarning",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power", "empty", "critical"],
    codepoint: 57544,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "battery-warning-vertical",
    pascal_name: "BatteryWarningVertical",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["charged", "charger", "charging", "power", "empty", "critical"],
    codepoint: 57546,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "beach-ball",
    pascal_name: "BeachBall",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "ocean", "party"],
    codepoint: 60708,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "beanie",
    pascal_name: "Beanie",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "clothes", "clothing", "sports", "hat", "winter"],
    codepoint: 59946,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "bed",
    pascal_name: "Bed",
    categories: [e.HEALTH, e.MAP, e.OBJECTS],
    figma_category: a.HEALTH,
    tags: [
      "hotels",
      "accommodations",
      "sleeping",
      "places",
      "locations",
      "medical",
      "hospital"
    ],
    codepoint: 57548,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "beer-bottle",
    pascal_name: "BeerBottle",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "drinks",
      "beverages",
      "places",
      "locations",
      "bars",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 59312,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "beer-stein",
    pascal_name: "BeerStein",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "drinks",
      "beverages",
      "places",
      "locations",
      "bars",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 60258,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "behance-logo",
    pascal_name: "BehanceLogo",
    categories: [e.BRAND, e.DESIGN],
    figma_category: a.BRAND,
    tags: ["logos", "illustration", "ui", "interface"],
    codepoint: 59380,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "bell",
    pascal_name: "Bell",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: [
      "alarm",
      "notifications",
      "times",
      "timer",
      "clock",
      "schedule",
      "events",
      "ringer",
      "calls"
    ],
    codepoint: 57550,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bell-ringing",
    pascal_name: "BellRinging",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "alarm",
      "notifications",
      "times",
      "timer",
      "clock",
      "schedule",
      "events",
      "ringer",
      "calls"
    ],
    codepoint: 58856,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "bell-simple",
    pascal_name: "BellSimple",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: [
      "alarm",
      "notifications",
      "times",
      "timer",
      "clock",
      "schedule",
      "events",
      "ringer",
      "calls"
    ],
    codepoint: 57552,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bell-simple-ringing",
    pascal_name: "BellSimpleRinging",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "alarm",
      "notifications",
      "times",
      "timer",
      "clock",
      "schedule",
      "events",
      "ringer",
      "calls"
    ],
    codepoint: 58858,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "bell-simple-slash",
    pascal_name: "BellSimpleSlash",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "alarm",
      "notifications",
      "times",
      "timer",
      "clock",
      "schedule",
      "events",
      "ringer",
      "silent",
      "silenced",
      "disabled"
    ],
    codepoint: 57554,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bell-simple-z",
    pascal_name: "BellSimpleZ",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "alarm",
      "notifications",
      "times",
      "timer",
      "clock",
      "schedule",
      "events",
      "ringer",
      "snooze"
    ],
    codepoint: 58860,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "bell-slash",
    pascal_name: "BellSlash",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "alarm",
      "notifications",
      "times",
      "timer",
      "clock",
      "schedule",
      "events",
      "silent",
      "silenced",
      "ringer",
      "calls",
      "disabled"
    ],
    codepoint: 57556,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bell-z",
    pascal_name: "BellZ",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "alarm",
      "notifications",
      "times",
      "timer",
      "clock",
      "schedule",
      "events",
      "ringer",
      "snooze"
    ],
    codepoint: 58862,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "belt",
    pascal_name: "Belt",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "clothes", "clothing"],
    codepoint: 59948,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "bezier-curve",
    pascal_name: "BezierCurve",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["shapes", "drawing", "path", "pen", "vector"],
    codepoint: 60160,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "bicycle",
    pascal_name: "Bicycle",
    categories: [e.HEALTH, e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "bikers",
      "bicycling",
      "cyclists",
      "transit",
      "transportation",
      "commuter",
      "exercises",
      "fitness"
    ],
    codepoint: 57558,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "binary",
    pascal_name: "Binary",
    categories: [e.DEVELOPMENT, e.SYSTEM],
    figma_category: a.DEVELOPMENT,
    tags: ["*new*", "digital", "0", "1", "programming", "coding", "executable"],
    codepoint: 61024,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "binoculars",
    pascal_name: "Binoculars",
    categories: [e.NATURE, e.OBJECTS, e.MAP],
    figma_category: a.COMMERCE,
    tags: ["telescope", "glasses", "search", "find", "explore"],
    codepoint: 60004,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "biohazard",
    pascal_name: "Biohazard",
    categories: [e.HEALTH],
    figma_category: a.SECURITY,
    tags: [
      "*new*",
      "contamination",
      "quarantine",
      "toxic",
      "poison",
      "danger",
      "caution"
    ],
    codepoint: 59872,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "bird",
    pascal_name: "Bird",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["*updated*", "animals", "pets"],
    codepoint: 59180,
    published_in: 1.3,
    updated_in: 2.1
  },
  {
    name: "blueprint",
    pascal_name: "Blueprint",
    categories: [e.COMMERCE, e.DESIGN],
    figma_category: a.DESIGN,
    tags: [
      "*new*",
      "architecture",
      "layout",
      "floorplan",
      "building",
      "construction"
    ],
    codepoint: 60832,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "bluetooth",
    pascal_name: "Bluetooth",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["wireless", "connection", "connected", "connectivity"],
    codepoint: 57562,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bluetooth-connected",
    pascal_name: "BluetoothConnected",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["wireless", "connection", "connected", "connectivity"],
    codepoint: 57564,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bluetooth-slash",
    pascal_name: "BluetoothSlash",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "wireless",
      "connection",
      "connectivity",
      "disconnected",
      "disabled"
    ],
    codepoint: 57566,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bluetooth-x",
    pascal_name: "BluetoothX",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["wireless", "connection", "connectivity", "disconnected", "errors"],
    codepoint: 57568,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "boat",
    pascal_name: "Boat",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "ferry",
      "ship",
      "cruise",
      "vehicles",
      "public transit",
      "transportation",
      "commuter",
      "traveling",
      "sailing",
      "places",
      "locations"
    ],
    codepoint: 59270,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "bomb",
    pascal_name: "Bomb",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "gaming", "grenade", "explosive", "war", "weapon", "fuse"],
    codepoint: 60938,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "bone",
    pascal_name: "Bone",
    categories: [e.NATURE, e.HEALTH],
    figma_category: a.WEATHER,
    tags: ["dogbone"],
    codepoint: 59378,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "book",
    pascal_name: "Book",
    categories: [e.OFFICE, e.MEDIA, e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: ["reading", "reader", "novel", "story", "library"],
    codepoint: 57570,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "book-bookmark",
    pascal_name: "BookBookmark",
    categories: [e.OFFICE, e.MEDIA, e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: [
      "reading",
      "reader",
      "novel",
      "story",
      "library",
      "favorites",
      "favorited"
    ],
    codepoint: 57572,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "book-open",
    pascal_name: "BookOpen",
    categories: [e.OFFICE, e.MEDIA, e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: ["*updated*", "reading", "reader", "novel", "story", "library"],
    codepoint: 57574,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "book-open-text",
    pascal_name: "BookOpenText",
    categories: [
      e.OFFICE,
      e.MEDIA,
      e.OBJECTS,
      e.MAP
    ],
    figma_category: a.EDUCATION,
    tags: ["*updated*", "reading", "reader", "novel", "story", "library"],
    codepoint: 59634,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "book-open-user",
    pascal_name: "BookOpenUser",
    categories: [e.OFFICE, e.MEDIA, e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: [
      "*new*",
      "reading",
      "reader",
      "easy read",
      "library",
      "places",
      "locations"
    ],
    codepoint: 60896,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "bookmark",
    pascal_name: "Bookmark",
    categories: [e.OFFICE, e.MEDIA, e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: [
      "reading",
      "reader",
      "novel",
      "story",
      "placeholder",
      "favorites",
      "favorited",
      "library"
    ],
    codepoint: 57576,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bookmark-simple",
    pascal_name: "BookmarkSimple",
    categories: [e.OFFICE, e.MEDIA, e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: [
      "reading",
      "reader",
      "novel",
      "story",
      "placeholder",
      "favorites",
      "favorited",
      "library"
    ],
    codepoint: 57578,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bookmarks",
    pascal_name: "Bookmarks",
    categories: [e.OFFICE, e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: [
      "reading",
      "reader",
      "novel",
      "story",
      "placeholder",
      "favorites",
      "favorited",
      "library"
    ],
    codepoint: 57580,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bookmarks-simple",
    pascal_name: "BookmarksSimple",
    categories: [e.OFFICE, e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: [
      "reading",
      "reader",
      "novel",
      "story",
      "placeholder",
      "favorites",
      "favorited",
      "library"
    ],
    codepoint: 58864,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "books",
    pascal_name: "Books",
    categories: [
      e.OFFICE,
      e.MAP,
      e.MEDIA,
      e.OBJECTS
    ],
    figma_category: a.EDUCATION,
    tags: ["reading", "reader", "bookshelf", "library", "places", "locations"],
    codepoint: 59224,
    published_in: 1.3,
    updated_in: 2
  },
  {
    name: "boot",
    pascal_name: "Boot",
    categories: [
      e.COMMERCE,
      e.OBJECTS,
      e.HEALTH
    ],
    figma_category: a.COMMERCE,
    tags: ["hiking", "shoes", "sports", "exercise"],
    codepoint: 60618,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "boules",
    pascal_name: "Boules",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: [
      "*new*",
      "balls",
      "sports",
      "pétanque",
      "raffa",
      "bocce",
      "boule lyonnaise",
      "lawn bowls"
    ],
    codepoint: 59170,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "bounding-box",
    pascal_name: "BoundingBox",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["polygon", "shapes", "outline", "corners", "rectangle"],
    codepoint: 59086,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "bowl-food",
    pascal_name: "BowlFood",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "ramen",
      "food",
      "meal",
      "eating",
      "restaurants",
      "dining",
      "locations"
    ],
    codepoint: 60068,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "bowl-steam",
    pascal_name: "BowlSteam",
    categories: [e.COMMERCE, e.OBJECTS, e.MAP],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "food",
      "meal",
      "eating",
      "restaurants",
      "dining",
      "locations"
    ],
    codepoint: 59620,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "bowling-ball",
    pascal_name: "BowlingBall",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "alley"],
    codepoint: 59956,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "box-arrow-down",
    pascal_name: "BoxArrowDown",
    alias: { name: "archive-box", pascal_name: "ArchiveBox" },
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "downloaded",
      "downloading"
    ],
    codepoint: 57358,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "box-arrow-up",
    pascal_name: "BoxArrowUp",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["*new*", "unarchive", "archival", "upload"],
    codepoint: 61012,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "boxing-glove",
    pascal_name: "BoxingGlove",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "combat", "martial arts", "fight", "gym"],
    codepoint: 59958,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "brackets-angle",
    pascal_name: "BracketsAngle",
    categories: [e.DEVELOPMENT, e.EDITOR],
    figma_category: a.DEVELOPMENT,
    tags: ["code", "angle brackets", "angle braces"],
    codepoint: 59490,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "brackets-curly",
    pascal_name: "BracketsCurly",
    categories: [e.DEVELOPMENT, e.EDITOR],
    figma_category: a.DEVELOPMENT,
    tags: ["code", "curly brackets", "curly braces"],
    codepoint: 59488,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "brackets-round",
    pascal_name: "BracketsRound",
    categories: [e.DEVELOPMENT, e.EDITOR],
    figma_category: a.DEVELOPMENT,
    tags: ["code", "parentheses", "round brackets", "round braces"],
    codepoint: 59492,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "brackets-square",
    pascal_name: "BracketsSquare",
    categories: [e.DEVELOPMENT, e.EDITOR],
    figma_category: a.DEVELOPMENT,
    tags: ["code", "square brackets", "square braces", "array"],
    codepoint: 59486,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "brain",
    pascal_name: "Brain",
    categories: [e.HEALTH, e.NATURE],
    figma_category: a.HEALTH,
    tags: ["mind", "mental"],
    codepoint: 59214,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "brandy",
    pascal_name: "Brandy",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "drinks",
      "beverages",
      "whiskey",
      "cocktail",
      "places",
      "locations",
      "bars",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 59060,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "bread",
    pascal_name: "Bread",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "food",
      "meal",
      "bakery",
      "sandwich",
      "gluten",
      "loaf",
      "toast",
      "slice"
    ],
    codepoint: 59420,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "bridge",
    pascal_name: "Bridge",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["travel", "transportation", "infrastucture"],
    codepoint: 60008,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "briefcase",
    pascal_name: "Briefcase",
    categories: [e.OFFICE, e.OBJECTS],
    figma_category: a.OFFICE,
    tags: ["suitcase", "valise", "baggage", "folders", "portfolio"],
    codepoint: 57582,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "briefcase-metal",
    pascal_name: "BriefcaseMetal",
    categories: [e.OFFICE, e.OBJECTS],
    figma_category: a.OFFICE,
    tags: ["suitcase", "valise", "baggage", "folders", "portfolio"],
    codepoint: 58866,
    published_in: 1.2,
    updated_in: 1.4
  },
  {
    name: "broadcast",
    pascal_name: "Broadcast",
    categories: [
      e.COMMUNICATION,
      e.MEDIA,
      e.SYSTEM
    ],
    figma_category: a.COMMUNICATION,
    tags: ["radio", "hotspot", "wifi", "emit"],
    codepoint: 57586,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "broom",
    pascal_name: "Broom",
    categories: [e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["sweeping", "cleaning"],
    codepoint: 60500,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "browser",
    pascal_name: "Browser",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "web browsers",
      "windows",
      "internet",
      "website",
      "webpage",
      "chrome",
      "edge",
      "firefox"
    ],
    codepoint: 57588,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "browsers",
    pascal_name: "Browsers",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "web browsers",
      "windows",
      "internet",
      "website",
      "webpage",
      "chrome",
      "edge",
      "firefox"
    ],
    codepoint: 57590,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "bug",
    pascal_name: "Bug",
    categories: [e.DEVELOPMENT, e.NATURE],
    figma_category: a.DEVELOPMENT,
    tags: ["debug", "errors", "insect", "ladybug"],
    codepoint: 58868,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "bug-beetle",
    pascal_name: "BugBeetle",
    categories: [e.DEVELOPMENT, e.NATURE],
    figma_category: a.DEVELOPMENT,
    tags: ["debug", "errors", "insect", "ladybug"],
    codepoint: 58870,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "bug-droid",
    pascal_name: "BugDroid",
    categories: [e.DEVELOPMENT, e.NATURE],
    figma_category: a.DEVELOPMENT,
    tags: ["debug", "errors", "insect", "android", "google"],
    codepoint: 58872,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "building",
    pascal_name: "Building",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: ["*new*", "places", "locations", "company", "business", "buildings"],
    codepoint: 57600,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "building-apartment",
    pascal_name: "BuildingApartment",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: ["*new*", "places", "locations", "buildings"],
    codepoint: 57598,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "building-office",
    pascal_name: "BuildingOffice",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: ["*new*", "places", "locations", "company", "business", "buildings"],
    codepoint: 57598,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "buildings",
    pascal_name: "Buildings",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: ["places", "locations", "company", "business"],
    codepoint: 57602,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "bulldozer",
    pascal_name: "Bulldozer",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "vehicles", "construction", "earth mover", "dig", "digger"],
    codepoint: 60524,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "bus",
    pascal_name: "Bus",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "vehicles",
      "automobile",
      "public transit",
      "transportation",
      "commuter",
      "traveling",
      "places",
      "locations"
    ],
    codepoint: 57606,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "butterfly",
    pascal_name: "Butterfly",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["animals", "insects", "moth"],
    codepoint: 60014,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "cable-car",
    pascal_name: "CableCar",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "vehicles",
      "gondola",
      "skiing",
      "mountains",
      "public transit",
      "transportation",
      "commuter",
      "traveling",
      "places",
      "locations"
    ],
    codepoint: 58524,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "cactus",
    pascal_name: "Cactus",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["*updated*", "plants", "cacti", "desert", "western"],
    codepoint: 59672,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "cake",
    pascal_name: "Cake",
    categories: [e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["dessert", "birthday", "celebration", "event"],
    codepoint: 59264,
    published_in: 1.3,
    updated_in: 2
  },
  {
    name: "calculator",
    pascal_name: "Calculator",
    categories: [
      e.DEVELOPMENT,
      e.FINANCE,
      e.OFFICE,
      e.OBJECTS
    ],
    figma_category: a.FINANCE,
    tags: [
      "addition",
      "sum",
      "subtraction",
      "difference",
      "multiply",
      "multiplication",
      "product",
      "divide",
      "division",
      "divisor",
      "dividend",
      "quotient",
      "equals",
      "equality",
      "mathematics",
      "arithmetic",
      "+",
      "-",
      "±",
      "×",
      "÷",
      "="
    ],
    codepoint: 58680,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "calendar",
    pascal_name: "Calendar",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.TIME,
    tags: ["dates", "times", "events", "schedule", "12"],
    codepoint: 57608,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "calendar-blank",
    pascal_name: "CalendarBlank",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.TIME,
    tags: ["dates", "times", "events", "schedule", "none"],
    codepoint: 57610,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "calendar-check",
    pascal_name: "CalendarCheck",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.TIME,
    tags: ["dates", "times", "events", "schedule", "todo", "checklist"],
    codepoint: 59154,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "calendar-dot",
    pascal_name: "CalendarDot",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.TIME,
    tags: ["*new*", "dates", "times", "events", "schedule", "today"],
    codepoint: 59314,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "calendar-dots",
    pascal_name: "CalendarDots",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.TIME,
    tags: ["*new*", "dates", "times", "events", "schedule"],
    codepoint: 59316,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "calendar-heart",
    pascal_name: "CalendarHeart",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.TIME,
    tags: ["*new*", "dates", "times", "events", "schedule", "favorite", "star"],
    codepoint: 59568,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "calendar-minus",
    pascal_name: "CalendarMinus",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.TIME,
    tags: ["*new*", "dates", "times", "events", "schedule", "remove", "delete"],
    codepoint: 59924,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "calendar-plus",
    pascal_name: "CalendarPlus",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.TIME,
    tags: ["dates", "times", "events", "schedule", "add"],
    codepoint: 59156,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "calendar-slash",
    pascal_name: "CalendarSlash",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.TIME,
    tags: [
      "*new*",
      "dates",
      "times",
      "events",
      "schedule",
      "remove",
      "delete",
      "cancel. unavailable"
    ],
    codepoint: 59922,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "calendar-star",
    pascal_name: "CalendarStar",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.TIME,
    tags: ["*new*", "dates", "times", "events", "schedule", "favorite", "star"],
    codepoint: 59570,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "calendar-x",
    pascal_name: "CalendarX",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.TIME,
    tags: ["dates", "times", "events", "schedule", "closed", "cancelled"],
    codepoint: 57612,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "call-bell",
    pascal_name: "CallBell",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["service bell", "reception", "attendant", "concierge bell"],
    codepoint: 59358,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "camera",
    pascal_name: "Camera",
    categories: [e.MEDIA, e.SYSTEM, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["photography", "pictures", "lens"],
    codepoint: 57614,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "camera-plus",
    pascal_name: "CameraPlus",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["photography", "pictures", "album", "add"],
    codepoint: 60504,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "camera-rotate",
    pascal_name: "CameraRotate",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "photography",
      "pictures",
      "orientation",
      "portrait",
      "landscape",
      "selfie",
      "flip"
    ],
    codepoint: 59300,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "camera-slash",
    pascal_name: "CameraSlash",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["photography", "pictures", "lens", "disabled"],
    codepoint: 57616,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "campfire",
    pascal_name: "Campfire",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["camping", "flame", "bonfire", "outdoors"],
    codepoint: 59864,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "car",
    pascal_name: "Car",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "*updated*",
      "cars",
      "vehicles",
      "automobile",
      "transit",
      "transportation",
      "traveling"
    ],
    codepoint: 57618,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "car-battery",
    pascal_name: "CarBattery",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "charged",
      "charger",
      "charging",
      "power",
      "voltage",
      "electricity"
    ],
    codepoint: 60976,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "car-profile",
    pascal_name: "CarProfile",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "cars",
      "vehicles",
      "automobile",
      "transit",
      "transportation",
      "traveling"
    ],
    codepoint: 59596,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "car-simple",
    pascal_name: "CarSimple",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "cars",
      "vehicles",
      "automobile",
      "transit",
      "transportation",
      "traveling"
    ],
    codepoint: 57620,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "cardholder",
    pascal_name: "Cardholder",
    categories: [
      e.COMMERCE,
      e.FINANCE,
      e.OBJECTS
    ],
    figma_category: a.COMMERCE,
    tags: ["wallet", "money", "payment", "paying", "purchase"],
    codepoint: 58874,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "cards",
    pascal_name: "Cards",
    categories: [e.DESIGN, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "card",
      "slides",
      "slideshow",
      "windows",
      "website",
      "webpage",
      "layers"
    ],
    codepoint: 57592,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "cards-three",
    pascal_name: "CardsThree",
    categories: [e.DESIGN, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "*new*",
      "card",
      "slides",
      "slideshow",
      "windows",
      "website",
      "webpage",
      "layers",
      "stack"
    ],
    codepoint: 61008,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "caret-circle-double-down",
    pascal_name: "CaretCircleDoubleDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57622,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-circle-double-left",
    pascal_name: "CaretCircleDoubleLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57624,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-circle-double-right",
    pascal_name: "CaretCircleDoubleRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57626,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-circle-double-up",
    pascal_name: "CaretCircleDoubleUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57628,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-circle-down",
    pascal_name: "CaretCircleDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57630,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-circle-left",
    pascal_name: "CaretCircleLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57632,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-circle-right",
    pascal_name: "CaretCircleRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57634,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-circle-up",
    pascal_name: "CaretCircleUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57636,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-circle-up-down",
    pascal_name: "CaretCircleUpDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57662,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "caret-double-down",
    pascal_name: "CaretDoubleDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57638,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-double-left",
    pascal_name: "CaretDoubleLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57640,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-double-right",
    pascal_name: "CaretDoubleRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57642,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-double-up",
    pascal_name: "CaretDoubleUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57644,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-down",
    pascal_name: "CaretDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57654,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-left",
    pascal_name: "CaretLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57656,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-line-down",
    pascal_name: "CaretLineDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*new*",
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57652,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "caret-line-left",
    pascal_name: "CaretLineLeft",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*new*",
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57650,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "caret-line-right",
    pascal_name: "CaretLineRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*new*",
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57648,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "caret-line-up",
    pascal_name: "CaretLineUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "*new*",
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57646,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "caret-right",
    pascal_name: "CaretRight",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57658,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-up",
    pascal_name: "CaretUp",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57660,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "caret-up-down",
    pascal_name: "CaretUpDown",
    categories: [e.ARROWS],
    figma_category: a.ARROWS,
    tags: [
      "chevron",
      "directional",
      "pointer",
      "pointing",
      "arrowhead",
      "triangle"
    ],
    codepoint: 57664,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "carrot",
    pascal_name: "Carrot",
    categories: [e.COMMERCE, e.NATURE],
    figma_category: a.COMMERCE,
    tags: ["food", "vegetable", "veggie", "groceries", "market"],
    codepoint: 60728,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "cash-register",
    pascal_name: "CashRegister",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "retail",
      "point-of-sale",
      "pos",
      "transaction",
      "sales",
      "till"
    ],
    codepoint: 60800,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "cassette-tape",
    pascal_name: "CassetteTape",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["recording", "audio", "album", "music"],
    codepoint: 60718,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "castle-turret",
    pascal_name: "CastleTurret",
    categories: [e.MAP, e.OBJECTS, e.GAMES],
    figma_category: a.GAMES,
    tags: ["*updated*", "chess", "rook"],
    codepoint: 59856,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "cat",
    pascal_name: "Cat",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["pets", "animals", "kitty", "kitten"],
    codepoint: 59208,
    published_in: 1.3,
    updated_in: 1.4
  },
  {
    name: "cell-signal-full",
    pascal_name: "CellSignalFull",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "wireless",
      "cellular",
      "phone",
      "mobile",
      "network",
      "connection",
      "connectivity",
      "reception",
      "service"
    ],
    codepoint: 57666,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "cell-signal-high",
    pascal_name: "CellSignalHigh",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "wireless",
      "cellular",
      "phone",
      "mobile",
      "network",
      "connection",
      "connectivity",
      "reception",
      "service"
    ],
    codepoint: 57668,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "cell-signal-low",
    pascal_name: "CellSignalLow",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "wireless",
      "cellular",
      "phone",
      "mobile",
      "network",
      "connection",
      "connectivity",
      "reception",
      "service"
    ],
    codepoint: 57670,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "cell-signal-medium",
    pascal_name: "CellSignalMedium",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "wireless",
      "cellular",
      "phone",
      "mobile",
      "network",
      "connection",
      "connectivity",
      "reception",
      "service"
    ],
    codepoint: 57672,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "cell-signal-none",
    pascal_name: "CellSignalNone",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "wireless",
      "cellular",
      "phone",
      "mobile",
      "network",
      "connection",
      "connectivity",
      "reception",
      "service"
    ],
    codepoint: 57674,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "cell-signal-slash",
    pascal_name: "CellSignalSlash",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "wireless",
      "cellular",
      "phone",
      "mobile",
      "network",
      "connection",
      "connectivity",
      "disconnected",
      "disabled",
      "reception",
      "service"
    ],
    codepoint: 57676,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "cell-signal-x",
    pascal_name: "CellSignalX",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "wireless",
      "cellular",
      "phone",
      "mobile",
      "network",
      "connection",
      "connectivity",
      "reception",
      "disconnected",
      "errors",
      "service"
    ],
    codepoint: 57678,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "cell-tower",
    pascal_name: "CellTower",
    categories: [e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: [
      "*new*",
      "wireless",
      "cellular",
      "broadcast",
      "phone",
      "mobile",
      "network",
      "connection",
      "connectivity"
    ],
    codepoint: 60330,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "certificate",
    pascal_name: "Certificate",
    categories: [e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: ["*updated*", "awards", "certification", "degree", "diploma"],
    codepoint: 59238,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "chair",
    pascal_name: "Chair",
    categories: [e.OBJECTS, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["seat", "furniture"],
    codepoint: 59728,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "chalkboard",
    pascal_name: "Chalkboard",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: [
      "blackboard",
      "whiteboard",
      "classroom",
      "teacher",
      "education",
      "school",
      "college",
      "university"
    ],
    codepoint: 58876,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "chalkboard-simple",
    pascal_name: "ChalkboardSimple",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: [
      "*updated*",
      "blackboard",
      "whiteboard",
      "classroom",
      "teacher",
      "education",
      "school",
      "college",
      "university"
    ],
    codepoint: 58878,
    published_in: 1.2,
    updated_in: 2.1
  },
  {
    name: "chalkboard-teacher",
    pascal_name: "ChalkboardTeacher",
    categories: [e.MAP, e.OBJECTS, e.PEOPLE],
    figma_category: a.EDUCATION,
    tags: [
      "blackboard",
      "whiteboard",
      "classroom",
      "education",
      "school",
      "college",
      "university"
    ],
    codepoint: 58880,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "champagne",
    pascal_name: "Champagne",
    categories: [e.MAP, e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "glass",
      "drinks",
      "beverages",
      "wine",
      "places",
      "locations",
      "bars",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 60106,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "charging-station",
    pascal_name: "ChargingStation",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["ev", "charge", "fuel", "pump"],
    codepoint: 59600,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "chart-bar",
    pascal_name: "ChartBar",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "histogram",
      "analyze",
      "analysis"
    ],
    codepoint: 57680,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chart-bar-horizontal",
    pascal_name: "ChartBarHorizontal",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "histogram",
      "analyze",
      "analysis"
    ],
    codepoint: 57682,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chart-donut",
    pascal_name: "ChartDonut",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "circle"
    ],
    codepoint: 60070,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "chart-line",
    pascal_name: "ChartLine",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "stocks"
    ],
    codepoint: 57684,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chart-line-down",
    pascal_name: "ChartLineDown",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: [
      "*updated*",
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "stocks"
    ],
    codepoint: 59574,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "chart-line-up",
    pascal_name: "ChartLineUp",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: [
      "*updated*",
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "stocks"
    ],
    codepoint: 57686,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "chart-pie",
    pascal_name: "ChartPie",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "circle",
      "analyze",
      "analysis"
    ],
    codepoint: 57688,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chart-pie-slice",
    pascal_name: "ChartPieSlice",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: [
      "*updated*",
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "circle",
      "analyze",
      "analysis"
    ],
    codepoint: 57690,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "chart-polar",
    pascal_name: "ChartPolar",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "circle"
    ],
    codepoint: 60072,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "chart-scatter",
    pascal_name: "ChartScatter",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: ["graphs", "graphing", "charts", "statistics", "analyze", "analysis"],
    codepoint: 60076,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "chat",
    pascal_name: "Chat",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "square",
      "bubble"
    ],
    codepoint: 57692,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chat-centered",
    pascal_name: "ChatCentered",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "square",
      "bubble"
    ],
    codepoint: 57696,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chat-centered-dots",
    pascal_name: "ChatCenteredDots",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "square",
      "bubble"
    ],
    codepoint: 57700,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chat-centered-slash",
    pascal_name: "ChatCenteredSlash",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "*new*",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "square",
      "bubble"
    ],
    codepoint: 57698,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "chat-centered-text",
    pascal_name: "ChatCenteredText",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "square",
      "bubble"
    ],
    codepoint: 57702,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chat-circle",
    pascal_name: "ChatCircle",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "round",
      "bubble"
    ],
    codepoint: 57704,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chat-circle-dots",
    pascal_name: "ChatCircleDots",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "round",
      "bubble"
    ],
    codepoint: 57708,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chat-circle-slash",
    pascal_name: "ChatCircleSlash",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "*new*",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "round",
      "bubble"
    ],
    codepoint: 57706,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "chat-circle-text",
    pascal_name: "ChatCircleText",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "round",
      "bubble"
    ],
    codepoint: 57710,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chat-dots",
    pascal_name: "ChatDots",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "square",
      "bubble"
    ],
    codepoint: 57712,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chat-slash",
    pascal_name: "ChatSlash",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "*new*",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "square",
      "bubble"
    ],
    codepoint: 57694,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "chat-teardrop",
    pascal_name: "ChatTeardrop",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "bubble"
    ],
    codepoint: 57714,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chat-teardrop-dots",
    pascal_name: "ChatTeardropDots",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "bubble"
    ],
    codepoint: 57718,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chat-teardrop-slash",
    pascal_name: "ChatTeardropSlash",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "*new*",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "bubble"
    ],
    codepoint: 57716,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "chat-teardrop-text",
    pascal_name: "ChatTeardropText",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "bubble"
    ],
    codepoint: 57720,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chat-text",
    pascal_name: "ChatText",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "square",
      "bubble"
    ],
    codepoint: 57722,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chats",
    pascal_name: "Chats",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "square",
      "bubble"
    ],
    codepoint: 57724,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chats-circle",
    pascal_name: "ChatsCircle",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "round",
      "bubble"
    ],
    codepoint: 57726,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "chats-teardrop",
    pascal_name: "ChatsTeardrop",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "send",
      "sent",
      "messages",
      "messaging",
      "sms",
      "texting",
      "comment",
      "bubble"
    ],
    codepoint: 57728,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "check",
    pascal_name: "Check",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["todo", "to-do", "task", "list", "checkbox", "ok", "done"],
    codepoint: 57730,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "check-circle",
    pascal_name: "CheckCircle",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["todo", "to-do", "task", "list", "checkbox", "round", "ok", "done"],
    codepoint: 57732,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "check-fat",
    pascal_name: "CheckFat",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["todo", "to-do", "task", "list", "checkbox", "ok", "done"],
    codepoint: 60326,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "check-square",
    pascal_name: "CheckSquare",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "todo",
      "to-do",
      "task",
      "list",
      "checkbox",
      "rectangle",
      "ok",
      "done"
    ],
    codepoint: 57734,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "check-square-offset",
    pascal_name: "CheckSquareOffset",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "*updated*",
      "todo",
      "to-do",
      "task",
      "list",
      "checkbox",
      "rectangle",
      "ok",
      "done"
    ],
    codepoint: 57736,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "checkerboard",
    pascal_name: "Checkerboard",
    categories: [e.GAMES],
    figma_category: a.GAMES,
    tags: ["*new*", "crossword"],
    codepoint: 59588,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "checks",
    pascal_name: "Checks",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "*updated*",
      "todo",
      "task",
      "to-do",
      "list",
      "checkbox",
      "ok",
      "done"
    ],
    codepoint: 58682,
    published_in: 1.1,
    updated_in: 2.1
  },
  {
    name: "cheers",
    pascal_name: "Cheers",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "glass",
      "drinks",
      "beverages",
      "champagne",
      "toast",
      "places",
      "locations",
      "bars",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 59978,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "cheese",
    pascal_name: "Cheese",
    categories: [e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["*new*", "dairy", "wedge", "food", "dining"],
    codepoint: 59902,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "chef-hat",
    pascal_name: "ChefHat",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "cooking", "cuisine", "kitchen", "clothes", "clothing"],
    codepoint: 60814,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "cherries",
    pascal_name: "Cherries",
    categories: [e.NATURE, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["*new*", "food", "fruit", "cherry", "groceries", "market"],
    codepoint: 59440,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "church",
    pascal_name: "Church",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["christ", "christianity", "cathedral", "religion", "worship"],
    codepoint: 60650,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "cigarette",
    pascal_name: "Cigarette",
    categories: [e.COMMERCE, e.HEALTH],
    figma_category: a.COMMERCE,
    tags: ["*new*", "smoking", "tobacco"],
    codepoint: 60816,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "cigarette-slash",
    pascal_name: "CigaretteSlash",
    categories: [e.COMMERCE, e.HEALTH],
    figma_category: a.COMMERCE,
    tags: ["*new*", "non-smoking", "tobacco"],
    codepoint: 60818,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "circle",
    pascal_name: "Circle",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["round", "shapes", "polygons"],
    codepoint: 57738,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "circle-dashed",
    pascal_name: "CircleDashed",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["missing", "round", "shapes", "polygons"],
    codepoint: 58882,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "circle-half",
    pascal_name: "CircleHalf",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["round", "shapes", "contrast", "brightness"],
    codepoint: 57740,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "circle-half-tilt",
    pascal_name: "CircleHalfTilt",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["round", "shapes", "contrast", "brightness"],
    codepoint: 57742,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "circle-notch",
    pascal_name: "CircleNotch",
    categories: [e.SYSTEM],
    figma_category: a.DESIGN,
    tags: [
      "round",
      "shapes",
      "loading",
      "loader",
      "spinner",
      "waiting",
      "progress"
    ],
    codepoint: 60228,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "circles-four",
    pascal_name: "CirclesFour",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["round", "shapes", "polygons", "4"],
    codepoint: 57744,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "circles-three",
    pascal_name: "CirclesThree",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["round", "shapes", "polygons", "3", "asana"],
    codepoint: 57746,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "circles-three-plus",
    pascal_name: "CirclesThreePlus",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["round", "shapes", "polygons", "3", "+"],
    codepoint: 57748,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "circuitry",
    pascal_name: "Circuitry",
    categories: [e.DEVELOPMENT],
    figma_category: a.SYSTEM,
    tags: [
      "processor",
      "microchip",
      "computer",
      "circuit",
      "electronics",
      "motherboard"
    ],
    codepoint: 59842,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "city",
    pascal_name: "City",
    categories: [e.MAP, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "skyline",
      "skyscrapers",
      "places",
      "locations",
      "buildings"
    ],
    codepoint: 60010,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "clipboard",
    pascal_name: "Clipboard",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["copy", "copied", "checklist"],
    codepoint: 57750,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "clipboard-text",
    pascal_name: "ClipboardText",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["copy", "copied", "checklist"],
    codepoint: 57752,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "clock",
    pascal_name: "Clock",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.TIME,
    tags: ["times", "timer", "alarm", "schedule", "events", "watch"],
    codepoint: 57754,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "clock-afternoon",
    pascal_name: "ClockAfternoon",
    categories: [e.SYSTEM],
    figma_category: a.TIME,
    tags: ["times", "timer", "alarm", "schedule", "events", "watch"],
    codepoint: 57756,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "clock-clockwise",
    pascal_name: "ClockClockwise",
    categories: [e.SYSTEM],
    figma_category: a.TIME,
    tags: [
      "times",
      "timer",
      "alarm",
      "schedule",
      "events",
      "restore",
      "fast forward",
      "update"
    ],
    codepoint: 57758,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "clock-countdown",
    pascal_name: "ClockCountdown",
    categories: [e.SYSTEM],
    figma_category: a.TIME,
    tags: ["times", "timer", "alarm", "schedule", "events", "watch"],
    codepoint: 60716,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "clock-counter-clockwise",
    pascal_name: "ClockCounterClockwise",
    categories: [e.SYSTEM],
    figma_category: a.TIME,
    tags: [
      "times",
      "timer",
      "alarm",
      "schedule",
      "events",
      "backup",
      "rewind",
      "history"
    ],
    codepoint: 57760,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "clock-user",
    pascal_name: "ClockUser",
    categories: [e.SYSTEM],
    figma_category: a.TIME,
    tags: ["*new*", "times", "timer", "shift", "schedule", "events", "watch"],
    codepoint: 60908,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "closed-captioning",
    pascal_name: "ClosedCaptioning",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: [
      "subtitles",
      "television",
      "tv",
      "transcribed",
      "transcription",
      "accessibility",
      "a11y"
    ],
    codepoint: 57764,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "cloud",
    pascal_name: "Cloud",
    categories: [e.SYSTEM, e.WEATHER],
    figma_category: a.WEATHER,
    tags: [
      "serverless",
      "backup",
      "storage",
      "meteorology",
      "cloudy",
      "overcast"
    ],
    codepoint: 57770,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "cloud-arrow-down",
    pascal_name: "CloudArrowDown",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["serverless", "backup", "storage", "download"],
    codepoint: 57772,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "cloud-arrow-up",
    pascal_name: "CloudArrowUp",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["serverless", "backup", "storage", "upload"],
    codepoint: 57774,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "cloud-check",
    pascal_name: "CloudCheck",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["serverless", "backup", "storage", "sync", "synchronized"],
    codepoint: 57776,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "cloud-fog",
    pascal_name: "CloudFog",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["meteorology", "cloudy", "overcast", "foggy", "mist", "haze"],
    codepoint: 58684,
    published_in: 1.1,
    updated_in: 1.4
  },
  {
    name: "cloud-lightning",
    pascal_name: "CloudLightning",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["meteorology", "cloudy", "overcast", "stormy", "thunderstorm"],
    codepoint: 57778,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "cloud-moon",
    pascal_name: "CloudMoon",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["meteorology", "cloudy", "partly cloudy", "night", "evening"],
    codepoint: 58686,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "cloud-rain",
    pascal_name: "CloudRain",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["meteorology", "cloudy", "rainy", "raining", "stormy", "rainstorm"],
    codepoint: 57780,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "cloud-slash",
    pascal_name: "CloudSlash",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["serverless", "backup", "storage", "sync", "disabled"],
    codepoint: 57782,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "cloud-snow",
    pascal_name: "CloudSnow",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["meteorology", "cloudy", "snowy", "snowing", "stormy", "snowstorm"],
    codepoint: 57784,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "cloud-sun",
    pascal_name: "CloudSun",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["meteorology", "cloudy", "partly cloudy", "partly sunny"],
    codepoint: 58688,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "cloud-warning",
    pascal_name: "CloudWarning",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["serverless", "backup", "storage", "errors"],
    codepoint: 60056,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "cloud-x",
    pascal_name: "CloudX",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["serverless", "backup", "storage", "errors"],
    codepoint: 60054,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "clover",
    pascal_name: "Clover",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["*new*", "four leaf clover", "plants", "luck", "lucky", "irish"],
    codepoint: 60872,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "club",
    pascal_name: "Club",
    categories: [e.GAMES],
    figma_category: a.GAMES,
    tags: ["clubs", "suits", "cards", "gambling", "casino", "gaming"],
    codepoint: 57786,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "coat-hanger",
    pascal_name: "CoatHanger",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["clothing", "clothes", "closet"],
    codepoint: 59390,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "coda-logo",
    pascal_name: "CodaLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: [
      "project management",
      "productivity",
      "documentation",
      "wiki",
      "logos"
    ],
    codepoint: 59342,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "code",
    pascal_name: "Code",
    categories: [e.DEVELOPMENT, e.EDITOR],
    figma_category: a.DEVELOPMENT,
    tags: ["angle brackets", "angle braces", "snippets"],
    codepoint: 57788,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "code-block",
    pascal_name: "CodeBlock",
    categories: [e.DEVELOPMENT, e.EDITOR],
    figma_category: a.DEVELOPMENT,
    tags: ["angle brackets", "angle braces", "snippets"],
    codepoint: 60158,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "code-simple",
    pascal_name: "CodeSimple",
    categories: [e.DEVELOPMENT, e.EDITOR],
    figma_category: a.DEVELOPMENT,
    tags: ["angle brackets", "angle braces", "snippets"],
    codepoint: 57790,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "codepen-logo",
    pascal_name: "CodepenLogo",
    categories: [e.BRAND, e.DEVELOPMENT],
    figma_category: a.BRAND,
    tags: ["ide", "logos"],
    codepoint: 59768,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "codesandbox-logo",
    pascal_name: "CodesandboxLogo",
    categories: [e.BRAND, e.DEVELOPMENT],
    figma_category: a.BRAND,
    tags: ["ide", "logos"],
    codepoint: 59910,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "coffee",
    pascal_name: "Coffee",
    categories: [e.COMMERCE, e.OBJECTS, e.MAP],
    figma_category: a.COMMERCE,
    tags: [
      "tea",
      "java",
      "beverages",
      "drinks",
      "cafe",
      "cup",
      "mug",
      "espresso",
      "cappuccino",
      "latte",
      "places",
      "locations",
      "bars",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 57794,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "coffee-bean",
    pascal_name: "CoffeeBean",
    categories: [e.COMMERCE, e.MAP, e.NATURE],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "tea",
      "java",
      "beverages",
      "drinks",
      "cafe",
      "cup",
      "mug",
      "espresso",
      "cappuccino",
      "latte",
      "places",
      "locations",
      "bars",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 57792,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "coin",
    pascal_name: "Coin",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: [
      "coins",
      "cents",
      "change",
      "money",
      "currency",
      "payment",
      "paying",
      "purchase",
      "price",
      "sell"
    ],
    codepoint: 58894,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "coin-vertical",
    pascal_name: "CoinVertical",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: [
      "cents",
      "change",
      "money",
      "currency",
      "payment",
      "paying",
      "purchase",
      "price",
      "sell"
    ],
    codepoint: 60232,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "coins",
    pascal_name: "Coins",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: [
      "cents",
      "change",
      "money",
      "currency",
      "payment",
      "paying",
      "purchase",
      "price",
      "sell"
    ],
    codepoint: 59278,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "columns",
    pascal_name: "Columns",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["2", "shapes", "polygons", "box", "stack", "list", "table", "cards"],
    codepoint: 58694,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "columns-plus-left",
    pascal_name: "ColumnsPlusLeft",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: [
      "*new*",
      "2",
      "shapes",
      "polygons",
      "box",
      "stack",
      "list",
      "table",
      "cards",
      "prepend",
      "insert"
    ],
    codepoint: 58692,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "columns-plus-right",
    pascal_name: "ColumnsPlusRight",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: [
      "*new*",
      "2",
      "shapes",
      "polygons",
      "box",
      "stack",
      "list",
      "table",
      "cards",
      "append",
      "insert"
    ],
    codepoint: 58690,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "command",
    pascal_name: "Command",
    categories: [e.EDITOR, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "apple",
      "keyboard",
      "shortcut",
      "modifier",
      "looped square",
      "bowen knot",
      "saint john's arms"
    ],
    codepoint: 57796,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "compass",
    pascal_name: "Compass",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["navigation", "directions", "maps", "safari", "apple"],
    codepoint: 57800,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "compass-rose",
    pascal_name: "CompassRose",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "navigation",
      "directions",
      "maps",
      "cardinal",
      "cartography"
    ],
    codepoint: 57798,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "compass-tool",
    pascal_name: "CompassTool",
    categories: [e.DESIGN, e.OBJECTS],
    figma_category: a.DESIGN,
    tags: [
      "drawing",
      "geometry",
      "trigonometry",
      "degrees",
      "radians",
      "measurement",
      "protractor",
      "compass",
      "arc"
    ],
    codepoint: 59918,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "computer-tower",
    pascal_name: "ComputerTower",
    categories: [e.DEVELOPMENT, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["desktop", "pc", "imac"],
    codepoint: 58696,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "confetti",
    pascal_name: "Confetti",
    categories: [e.COMMUNICATION],
    figma_category: a.GAMES,
    tags: ["tada", "party", "emoji"],
    codepoint: 59418,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "contactless-payment",
    pascal_name: "ContactlessPayment",
    categories: [e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["purchase", "credit card", "nfc"],
    codepoint: 60738,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "control",
    pascal_name: "Control",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["ctrl", "key", "keyboard", "shortcut", "caret"],
    codepoint: 60582,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "cookie",
    pascal_name: "Cookie",
    categories: [
      e.MAP,
      e.OBJECTS,
      e.DEVELOPMENT
    ],
    figma_category: a.COMMERCE,
    tags: ["privacy", "dessert", "food", "dining"],
    codepoint: 59082,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "cooking-pot",
    pascal_name: "CookingPot",
    categories: [e.OBJECTS, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["stew", "kitchen", "steaming", "restaurants", "food", "dining"],
    codepoint: 59236,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "copy",
    pascal_name: "Copy",
    categories: [e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["duplicated", "copied", "clipboard"],
    codepoint: 57802,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "copy-simple",
    pascal_name: "CopySimple",
    categories: [e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["duplicated", "copied", "clipboard"],
    codepoint: 57804,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "copyleft",
    pascal_name: "Copyleft",
    categories: [e.COMMERCE, e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["🄯", "intellectual property", "copr.", "symbol"],
    codepoint: 59498,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "copyright",
    pascal_name: "Copyright",
    categories: [e.COMMERCE, e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["©", "intellectual property", "copr.", "symbol"],
    codepoint: 58698,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "corners-in",
    pascal_name: "CornersIn",
    categories: [e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["*updated*", "collapse", "windowed", "minimized"],
    codepoint: 57806,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "corners-out",
    pascal_name: "CornersOut",
    categories: [e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["*updated*", "expand", "fullscreen", "maximized"],
    codepoint: 57808,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "couch",
    pascal_name: "Couch",
    categories: [e.OBJECTS, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["furniture", "seat"],
    codepoint: 59382,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "court-basketball",
    pascal_name: "CourtBasketball",
    categories: [e.GAMES, e.HEALTH, e.MAP],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "nba"],
    codepoint: 60982,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "cow",
    pascal_name: "Cow",
    categories: [e.COMMERCE, e.NATURE],
    figma_category: a.WEATHER,
    tags: ["*new*", "animals", "livestock", "beef", "bull", "milk", "dairy"],
    codepoint: 60094,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "cowboy-hat",
    pascal_name: "CowboyHat",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "clothes", "clothing", "stetson"],
    codepoint: 60690,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "cpu",
    pascal_name: "Cpu",
    categories: [e.DEVELOPMENT],
    figma_category: a.DEVELOPMENT,
    tags: ["processor", "microchip", "computer", "circuit"],
    codepoint: 58896,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "crane",
    pascal_name: "Crane",
    categories: [e.COMMERCE, e.DEVELOPMENT],
    figma_category: a.COMMERCE,
    tags: ["*new*", "construction", "industry"],
    codepoint: 60744,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "crane-tower",
    pascal_name: "CraneTower",
    categories: [e.COMMERCE, e.DEVELOPMENT],
    figma_category: a.COMMERCE,
    tags: ["*new*", "construction", "industry"],
    codepoint: 60744,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "credit-card",
    pascal_name: "CreditCard",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: [
      "debit",
      "visa",
      "mastercard",
      "money",
      "payment",
      "paying",
      "purchase",
      "swipe"
    ],
    codepoint: 57810,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "cricket",
    pascal_name: "Cricket",
    categories: [e.GAMES, e.HEALTH],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "ball", "bat"],
    codepoint: 60946,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "crop",
    pascal_name: "Crop",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["photography", "clip", "screenshots"],
    codepoint: 57812,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "cross",
    pascal_name: "Cross",
    categories: [e.DESIGN, e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "dagger",
      "crucifix",
      "christ",
      "christianity",
      "religion",
      "worship",
      "symbol"
    ],
    codepoint: 59552,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "crosshair",
    pascal_name: "Crosshair",
    categories: [e.MAP, e.SYSTEM],
    figma_category: a.MAP,
    tags: ["geolocation", "gps", "aiming", "targeting"],
    codepoint: 57814,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "crosshair-simple",
    pascal_name: "CrosshairSimple",
    categories: [e.MAP, e.SYSTEM],
    figma_category: a.MAP,
    tags: ["geolocation", "gps", "aiming", "targeting"],
    codepoint: 57816,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "crown",
    pascal_name: "Crown",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: [
      "*updated*",
      "king",
      "queen",
      "royalty",
      "monarch",
      "ruler",
      "leader",
      "chess"
    ],
    codepoint: 58900,
    published_in: 1.2,
    updated_in: 2.1
  },
  {
    name: "crown-cross",
    pascal_name: "CrownCross",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: [
      "*new*",
      "king",
      "queen",
      "royalty",
      "monarch",
      "ruler",
      "leader",
      "chess"
    ],
    codepoint: 61022,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "crown-simple",
    pascal_name: "CrownSimple",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: [
      "*updated*",
      "king",
      "queen",
      "royalty",
      "monarch",
      "ruler",
      "leader",
      "chess"
    ],
    codepoint: 58902,
    published_in: 1.2,
    updated_in: 2.1
  },
  {
    name: "cube",
    pascal_name: "Cube",
    categories: [e.DESIGN, e.GAMES, e.OBJECTS],
    figma_category: a.DESIGN,
    tags: ["square", "box", "3d", "volume", "blocks"],
    codepoint: 57818,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "cube-focus",
    pascal_name: "CubeFocus",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["augmented reality", "ar", "virual reality", "vr", "3d", "scan"],
    codepoint: 60682,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "cube-transparent",
    pascal_name: "CubeTransparent",
    categories: [e.DESIGN, e.GAMES, e.OBJECTS],
    figma_category: a.DESIGN,
    tags: ["square", "box", "3d", "volume", "blocks", "necker"],
    codepoint: 60540,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "currency-btc",
    pascal_name: "CurrencyBtc",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: [
      "money",
      "btc",
      "bitcoin",
      "crypto",
      "cryptocurrency",
      "payment",
      "paying",
      "purchase"
    ],
    codepoint: 58904,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "currency-circle-dollar",
    pascal_name: "CurrencyCircleDollar",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "usd", "payment", "paying", "purchase"],
    codepoint: 58700,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "currency-cny",
    pascal_name: "CurrencyCny",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "yuan", "payment", "paying", "purchase"],
    codepoint: 58702,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "currency-dollar",
    pascal_name: "CurrencyDollar",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "usd", "payment", "paying", "purchase"],
    codepoint: 58704,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "currency-dollar-simple",
    pascal_name: "CurrencyDollarSimple",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "usd", "payment", "paying", "purchase"],
    codepoint: 58706,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "currency-eth",
    pascal_name: "CurrencyEth",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: [
      "money",
      "ethereum",
      "crypto",
      "cryptocurrency",
      "payment",
      "paying",
      "purchase"
    ],
    codepoint: 60122,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "currency-eur",
    pascal_name: "CurrencyEur",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "euros", "payment", "paying", "purchase"],
    codepoint: 58708,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "currency-gbp",
    pascal_name: "CurrencyGbp",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "pounds sterling", "payment", "paying", "purchase"],
    codepoint: 58710,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "currency-inr",
    pascal_name: "CurrencyInr",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "rupees", "payment", "paying", "purchase"],
    codepoint: 58712,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "currency-jpy",
    pascal_name: "CurrencyJpy",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "yen", "payment", "paying", "purchase"],
    codepoint: 58714,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "currency-krw",
    pascal_name: "CurrencyKrw",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "won", "payment", "paying", "purchase"],
    codepoint: 58716,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "currency-kzt",
    pascal_name: "CurrencyKzt",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "kazakhstan", "tenge", "payment", "paying", "purchase"],
    codepoint: 60492,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "currency-ngn",
    pascal_name: "CurrencyNgn",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "nigeria", "naira", "payment", "paying", "purchase"],
    codepoint: 60242,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "currency-rub",
    pascal_name: "CurrencyRub",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["money", "rubles", "payment", "paying", "purchase"],
    codepoint: 58718,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "cursor",
    pascal_name: "Cursor",
    categories: [e.DESIGN, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["pointer", "arrowhead", "mouse", "click"],
    codepoint: 57820,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "cursor-click",
    pascal_name: "CursorClick",
    categories: [e.DESIGN, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["pointer", "arrowhead", "mouse"],
    codepoint: 59336,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "cursor-text",
    pascal_name: "CursorText",
    categories: [e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["i-beam", "input", "select"],
    codepoint: 59352,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "cylinder",
    pascal_name: "Cylinder",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["shapes", "tube"],
    codepoint: 59644,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "database",
    pascal_name: "Database",
    categories: [e.DEVELOPMENT, e.SYSTEM],
    figma_category: a.DEVELOPMENT,
    tags: [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "hard disk",
      "storage",
      "hdd",
      "servers",
      "databases"
    ],
    codepoint: 57822,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "desk",
    pascal_name: "Desk",
    categories: [
      e.COMMERCE,
      e.OBJECTS,
      e.OFFICE
    ],
    figma_category: a.COMMERCE,
    tags: ["*new*", "furniture", "workspace", "table"],
    codepoint: 60694,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "desktop",
    pascal_name: "Desktop",
    categories: [e.DEVELOPMENT, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["computer", "pc", "imac", "tower"],
    codepoint: 58720,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "desktop-tower",
    pascal_name: "DesktopTower",
    categories: [e.DEVELOPMENT, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["*updated*", "computer", "pc", "imac"],
    codepoint: 58722,
    published_in: 1.1,
    updated_in: 2.1
  },
  {
    name: "detective",
    pascal_name: "Detective",
    categories: [e.PEOPLE, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: ["incognito", "police", "law enforcement", "spy", "secret"],
    codepoint: 59454,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "dev-to-logo",
    pascal_name: "DevToLogo",
    categories: [e.BRAND, e.DEVELOPMENT],
    figma_category: a.BRAND,
    tags: ["reading", "writing", "social media", "logos"],
    codepoint: 60686,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "device-mobile",
    pascal_name: "DeviceMobile",
    categories: [e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["cellphone", "cellular"],
    codepoint: 57824,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "device-mobile-camera",
    pascal_name: "DeviceMobileCamera",
    categories: [e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["cellphone", "cellular"],
    codepoint: 57826,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "device-mobile-slash",
    pascal_name: "DeviceMobileSlash",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "cellphone", "cellular"],
    codepoint: 60998,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "device-mobile-speaker",
    pascal_name: "DeviceMobileSpeaker",
    categories: [e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["cellphone", "cellular"],
    codepoint: 57828,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "device-rotate",
    pascal_name: "DeviceRotate",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "orientation", "landscape", "portrait", "spin", "flip"],
    codepoint: 60914,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "device-tablet",
    pascal_name: "DeviceTablet",
    categories: [e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["cellphone", "cellular", "ipad", "phablet"],
    codepoint: 57830,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "device-tablet-camera",
    pascal_name: "DeviceTabletCamera",
    categories: [e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["cellphone", "cellular", "ipad", "phablet"],
    codepoint: 57832,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "device-tablet-speaker",
    pascal_name: "DeviceTabletSpeaker",
    categories: [e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["cellphone", "cellular", "ipad", "phablet"],
    codepoint: 57834,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "devices",
    pascal_name: "Devices",
    categories: [e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["responsive", "cellphone", "cellular", "tablet", "destop"],
    codepoint: 60324,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "diamond",
    pascal_name: "Diamond",
    categories: [e.DESIGN, e.GAMES],
    figma_category: a.GAMES,
    tags: [
      "rectangle",
      "shapes",
      "polygons",
      "diamonds",
      "suits",
      "cards",
      "gambling",
      "casino",
      "gaming"
    ],
    codepoint: 57836,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "diamonds-four",
    pascal_name: "DiamondsFour",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["shapes", "grid", "component"],
    codepoint: 59636,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "dice-five",
    pascal_name: "DiceFive",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["die", "rolling", "gamble", "gambling", "casino", "gaming", "5"],
    codepoint: 57838,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dice-four",
    pascal_name: "DiceFour",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["die", "rolling", "gamble", "gambling", "casino", "gaming", "4"],
    codepoint: 57840,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dice-one",
    pascal_name: "DiceOne",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["die", "rolling", "gamble", "gambling", "casino", "gaming", "1"],
    codepoint: 57842,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dice-six",
    pascal_name: "DiceSix",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["die", "rolling", "gamble", "gambling", "casino", "gaming", "6"],
    codepoint: 57844,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dice-three",
    pascal_name: "DiceThree",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["die", "rolling", "gamble", "gambling", "casino", "gaming", "3"],
    codepoint: 57846,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dice-two",
    pascal_name: "DiceTwo",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["die", "rolling", "gamble", "gambling", "casino", "gaming", "2"],
    codepoint: 57848,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "disc",
    pascal_name: "Disc",
    categories: [
      e.DEVELOPMENT,
      e.MEDIA,
      e.OBJECTS
    ],
    figma_category: a.MEDIA,
    tags: ["cd-rom", "compact disk", "album", "record"],
    codepoint: 58724,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "disco-ball",
    pascal_name: "DiscoBall",
    categories: [e.GAMES, e.MAP, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "danging", "club", "70s"],
    codepoint: 60824,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "discord-logo",
    pascal_name: "DiscordLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "messages", "messaging", "chat"],
    codepoint: 58906,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "divide",
    pascal_name: "Divide",
    categories: [e.DEVELOPMENT, e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "division",
      "divisor",
      "dividend",
      "quotient",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 57850,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dna",
    pascal_name: "Dna",
    categories: [e.HEALTH, e.NATURE],
    figma_category: a.HEALTH,
    tags: ["double helix", "gene", "genetics"],
    codepoint: 59684,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "dog",
    pascal_name: "Dog",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["pets", "animals", "puppy"],
    codepoint: 59210,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "door",
    pascal_name: "Door",
    categories: [e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["entrance", "exit"],
    codepoint: 58908,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "door-open",
    pascal_name: "DoorOpen",
    categories: [e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["entrance", "exit"],
    codepoint: 59366,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "dot",
    pascal_name: "Dot",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["dots", "circles", "shapes", "polygons"],
    codepoint: 60638,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "dot-outline",
    pascal_name: "DotOutline",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["dots", "circles", "shapes", "polygons"],
    codepoint: 60640,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "dots-nine",
    pascal_name: "DotsNine",
    categories: [e.DESIGN],
    figma_category: a.SYSTEM,
    tags: ["grid", "circles", "shapes", "polygons", "9"],
    codepoint: 57852,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dots-six",
    pascal_name: "DotsSix",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "*updated*",
      "drag handle",
      "knurling",
      "circles",
      "shapes",
      "polygons",
      "6"
    ],
    codepoint: 59284,
    published_in: 1.3,
    updated_in: 2.1
  },
  {
    name: "dots-six-vertical",
    pascal_name: "DotsSixVertical",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "*updated*",
      "drag handle",
      "knurling",
      "circles",
      "shapes",
      "polygons",
      "6"
    ],
    codepoint: 60130,
    published_in: 1.3,
    updated_in: 2.1
  },
  {
    name: "dots-three",
    pascal_name: "DotsThree",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "menu",
      "overflow",
      "circles",
      "shapes",
      "polygons",
      "3",
      "ellipsis",
      "ellipses",
      "more"
    ],
    codepoint: 57854,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dots-three-circle",
    pascal_name: "DotsThreeCircle",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "menu",
      "overflow",
      "circles",
      "shapes",
      "polygons",
      "3",
      "ellipsis",
      "ellipses",
      "more"
    ],
    codepoint: 57856,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dots-three-circle-vertical",
    pascal_name: "DotsThreeCircleVertical",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "menu",
      "overflow",
      "circles",
      "shapes",
      "polygons",
      "3",
      "ellipsis",
      "ellipses",
      "more"
    ],
    codepoint: 57858,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dots-three-outline",
    pascal_name: "DotsThreeOutline",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "menu",
      "overflow",
      "circles",
      "shapes",
      "polygons",
      "3",
      "ellipsis",
      "ellipses",
      "more"
    ],
    codepoint: 57860,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dots-three-outline-vertical",
    pascal_name: "DotsThreeOutlineVertical",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "menu",
      "overflow",
      "circles",
      "shapes",
      "polygons",
      "3",
      "ellipsis",
      "ellipses",
      "more"
    ],
    codepoint: 57862,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "dots-three-vertical",
    pascal_name: "DotsThreeVertical",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "menu",
      "overflow",
      "circles",
      "shapes",
      "polygons",
      "3",
      "ellipsis",
      "ellipses",
      "more"
    ],
    codepoint: 57864,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "download",
    pascal_name: "Download",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "downloaded",
      "downloading",
      "hard drive",
      "disk"
    ],
    codepoint: 57866,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "download-simple",
    pascal_name: "DownloadSimple",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "*updated*",
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "downloaded",
      "downloading",
      "hard drive",
      "disk",
      "import"
    ],
    codepoint: 57868,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "dress",
    pascal_name: "Dress",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["clothes", "clothing"],
    codepoint: 60030,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "dresser",
    pascal_name: "Dresser",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "furniture", "bedroom", "storage", "drawers", "wardrobe"],
    codepoint: 59726,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "dribbble-logo",
    pascal_name: "DribbbleLogo",
    categories: [e.BRAND, e.DESIGN],
    figma_category: a.BRAND,
    tags: ["logos", "round", "basketball", "sports", "design"],
    codepoint: 57870,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "drone",
    pascal_name: "Drone",
    categories: [
      e.GAMES,
      e.OBJECTS,
      e.DEVELOPMENT
    ],
    figma_category: a.GAMES,
    tags: ["*new*", "aerial", "uav", "photography", "remote"],
    codepoint: 60788,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "drop",
    pascal_name: "Drop",
    categories: [e.NATURE, e.WEATHER],
    figma_category: a.WEATHER,
    tags: [
      "droplet",
      "teardrop",
      "raindrop",
      "raining",
      "meteorology",
      "water",
      "blur"
    ],
    codepoint: 57872,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "drop-half",
    pascal_name: "DropHalf",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.NATURE,
      e.WEATHER
    ],
    figma_category: a.DESIGN,
    tags: [
      "droplet",
      "teardrop",
      "raindrop",
      "humidity",
      "water",
      "contrast",
      "brightness"
    ],
    codepoint: 58726,
    published_in: 1.1,
    updated_in: 1.4
  },
  {
    name: "drop-half-bottom",
    pascal_name: "DropHalfBottom",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.NATURE,
      e.WEATHER
    ],
    figma_category: a.DESIGN,
    tags: [
      "droplet",
      "teardrop",
      "raindrop",
      "humidity",
      "water",
      "contrast",
      "brightness"
    ],
    codepoint: 60224,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "drop-simple",
    pascal_name: "DropSimple",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.NATURE,
      e.WEATHER
    ],
    figma_category: a.WEATHER,
    tags: [
      "*new*",
      "droplet",
      "teardrop",
      "raindrop",
      "raining",
      "humidity",
      "meteorology",
      "water",
      "blur"
    ],
    codepoint: 60978,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "drop-slash",
    pascal_name: "DropSlash",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.NATURE,
      e.WEATHER
    ],
    figma_category: a.DESIGN,
    tags: [
      "*new*",
      "droplet",
      "teardrop",
      "raindrop",
      "raining",
      "humidity",
      "meteorology",
      "water",
      "blur",
      "disabled"
    ],
    codepoint: 59732,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "dropbox-logo",
    pascal_name: "DropboxLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["cloud", "storage", "backup", "logos"],
    codepoint: 59344,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "ear",
    pascal_name: "Ear",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["hearing", "audio", "sound"],
    codepoint: 59148,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "ear-slash",
    pascal_name: "EarSlash",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["hearing", "audio", "sound", "mute", "accessible"],
    codepoint: 59150,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "egg",
    pascal_name: "Egg",
    categories: [e.COMMERCE, e.NATURE],
    figma_category: a.COMMERCE,
    tags: ["chicken", "food", "meal", "baby", "hatch"],
    codepoint: 59410,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "egg-crack",
    pascal_name: "EggCrack",
    categories: [e.COMMERCE, e.NATURE],
    figma_category: a.COMMERCE,
    tags: ["chicken", "food", "meal", "baby", "hatch", "break"],
    codepoint: 60260,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "eject",
    pascal_name: "Eject",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["disconnect"],
    codepoint: 57874,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "eject-simple",
    pascal_name: "EjectSimple",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["disconnect"],
    codepoint: 59054,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "elevator",
    pascal_name: "Elevator",
    categories: [e.OBJECTS, e.MAP],
    figma_category: a.MAP,
    tags: ["lift"],
    codepoint: 60608,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "empty",
    pascal_name: "Empty",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "∅",
      "empty set",
      "member",
      "mathematics",
      "arithmetic",
      "calculator",
      "null"
    ],
    codepoint: 60860,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "engine",
    pascal_name: "Engine",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["*updated*", "motor", "repair", "vehicles", "automobile"],
    codepoint: 60032,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "envelope",
    pascal_name: "Envelope",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["mail", "email", "send", "sent", "message", "post", "letter"],
    codepoint: 57876,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "envelope-open",
    pascal_name: "EnvelopeOpen",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "mail",
      "email",
      "send",
      "sent",
      "message",
      "read",
      "post",
      "letter"
    ],
    codepoint: 57878,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "envelope-simple",
    pascal_name: "EnvelopeSimple",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["mail", "email", "send", "sent", "message", "post", "letter"],
    codepoint: 57880,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "envelope-simple-open",
    pascal_name: "EnvelopeSimpleOpen",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "mail",
      "email",
      "send",
      "sent",
      "message",
      "read",
      "post",
      "letter"
    ],
    codepoint: 57882,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "equalizer",
    pascal_name: "Equalizer",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "meter", "volume", "spectrum", "eq", "deezer"],
    codepoint: 60348,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "equals",
    pascal_name: "Equals",
    categories: [e.DEVELOPMENT, e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "=",
      "equality",
      "equivalent",
      "equivalence",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 57884,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "eraser",
    pascal_name: "Eraser",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["write", "writing", "editing", "undo", "deleted"],
    codepoint: 57886,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "escalator-down",
    pascal_name: "EscalatorDown",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["stairs"],
    codepoint: 60602,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "escalator-up",
    pascal_name: "EscalatorUp",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["stairs"],
    codepoint: 60604,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "exam",
    pascal_name: "Exam",
    categories: [e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: ["text", "examination", "paper", "school", "grade"],
    codepoint: 59202,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "exclamation-mark",
    pascal_name: "ExclamationMark",
    categories: [e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "*new*",
      "!",
      "alert",
      "warning",
      "caution",
      "interjection",
      "punctuation",
      "symbol"
    ],
    codepoint: 60996,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "exclude",
    pascal_name: "Exclude",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["venn-diagram", "difference", "intersection"],
    codepoint: 59522,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "exclude-square",
    pascal_name: "ExcludeSquare",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["venn-diagram", "difference", "intersection"],
    codepoint: 59520,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "export",
    pascal_name: "Export",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["share", "send to", "arrows"],
    codepoint: 60144,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "eye",
    pascal_name: "Eye",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["visible", "hidden", "show", "hide", "visibility", "view"],
    codepoint: 57888,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "eye-closed",
    pascal_name: "EyeClosed",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: [
      "visible",
      "hidden",
      "show",
      "hide",
      "visibility",
      "view",
      "invisible",
      "private"
    ],
    codepoint: 57890,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "eye-slash",
    pascal_name: "EyeSlash",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: [
      "visible",
      "hidden",
      "show",
      "hide",
      "visibility",
      "view",
      "invisible",
      "eyelashes",
      "disabled",
      "private"
    ],
    codepoint: 57892,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "eyedropper",
    pascal_name: "Eyedropper",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.OBJECTS
    ],
    figma_category: a.DESIGN,
    tags: ["colors", "color picker", "sample", "arts"],
    codepoint: 58728,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "eyedropper-sample",
    pascal_name: "EyedropperSample",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.OBJECTS
    ],
    figma_category: a.DESIGN,
    tags: ["colors", "color picker", "arts"],
    codepoint: 60100,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "eyeglasses",
    pascal_name: "Eyeglasses",
    categories: [e.HEALTH, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["vision", "spectacles"],
    codepoint: 59322,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "eyes",
    pascal_name: "Eyes",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["*new*", "look", "glance"],
    codepoint: 61020,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "face-mask",
    pascal_name: "FaceMask",
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: ["ppe", "facemask", "covid-19", "coronavirus", "flu", "cold"],
    codepoint: 58730,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "facebook-logo",
    pascal_name: "FacebookLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "social media"],
    codepoint: 57894,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "factory",
    pascal_name: "Factory",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: ["industry", "manufacture", "buildings", "places", "locations"],
    codepoint: 59232,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "faders",
    pascal_name: "Faders",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "music",
      "audio",
      "sliders",
      "filters",
      "equalizer",
      "volume",
      "settings",
      "preferences"
    ],
    codepoint: 57896,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "faders-horizontal",
    pascal_name: "FadersHorizontal",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "music",
      "audio",
      "sliders",
      "filters",
      "equalizer",
      "volume",
      "settings",
      "preferences"
    ],
    codepoint: 57898,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "fallout-shelter",
    pascal_name: "FalloutShelter",
    categories: [e.HEALTH],
    figma_category: a.SECURITY,
    tags: [
      "*new*",
      "radiation",
      "radioactive",
      "nuclear",
      "bunker",
      "contamination",
      "quarantine",
      "toxic",
      "danger",
      "caution"
    ],
    codepoint: 59870,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "fan",
    pascal_name: "Fan",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["desk fan", "air conditioning"],
    codepoint: 59890,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "farm",
    pascal_name: "Farm",
    categories: [e.COMMERCE, e.NATURE, e.MAP],
    figma_category: a.COMMERCE,
    tags: ["*new*", "farmer", "field", "farming", "agriculture"],
    codepoint: 60528,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "fast-forward",
    pascal_name: "FastForward",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["audio", "music", "seek", "scrub", "scan", "ahead", "skip"],
    codepoint: 59046,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "fast-forward-circle",
    pascal_name: "FastForwardCircle",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["audio", "music", "seek", "scrub", "scan", "ahead", "skip"],
    codepoint: 57900,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "feather",
    pascal_name: "Feather",
    categories: [e.NATURE, e.OBJECTS],
    figma_category: a.WEATHER,
    tags: ["bird"],
    codepoint: 59840,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "fediverse-logo",
    pascal_name: "FediverseLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["*new*", "social media", "decentralized"],
    codepoint: 60774,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "figma-logo",
    pascal_name: "FigmaLogo",
    categories: [e.BRAND, e.DESIGN],
    figma_category: a.BRAND,
    tags: [
      "*updated*",
      "logos",
      "drawing",
      "art",
      "illustration",
      "ui",
      "interface",
      "prototype",
      "prototyping"
    ],
    codepoint: 57902,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "file",
    pascal_name: "File",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "files", "save", "write", "page"],
    codepoint: 57904,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "file-archive",
    pascal_name: "FileArchive",
    categories: [e.SYSTEM, e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "zip", "compression"],
    codepoint: 60202,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "file-arrow-down",
    pascal_name: "FileArrowDown",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "documents",
      "files",
      "save",
      "write",
      "download",
      "directional",
      "pointer",
      "pointing",
      "arrowhead"
    ],
    codepoint: 57906,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "file-arrow-up",
    pascal_name: "FileArrowUp",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "documents",
      "files",
      "save",
      "write",
      "upload",
      "directional",
      "pointer",
      "pointing",
      "arrowhead"
    ],
    codepoint: 58910,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "file-audio",
    pascal_name: "FileAudio",
    categories: [e.OFFICE, e.EDITOR, e.MEDIA],
    figma_category: a.OFFICE,
    tags: ["documents", "music", "sound"],
    codepoint: 59936,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-c",
    pascal_name: "FileC",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["*new*", "documents", "code"],
    codepoint: 60210,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "file-c-sharp",
    pascal_name: "FileCSharp",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["*new*", "documents", "code", "c#"],
    codepoint: 60208,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "file-cloud",
    pascal_name: "FileCloud",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["documents", "sync"],
    codepoint: 59742,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-code",
    pascal_name: "FileCode",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["documents"],
    codepoint: 59668,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-cpp",
    pascal_name: "FileCpp",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["*new*", "documents", "code", "c++"],
    codepoint: 60206,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "file-css",
    pascal_name: "FileCss",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["documents", "code"],
    codepoint: 60212,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-csv",
    pascal_name: "FileCsv",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "data"],
    codepoint: 60188,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-dashed",
    pascal_name: "FileDashed",
    alias: { name: "file-dotted", pascal_name: "FileDotted" },
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "files", "browse", "draft", "open", "dotted"],
    codepoint: 59140,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "file-doc",
    pascal_name: "FileDoc",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "word", "microsoft"],
    codepoint: 60190,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-html",
    pascal_name: "FileHtml",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["*updated*", "documents", "code"],
    codepoint: 60216,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "file-image",
    pascal_name: "FileImage",
    categories: [e.OFFICE, e.EDITOR, e.MEDIA],
    figma_category: a.OFFICE,
    tags: ["documents", "pictures", "photograph"],
    codepoint: 59940,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-ini",
    pascal_name: "FileIni",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["*new*", "documents"],
    codepoint: 60210,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "file-jpg",
    pascal_name: "FileJpg",
    categories: [e.OFFICE, e.EDITOR, e.MEDIA],
    figma_category: a.OFFICE,
    tags: ["documents", "pictures", "photograph", "jpeg"],
    codepoint: 60186,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-js",
    pascal_name: "FileJs",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["documents", "code", "javascript"],
    codepoint: 60196,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-jsx",
    pascal_name: "FileJsx",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["documents", "code", "javascript"],
    codepoint: 60218,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-lock",
    pascal_name: "FileLock",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["documents", "secure", "locked", "private"],
    codepoint: 59740,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-magnifying-glass",
    pascal_name: "FileMagnifyingGlass",
    alias: { name: "file-search", pascal_name: "FileSearch" },
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "documents",
      "files",
      "search",
      "find",
      "locate",
      "browse",
      "missing"
    ],
    codepoint: 57912,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "file-md",
    pascal_name: "FileMd",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["*new*", "documents", "notes", "markdown"],
    codepoint: 60752,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "file-minus",
    pascal_name: "FileMinus",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "files", "delete", "write", "remove", "-"],
    codepoint: 57908,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "file-pdf",
    pascal_name: "FilePdf",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "files", "acrobat"],
    codepoint: 59138,
    published_in: 1.3,
    updated_in: 1.4
  },
  {
    name: "file-plus",
    pascal_name: "FilePlus",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "files", "save", "write", "add", "new", "create", "+"],
    codepoint: 57910,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "file-png",
    pascal_name: "FilePng",
    categories: [e.OFFICE, e.EDITOR, e.MEDIA],
    figma_category: a.OFFICE,
    tags: ["documents", "pictures", "photograph"],
    codepoint: 60184,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-ppt",
    pascal_name: "FilePpt",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "powerpoint", "microsoft"],
    codepoint: 60192,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-py",
    pascal_name: "FilePy",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["*new*", "documents", "code", "python"],
    codepoint: 60204,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "file-rs",
    pascal_name: "FileRs",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["documents", "code", "rust"],
    codepoint: 60200,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-sql",
    pascal_name: "FileSql",
    categories: [e.SYSTEM, e.DEVELOPMENT],
    figma_category: a.OFFICE,
    tags: ["documents", "database"],
    codepoint: 60750,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "file-svg",
    pascal_name: "FileSvg",
    categories: [e.SYSTEM, e.MEDIA],
    figma_category: a.OFFICE,
    tags: ["documents", "images", "vector"],
    codepoint: 60680,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "file-text",
    pascal_name: "FileText",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "files", "save", "write"],
    codepoint: 57914,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "file-ts",
    pascal_name: "FileTs",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["documents", "code", "typescript"],
    codepoint: 60198,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-tsx",
    pascal_name: "FileTsx",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["documents", "code", "typescript"],
    codepoint: 60220,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-txt",
    pascal_name: "FileTxt",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["*new*", "documents"],
    codepoint: 60210,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "file-video",
    pascal_name: "FileVideo",
    categories: [e.OFFICE, e.EDITOR, e.MEDIA],
    figma_category: a.OFFICE,
    tags: ["documents", "movie"],
    codepoint: 59938,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-vue",
    pascal_name: "FileVue",
    categories: [
      e.OFFICE,
      e.EDITOR,
      e.DEVELOPMENT
    ],
    figma_category: a.OFFICE,
    tags: ["documents", "code"],
    codepoint: 60222,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-x",
    pascal_name: "FileX",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "files", "cancelled", "deleted", "removed", "errors"],
    codepoint: 57916,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "file-xls",
    pascal_name: "FileXls",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "excel", "microsoft"],
    codepoint: 60194,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "file-zip",
    pascal_name: "FileZip",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["documents", "archive", "compression"],
    codepoint: 59736,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "files",
    pascal_name: "Files",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["documents", "open", "library"],
    codepoint: 59152,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "film-reel",
    pascal_name: "FilmReel",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["videography", "films", "movies", "recording"],
    codepoint: 59584,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "film-script",
    pascal_name: "FilmScript",
    categories: [e.OFFICE, e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["screenplay", "movie"],
    codepoint: 60240,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "film-slate",
    pascal_name: "FilmSlate",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["*updated*", "clapper", "movie"],
    codepoint: 59586,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "film-strip",
    pascal_name: "FilmStrip",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["camera", "photography", "darkroom", "movie", "analog"],
    codepoint: 59282,
    published_in: 1.3,
    updated_in: 1.4
  },
  {
    name: "fingerprint",
    pascal_name: "Fingerprint",
    categories: [e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "security",
      "secured",
      "authentication",
      "authenticated",
      "login",
      "locked",
      "biometrics",
      "encrypted",
      "encryption"
    ],
    codepoint: 57918,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "fingerprint-simple",
    pascal_name: "FingerprintSimple",
    categories: [e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "security",
      "secured",
      "authentication",
      "authenticated",
      "login",
      "locked",
      "biometrics",
      "encrypted",
      "encryption"
    ],
    codepoint: 57920,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "finn-the-human",
    pascal_name: "FinnTheHuman",
    categories: [e.GAMES],
    figma_category: a.GAMES,
    tags: ["adventure time", "cartoons", "television", "tv", "character"],
    codepoint: 58732,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "fire",
    pascal_name: "Fire",
    categories: [e.NATURE, e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["flame", "burning", "match", "lighter"],
    codepoint: 57922,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "fire-extinguisher",
    pascal_name: "FireExtinguisher",
    categories: [e.OBJECTS],
    figma_category: a.SECURITY,
    tags: ["safety", "prevention", "emergency", "hazard", "danger", "caution"],
    codepoint: 59880,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "fire-simple",
    pascal_name: "FireSimple",
    categories: [e.NATURE, e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["flame", "burning", "match", "lighter"],
    codepoint: 58912,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "fire-truck",
    pascal_name: "FireTruck",
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: [
      "*new*",
      "first-aid",
      "emt",
      "medical",
      "medicine",
      "injury",
      "safety",
      "emergency",
      "firefighter"
    ],
    codepoint: 58740,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "first-aid",
    pascal_name: "FirstAid",
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: [
      "hospital",
      "cross",
      "medical",
      "medicine",
      "injury",
      "safety",
      "emergency",
      "doctor"
    ],
    codepoint: 58734,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "first-aid-kit",
    pascal_name: "FirstAidKit",
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: [
      "bandages",
      "medical",
      "medicine",
      "injury",
      "safety",
      "emergency",
      "doctor"
    ],
    codepoint: 58736,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "fish",
    pascal_name: "Fish",
    categories: [e.NATURE, e.COMMERCE],
    figma_category: a.WEATHER,
    tags: ["animals", "pets", "food", "seafood", "restaurants", "dining"],
    codepoint: 59176,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "fish-simple",
    pascal_name: "FishSimple",
    categories: [e.NATURE, e.COMMERCE],
    figma_category: a.WEATHER,
    tags: ["animals", "pets", "food", "seafood", "restaurants", "dining"],
    codepoint: 59178,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "flag",
    pascal_name: "Flag",
    categories: [e.OBJECTS, e.MAP, e.SYSTEM],
    figma_category: a.MAP,
    tags: ["country", "countries", "finished", "completed", "flags"],
    codepoint: 57924,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "flag-banner",
    pascal_name: "FlagBanner",
    categories: [e.OBJECTS, e.MAP, e.SYSTEM],
    figma_category: a.MAP,
    tags: [
      "ribbon",
      "country",
      "countries",
      "finished",
      "completed",
      "flags",
      "swallowtail"
    ],
    codepoint: 58914,
    published_in: 1.2,
    updated_in: 2
  },
  {
    name: "flag-banner-fold",
    pascal_name: "FlagBannerFold",
    categories: [e.OBJECTS, e.MAP, e.SYSTEM],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "ribbon",
      "country",
      "countries",
      "finished",
      "completed",
      "flags",
      "swallowtail"
    ],
    codepoint: 60658,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "flag-checkered",
    pascal_name: "FlagCheckered",
    categories: [e.MAP, e.OBJECTS, e.GAMES],
    figma_category: a.MAP,
    tags: ["flags", "race", "racing", "finish line"],
    codepoint: 59960,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "flag-pennant",
    pascal_name: "FlagPennant",
    categories: [
      e.OBJECTS,
      e.MAP,
      e.SYSTEM,
      e.GAMES
    ],
    figma_category: a.MAP,
    tags: ["flags", "race", "sports", "team"],
    codepoint: 60656,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "flame",
    pascal_name: "Flame",
    categories: [e.NATURE, e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["fire", "burning", "match", "lighter"],
    codepoint: 58916,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "flashlight",
    pascal_name: "Flashlight",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["torch", "find", "search", "locate"],
    codepoint: 57926,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "flask",
    pascal_name: "Flask",
    categories: [
      e.DEVELOPMENT,
      e.NATURE,
      e.OBJECTS
    ],
    figma_category: a.HEALTH,
    tags: ["beaker", "science", "chemistry", "experiment", "erlenmeyer"],
    codepoint: 59294,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "flip-horizontal",
    pascal_name: "FlipHorizontal",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["*new*", "mirror", "rotate", "invert"],
    codepoint: 60778,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "flip-vertical",
    pascal_name: "FlipVertical",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["*new*", "mirror", "rotate", "invert"],
    codepoint: 60780,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "floppy-disk",
    pascal_name: "FloppyDisk",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "diskette",
      "directory",
      "directories",
      "folders",
      "documents",
      "files",
      "save",
      "write"
    ],
    codepoint: 57928,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "floppy-disk-back",
    pascal_name: "FloppyDiskBack",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "*updated*",
      "diskette",
      "directory",
      "directories",
      "folders",
      "documents",
      "files",
      "save",
      "write"
    ],
    codepoint: 60148,
    published_in: 1.3,
    updated_in: 2.1
  },
  {
    name: "flow-arrow",
    pascal_name: "FlowArrow",
    categories: [e.ARROWS, e.DESIGN, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["*updated*", "flowchart", "arrowhead"],
    codepoint: 59116,
    published_in: 1.3,
    updated_in: 2.1
  },
  {
    name: "flower",
    pascal_name: "Flower",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["plants", "green", "environmental"],
    codepoint: 59230,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "flower-lotus",
    pascal_name: "FlowerLotus",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["plants", "green", "environmental", "spirituality"],
    codepoint: 59084,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "flower-tulip",
    pascal_name: "FlowerTulip",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["plants", "green", "environmental"],
    codepoint: 60108,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "flying-saucer",
    pascal_name: "FlyingSaucer",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["ufo", "space", "aliens", "extra terrestrial", "sci-fi"],
    codepoint: 60234,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "folder",
    pascal_name: "Folder",
    alias: { name: "folder-notch", pascal_name: "FolderNotch" },
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["directory", "directories", "files", "folders"],
    codepoint: 57930,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "folder-dashed",
    pascal_name: "FolderDashed",
    alias: { name: "folder-dotted", pascal_name: "FolderDotted" },
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "directory",
      "directories",
      "files",
      "folders",
      "missing",
      "temporary",
      "dotted"
    ],
    codepoint: 59640,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "folder-lock",
    pascal_name: "FolderLock",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["directory", "directories", "files", "folders", "private", "secure"],
    codepoint: 59964,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "folder-minus",
    pascal_name: "FolderMinus",
    alias: { name: "folder-notch-minus", pascal_name: "FolderNotchMinus" },
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "directory",
      "directories",
      "files",
      "delete",
      "write",
      "remove",
      "-"
    ],
    codepoint: 57940,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "folder-open",
    pascal_name: "FolderOpen",
    alias: { name: "folder-notch-open", pascal_name: "FolderNotchOpen" },
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["directory", "directories", "files", "folders", "load"],
    codepoint: 57942,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "folder-plus",
    pascal_name: "FolderPlus",
    alias: { name: "folder-notch-plus", pascal_name: "FolderNotchPlus" },
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "directory",
      "directories",
      "files",
      "save",
      "write",
      "add",
      "new",
      "create",
      "+"
    ],
    codepoint: 57944,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "folder-simple",
    pascal_name: "FolderSimple",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["directory", "directories", "files", "folders"],
    codepoint: 57946,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "folder-simple-dashed",
    pascal_name: "FolderSimpleDashed",
    alias: { name: "folder-simple-dotted", pascal_name: "FolderSimpleDotted" },
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "directory",
      "directories",
      "files",
      "folders",
      "missing",
      "temporary",
      "dotted"
    ],
    codepoint: 60458,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "folder-simple-lock",
    pascal_name: "FolderSimpleLock",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["directory", "directories", "files", "folders", "private", "secure"],
    codepoint: 60254,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "folder-simple-minus",
    pascal_name: "FolderSimpleMinus",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "directory",
      "directories",
      "files",
      "delete",
      "write",
      "remove",
      "-"
    ],
    codepoint: 57948,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "folder-simple-plus",
    pascal_name: "FolderSimplePlus",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "directory",
      "directories",
      "files",
      "save",
      "write",
      "add",
      "new",
      "create",
      "+"
    ],
    codepoint: 57950,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "folder-simple-star",
    pascal_name: "FolderSimpleStar",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "directory",
      "directories",
      "files",
      "folders",
      "favorite",
      "starred"
    ],
    codepoint: 60462,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "folder-simple-user",
    pascal_name: "FolderSimpleUser",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["directory", "directories", "files", "folders", "personal"],
    codepoint: 60256,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "folder-star",
    pascal_name: "FolderStar",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "directory",
      "directories",
      "files",
      "folders",
      "favorite",
      "starred"
    ],
    codepoint: 60038,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "folder-user",
    pascal_name: "FolderUser",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["directory", "directories", "files", "folders", "personal"],
    codepoint: 60230,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "folders",
    pascal_name: "Folders",
    categories: [e.OFFICE, e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "directory",
      "directories",
      "files",
      "folders",
      "copy",
      "copied",
      "duplicated"
    ],
    codepoint: 57952,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "football",
    pascal_name: "Football",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["sports", "american football", "nfl"],
    codepoint: 59160,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "football-helmet",
    pascal_name: "FootballHelmet",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "american football", "nfl"],
    codepoint: 61004,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "footprints",
    pascal_name: "Footprints",
    categories: [e.HEALTH, e.MAP],
    figma_category: a.PEOPLE,
    tags: ["path", "trail", "walk", "route", "hike", "hiking"],
    codepoint: 60040,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "fork-knife",
    pascal_name: "ForkKnife",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["food", "meal", "eating", "restaurants", "dining", "utensils"],
    codepoint: 57954,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "four-k",
    pascal_name: "FourK",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["*new*", "uhd", "resolution", "video"],
    codepoint: 59996,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "frame-corners",
    pascal_name: "FrameCorners",
    categories: [e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "expand",
      "fullscreen",
      "maximized",
      "resize",
      "windowed",
      "capture"
    ],
    codepoint: 58918,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "framer-logo",
    pascal_name: "FramerLogo",
    categories: [e.BRAND, e.DESIGN],
    figma_category: a.BRAND,
    tags: ["logos", "interface", "ui", "motion", "prototype", "prototyping"],
    codepoint: 57956,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "function",
    pascal_name: "Function",
    categories: [e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: ["mathematics", "arithmetic", "f-stop"],
    codepoint: 60388,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "funnel",
    pascal_name: "Funnel",
    categories: [e.EDITOR, e.OBJECTS],
    figma_category: a.OFFICE,
    tags: ["filters", "refine", "sorting"],
    codepoint: 57958,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "funnel-simple",
    pascal_name: "FunnelSimple",
    categories: [e.EDITOR, e.OBJECTS],
    figma_category: a.OFFICE,
    tags: ["filters", "refine", "sorting"],
    codepoint: 57960,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "funnel-simple-x",
    pascal_name: "FunnelSimpleX",
    categories: [e.EDITOR, e.OBJECTS],
    figma_category: a.OFFICE,
    tags: ["*new*", "filters", "refine", "sorting"],
    codepoint: 57962,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "funnel-x",
    pascal_name: "FunnelX",
    categories: [e.EDITOR, e.OBJECTS],
    figma_category: a.OFFICE,
    tags: ["*new*", "filters", "refine", "sorting"],
    codepoint: 57964,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "game-controller",
    pascal_name: "GameController",
    categories: [e.GAMES, e.MEDIA, e.OBJECTS],
    figma_category: a.GAMES,
    tags: [
      "gaming",
      "video games",
      "nintendo switch",
      "sony playstation",
      "microsoft xbox"
    ],
    codepoint: 57966,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "garage",
    pascal_name: "Garage",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: ["vehicles", "automobile", "buildings", "transportation"],
    codepoint: 60630,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "gas-can",
    pascal_name: "GasCan",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["jerrycan", "petrol", "fuel", "gasoline"],
    codepoint: 59598,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "gas-pump",
    pascal_name: "GasPump",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["gas station", "petrol", "fuel", "gasoline"],
    codepoint: 59240,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "gauge",
    pascal_name: "Gauge",
    categories: [
      e.DEVELOPMENT,
      e.OBJECTS,
      e.SYSTEM
    ],
    figma_category: a.SYSTEM,
    tags: [
      "dashboard",
      "meter",
      "speed",
      "speedometer",
      "odometer",
      "performance"
    ],
    codepoint: 58920,
    published_in: 1.2,
    updated_in: 1.4
  },
  {
    name: "gavel",
    pascal_name: "Gavel",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["judge", "justice", "legal", "law", "court", "hammer", "government"],
    codepoint: 59954,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "gear",
    pascal_name: "Gear",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "8",
      "settings",
      "setup",
      "preferences",
      "cogs",
      "gears",
      "machinery",
      "mechanical"
    ],
    codepoint: 57968,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "gear-fine",
    pascal_name: "GearFine",
    categories: [e.SYSTEM],
    figma_category: a.DESIGN,
    tags: ["setup", "preferences", "cogs", "gears", "machinery", "mechanical"],
    codepoint: 59516,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "gear-six",
    pascal_name: "GearSix",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "6",
      "settings",
      "setup",
      "preferences",
      "cogs",
      "gears",
      "machinery",
      "mechanical"
    ],
    codepoint: 57970,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "gender-female",
    pascal_name: "GenderFemale",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["woman", "feminine", "venus"],
    codepoint: 59104,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "gender-intersex",
    pascal_name: "GenderIntersex",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["transgender", "non-binary"],
    codepoint: 59110,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "gender-male",
    pascal_name: "GenderMale",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["man", "masculine", "mars"],
    codepoint: 59106,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "gender-neuter",
    pascal_name: "GenderNeuter",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["agender", "non-binary", "asexual"],
    codepoint: 59114,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "gender-nonbinary",
    pascal_name: "GenderNonbinary",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["intersex", "non-binary"],
    codepoint: 59108,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "gender-transgender",
    pascal_name: "GenderTransgender",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["intersex", "non-binary"],
    codepoint: 59112,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "ghost",
    pascal_name: "Ghost",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["pac-man", "spirit", "scary", "halloween"],
    codepoint: 58922,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "gif",
    pascal_name: "Gif",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["gifs", ".gif", "giphy"],
    codepoint: 57972,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "gift",
    pascal_name: "Gift",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["presents", "holiday", "birthday"],
    codepoint: 57974,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "git-branch",
    pascal_name: "GitBranch",
    categories: [e.DEVELOPMENT],
    figma_category: a.DEVELOPMENT,
    tags: [
      "*updated*",
      "github",
      "vcs",
      "source control",
      "version control",
      "versioning",
      "branches"
    ],
    codepoint: 57976,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "git-commit",
    pascal_name: "GitCommit",
    categories: [e.DEVELOPMENT],
    figma_category: a.DEVELOPMENT,
    tags: [
      "github",
      "vcs",
      "source control",
      "version control",
      "versioning",
      "commits"
    ],
    codepoint: 57978,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "git-diff",
    pascal_name: "GitDiff",
    categories: [e.DEVELOPMENT],
    figma_category: a.DEVELOPMENT,
    tags: [
      "*updated*",
      "github",
      "vcs",
      "source control",
      "version control",
      "versioning",
      "difference",
      "compare"
    ],
    codepoint: 57980,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "git-fork",
    pascal_name: "GitFork",
    categories: [e.DEVELOPMENT],
    figma_category: a.DEVELOPMENT,
    tags: [
      "*updated*",
      "github",
      "vcs",
      "source control",
      "version control",
      "versioning",
      "split"
    ],
    codepoint: 57982,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "git-merge",
    pascal_name: "GitMerge",
    categories: [e.DEVELOPMENT],
    figma_category: a.DEVELOPMENT,
    tags: [
      "*updated*",
      "github",
      "vcs",
      "source control",
      "version control",
      "versioning",
      "split"
    ],
    codepoint: 57984,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "git-pull-request",
    pascal_name: "GitPullRequest",
    categories: [e.DEVELOPMENT],
    figma_category: a.DEVELOPMENT,
    tags: [
      "*updated*",
      "github",
      "vcs",
      "source control",
      "version control",
      "versioning",
      "merge request"
    ],
    codepoint: 57986,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "github-logo",
    pascal_name: "GithubLogo",
    categories: [e.DEVELOPMENT, e.BRAND],
    figma_category: a.BRAND,
    tags: [
      "octocat",
      "vcs",
      "source control",
      "version control",
      "versioning",
      "branches"
    ],
    codepoint: 58742,
    published_in: 1.1,
    updated_in: 2
  },
  {
    name: "gitlab-logo",
    pascal_name: "GitlabLogo",
    categories: [e.BRAND, e.DEVELOPMENT],
    figma_category: a.BRAND,
    tags: [
      "vcs",
      "source control",
      "version control",
      "versioning",
      "branches"
    ],
    codepoint: 59028,
    published_in: 1.3,
    updated_in: 2
  },
  {
    name: "gitlab-logo-simple",
    pascal_name: "GitlabLogoSimple",
    categories: [e.BRAND, e.DEVELOPMENT],
    figma_category: a.BRAND,
    tags: [
      "vcs",
      "source control",
      "version control",
      "versioning",
      "branches"
    ],
    codepoint: 59030,
    published_in: 1.3,
    updated_in: 2
  },
  {
    name: "globe",
    pascal_name: "Globe",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "world",
      "earth",
      "global",
      "planet",
      "circle",
      "round",
      "internationalization",
      "i18n",
      "languages",
      "country",
      "countries",
      "geography",
      "internet"
    ],
    codepoint: 57992,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "globe-hemisphere-east",
    pascal_name: "GlobeHemisphereEast",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "world",
      "earth",
      "global",
      "planet",
      "circle",
      "round",
      "internationalization",
      "i18n",
      "languages",
      "country",
      "countries",
      "geography",
      "europe",
      "africa",
      "asia",
      "australia"
    ],
    codepoint: 57994,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "globe-hemisphere-west",
    pascal_name: "GlobeHemisphereWest",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "world",
      "earth",
      "global",
      "planet",
      "circle",
      "round",
      "internationalization",
      "i18n",
      "languages",
      "country",
      "countries",
      "geography",
      "north america",
      "south america"
    ],
    codepoint: 57996,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "globe-simple",
    pascal_name: "GlobeSimple",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "world",
      "earth",
      "global",
      "planet",
      "circle",
      "round",
      "internationalization",
      "i18n",
      "languages",
      "country",
      "countries",
      "geography"
    ],
    codepoint: 57998,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "globe-simple-x",
    pascal_name: "GlobeSimpleX",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "world",
      "earth",
      "global",
      "planet",
      "circle",
      "round",
      "internationalization",
      "i18n",
      "languages",
      "country",
      "countries",
      "geography",
      "internet"
    ],
    codepoint: 57988,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "globe-stand",
    pascal_name: "GlobeStand",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "world",
      "global",
      "planet",
      "circle",
      "round",
      "internationalization",
      "i18n",
      "languages",
      "country",
      "countries",
      "geography"
    ],
    codepoint: 58e3,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "globe-x",
    pascal_name: "GlobeX",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "world",
      "earth",
      "global",
      "planet",
      "circle",
      "round",
      "internationalization",
      "i18n",
      "languages",
      "country",
      "countries",
      "geography",
      "internet"
    ],
    codepoint: 57990,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "goggles",
    pascal_name: "Goggles",
    categories: [e.HEALTH, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["swim", "swimming", "sports", "exercise", "olympics", "aquatics"],
    codepoint: 60596,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "golf",
    pascal_name: "Golf",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "pga", "tee", "ball"],
    codepoint: 59966,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "goodreads-logo",
    pascal_name: "GoodreadsLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["*updated*", "reading", "books", "social media", "logos"],
    codepoint: 60688,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "google-cardboard-logo",
    pascal_name: "GoogleCardboardLogo",
    categories: [e.BRAND],
    figma_category: a.GAMES,
    tags: ["virtual reality", "vr", "logos"],
    codepoint: 59318,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "google-chrome-logo",
    pascal_name: "GoogleChromeLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["web browsers", "internet"],
    codepoint: 59766,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "google-drive-logo",
    pascal_name: "GoogleDriveLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["cloud", "storage", "backup", "logos"],
    codepoint: 59638,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "google-logo",
    pascal_name: "GoogleLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["logos", "search engine", "phone", "mobile", "android"],
    codepoint: 58002,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "google-photos-logo",
    pascal_name: "GooglePhotosLogo",
    categories: [e.BRAND, e.MEDIA],
    figma_category: a.BRAND,
    tags: ["album", "pictures", "photography"],
    codepoint: 60306,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "google-play-logo",
    pascal_name: "GooglePlayLogo",
    categories: [e.BRAND, e.SYSTEM, e.MEDIA],
    figma_category: a.BRAND,
    tags: [
      "logos",
      "games",
      "apps",
      "applications",
      "play store",
      "app store",
      "phone",
      "mobile",
      "android"
    ],
    codepoint: 58004,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "google-podcasts-logo",
    pascal_name: "GooglePodcastsLogo",
    categories: [e.BRAND, e.MEDIA],
    figma_category: a.BRAND,
    tags: ["audio"],
    codepoint: 60308,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "gps",
    pascal_name: "Gps",
    categories: [e.MAP, e.SYSTEM],
    figma_category: a.MAP,
    tags: ["*new*", "geolocation", "location", "navigation"],
    codepoint: 60888,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "gps-fix",
    pascal_name: "GpsFix",
    categories: [e.MAP, e.SYSTEM],
    figma_category: a.MAP,
    tags: ["*new*", "geolocation", "location", "navigation"],
    codepoint: 60886,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "gps-slash",
    pascal_name: "GpsSlash",
    categories: [e.MAP, e.SYSTEM],
    figma_category: a.MAP,
    tags: ["*new*", "geolocation", "location", "navigation", "disabled"],
    codepoint: 60884,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "gradient",
    pascal_name: "Gradient",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["fade", "ombre", "opacity"],
    codepoint: 60226,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "graduation-cap",
    pascal_name: "GraduationCap",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.EDUCATION,
    tags: [
      "classroom",
      "teacher",
      "education",
      "school",
      "college",
      "university",
      "degree",
      "graduate",
      "hat"
    ],
    codepoint: 58924,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "grains",
    pascal_name: "Grains",
    categories: [e.COMMERCE, e.NATURE],
    figma_category: a.COMMERCE,
    tags: ["wheat", "gluten", "farm", "farming", "agriculture"],
    codepoint: 60520,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "grains-slash",
    pascal_name: "GrainsSlash",
    categories: [e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["gluten-free", "wheat", "gluten", "farm", "farming", "agriculture"],
    codepoint: 60522,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "graph",
    pascal_name: "Graph",
    categories: [e.OFFICE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: ["nodes", "tree"],
    codepoint: 60248,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "graphics-card",
    pascal_name: "GraphicsCard",
    categories: [e.DEVELOPMENT],
    figma_category: a.DEVELOPMENT,
    tags: ["*new*", "graphics card", "microchip", "computer", "circuit"],
    codepoint: 58898,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "greater-than",
    pascal_name: "GreaterThan",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      ">",
      "greater than",
      "gt",
      "comparison",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60868,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "greater-than-or-equal",
    pascal_name: "GreaterThanOrEqual",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "≥",
      "greater than or equal",
      "gte",
      "comparison",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60834,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "grid-four",
    pascal_name: "GridFour",
    categories: [e.DESIGN, e.SYSTEM],
    figma_category: a.DESIGN,
    tags: [
      "4",
      "apps",
      "applications",
      "squares",
      "tiles",
      "cells",
      "tables",
      "tabular",
      "spreadsheets",
      "excel"
    ],
    codepoint: 58006,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "grid-nine",
    pascal_name: "GridNine",
    categories: [e.DESIGN, e.SYSTEM],
    figma_category: a.DESIGN,
    tags: [
      "9",
      "apps",
      "applications",
      "squares",
      "tiles",
      "cells",
      "tables",
      "tabular",
      "spreadsheets",
      "excel"
    ],
    codepoint: 60556,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "guitar",
    pascal_name: "Guitar",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["music", "instrument"],
    codepoint: 60042,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "hair-dryer",
    pascal_name: "HairDryer",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "blow dryer", "beauty", "grooming", "salon"],
    codepoint: 60006,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "hamburger",
    pascal_name: "Hamburger",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: [
      "fast food",
      "party",
      "places",
      "locations",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 59280,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "hammer",
    pascal_name: "Hammer",
    categories: [
      e.OBJECTS,
      e.SYSTEM,
      e.COMMERCE
    ],
    figma_category: a.COMMERCE,
    tags: ["tools", "carpentry", "construction"],
    codepoint: 59406,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "hand",
    pascal_name: "Hand",
    categories: [e.SYSTEM, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["pointers", "cursors", "emoji", "backhand"],
    codepoint: 58008,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hand-arrow-down",
    pascal_name: "HandArrowDown",
    categories: [
      e.PEOPLE,
      e.COMMERCE,
      e.FINANCE
    ],
    figma_category: a.PEOPLE,
    tags: ["*new*", "take", "receive", "remove", "withdraw", "emoji"],
    codepoint: 59982,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "hand-arrow-up",
    pascal_name: "HandArrowUp",
    categories: [
      e.PEOPLE,
      e.COMMERCE,
      e.FINANCE
    ],
    figma_category: a.PEOPLE,
    tags: ["*new*", "give", "insert", "deposit", "donation", "emoji"],
    codepoint: 61018,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "hand-coins",
    pascal_name: "HandCoins",
    categories: [
      e.PEOPLE,
      e.COMMERCE,
      e.FINANCE
    ],
    figma_category: a.COMMERCE,
    tags: ["donation", "payment", "money", "paying", "purchase"],
    codepoint: 60044,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "hand-deposit",
    pascal_name: "HandDeposit",
    categories: [
      e.PEOPLE,
      e.COMMERCE,
      e.FINANCE
    ],
    figma_category: a.PEOPLE,
    tags: ["*new*", "give", "insert", "donation", "atm", "emoji"],
    codepoint: 61058,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "hand-eye",
    pascal_name: "HandEye",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["*updated*", "emoji", "hamsa", "evil eye"],
    codepoint: 59980,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "hand-fist",
    pascal_name: "HandFist",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["emoji", "power", "protest", "blm"],
    codepoint: 58746,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "hand-grabbing",
    pascal_name: "HandGrabbing",
    categories: [e.SYSTEM, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["pointers", "cursors", "emoji", "drag", "hold"],
    codepoint: 58748,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "hand-heart",
    pascal_name: "HandHeart",
    categories: [e.PEOPLE],
    figma_category: a.HEALTH,
    tags: ["donation", "care", "emoji"],
    codepoint: 59408,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "hand-palm",
    pascal_name: "HandPalm",
    categories: [e.SYSTEM, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "pointers",
      "cursors",
      "emoji",
      "palm",
      "stop",
      "wait",
      "hamsa",
      "5"
    ],
    codepoint: 58750,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "hand-peace",
    pascal_name: "HandPeace",
    categories: [e.PEOPLE, e.COMMUNICATION],
    figma_category: a.PEOPLE,
    tags: ["*new*", "emoji", "victory"],
    codepoint: 59340,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "hand-pointing",
    pascal_name: "HandPointing",
    categories: [e.SYSTEM, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["pointers", "cursors", "emoji", "fingers", "clicks", "mouse"],
    codepoint: 58010,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hand-soap",
    pascal_name: "HandSoap",
    categories: [e.HEALTH, e.OBJECTS],
    figma_category: a.HEALTH,
    tags: [
      "dispenser",
      "pump",
      "sanitizer",
      "disinfectant",
      "lotion",
      "bottle"
    ],
    codepoint: 58928,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "hand-swipe-left",
    pascal_name: "HandSwipeLeft",
    categories: [e.PEOPLE, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["pointers", "cursors", "gesture"],
    codepoint: 60564,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "hand-swipe-right",
    pascal_name: "HandSwipeRight",
    categories: [e.PEOPLE, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["pointers", "cursors", "gesture"],
    codepoint: 60562,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "hand-tap",
    pascal_name: "HandTap",
    categories: [e.PEOPLE, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["pointers", "cursors", "gesture"],
    codepoint: 60560,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "hand-waving",
    pascal_name: "HandWaving",
    categories: [e.SYSTEM, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["emoji", "palm", "wave", "hello", "goodbye"],
    codepoint: 58752,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "hand-withdraw",
    pascal_name: "HandWithdraw",
    categories: [
      e.PEOPLE,
      e.COMMERCE,
      e.FINANCE
    ],
    figma_category: a.PEOPLE,
    tags: ["*new*", "take", "remove", "withdrawal", "atm", "emoji"],
    codepoint: 61056,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "handbag",
    pascal_name: "Handbag",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["suitcases", "valises", "baggage", "purses"],
    codepoint: 58012,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "handbag-simple",
    pascal_name: "HandbagSimple",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["suitcases", "valises", "baggage", "purses"],
    codepoint: 58926,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "hands-clapping",
    pascal_name: "HandsClapping",
    categories: [e.SYSTEM, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["emoji", "clap", "applause"],
    codepoint: 59040,
    published_in: 1.3,
    updated_in: 1.4
  },
  {
    name: "hands-praying",
    pascal_name: "HandsPraying",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["emoji", "religion", "worship", "prayer", "thanks", "thank you"],
    codepoint: 60616,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "handshake",
    pascal_name: "Handshake",
    categories: [e.PEOPLE, e.COMMERCE],
    figma_category: a.PEOPLE,
    tags: ["emoji", "deal", "agreement"],
    codepoint: 58754,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "hard-drive",
    pascal_name: "HardDrive",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "hard disk",
      "storage",
      "hdd",
      "servers",
      "databases"
    ],
    codepoint: 58014,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hard-drives",
    pascal_name: "HardDrives",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "hard disk",
      "storage",
      "hdd",
      "servers",
      "databases"
    ],
    codepoint: 58016,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hard-hat",
    pascal_name: "HardHat",
    categories: [
      e.COMMERCE,
      e.OBJECTS,
      e.DEVELOPMENT
    ],
    figma_category: a.COMMERCE,
    tags: ["*new*", "safety", "construction", "industry", "helmet", "ppe"],
    codepoint: 60742,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "hash",
    pascal_name: "Hash",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "hashtag",
      "octothorpe",
      "pound sign",
      "number sign",
      "tic-tac-toe",
      "symbol"
    ],
    codepoint: 58018,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hash-straight",
    pascal_name: "HashStraight",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: [
      "hashtag",
      "octothorpe",
      "pound sign",
      "number sign",
      "tic-tac-toe",
      "symbol"
    ],
    codepoint: 58020,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "head-circuit",
    pascal_name: "HeadCircuit",
    categories: [e.DEVELOPMENT],
    figma_category: a.DEVELOPMENT,
    tags: ["*new*", "automaton", "artificial intelligence", "ai"],
    codepoint: 59348,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "headlights",
    pascal_name: "Headlights",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["brights", "high beams"],
    codepoint: 59134,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "headphones",
    pascal_name: "Headphones",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "listening"],
    codepoint: 58022,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "headset",
    pascal_name: "Headset",
    categories: [e.MEDIA, e.GAMES, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: [
      "music",
      "audio",
      "listening",
      "gaming",
      "voice chat",
      "microphone",
      "headphones",
      "support",
      "customer-service",
      "call-center"
    ],
    codepoint: 58756,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "heart",
    pascal_name: "Heart",
    categories: [
      e.COMMUNICATION,
      e.GAMES,
      e.HEALTH
    ],
    figma_category: a.GAMES,
    tags: [
      "wellness",
      "love",
      "healthy",
      "like",
      "favorites",
      "favorited",
      "suits",
      "cards",
      "gambling",
      "casino",
      "gaming",
      "emoji"
    ],
    codepoint: 58024,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "heart-break",
    pascal_name: "HeartBreak",
    categories: [e.COMMUNICATION],
    figma_category: a.GAMES,
    tags: ["love", "hate", "crack", "split", "divorce", "emoji"],
    codepoint: 60392,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "heart-half",
    pascal_name: "HeartHalf",
    categories: [
      e.COMMUNICATION,
      e.GAMES,
      e.HEALTH
    ],
    figma_category: a.GAMES,
    tags: ["wellness", "love", "healthy", "like", "favorites", "favorited"],
    codepoint: 60488,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "heart-straight",
    pascal_name: "HeartStraight",
    categories: [
      e.COMMUNICATION,
      e.GAMES,
      e.HEALTH
    ],
    figma_category: a.GAMES,
    tags: [
      "wellness",
      "love",
      "healthy",
      "like",
      "favorites",
      "favorited",
      "suits",
      "cards",
      "gambling",
      "casino",
      "gaming",
      "emoji"
    ],
    codepoint: 58026,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "heart-straight-break",
    pascal_name: "HeartStraightBreak",
    categories: [e.COMMUNICATION],
    figma_category: a.GAMES,
    tags: ["love", "hate", "crack", "split", "divorce", "emoji"],
    codepoint: 60312,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "heartbeat",
    pascal_name: "Heartbeat",
    categories: [e.HEALTH, e.SYSTEM],
    figma_category: a.HEALTH,
    tags: ["wellness", "healthy", "ecg", "ekg", "vitals", "monitor"],
    codepoint: 58028,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "hexagon",
    pascal_name: "Hexagon",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["6", "shapes", "polygons"],
    codepoint: 58030,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "high-definition",
    pascal_name: "HighDefinition",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["*new*", "hd", "resolution", "video"],
    codepoint: 60046,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "high-heel",
    pascal_name: "HighHeel",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*updated*", "pumps", "clothes", "clothing", "shoes"],
    codepoint: 59624,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "highlighter",
    pascal_name: "Highlighter",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["*new*", "marker", "write", "writing", "editing"],
    codepoint: 60534,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "highlighter-circle",
    pascal_name: "HighlighterCircle",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["write", "writing", "editing", "drawing"],
    codepoint: 58930,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "hockey",
    pascal_name: "Hockey",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "nhl", "stick", "puck"],
    codepoint: 60550,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "hoodie",
    pascal_name: "Hoodie",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["clothes", "clothing", "sweatshirt"],
    codepoint: 60624,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "horse",
    pascal_name: "Horse",
    categories: [e.GAMES, e.HEALTH, e.NATURE],
    figma_category: a.GAMES,
    tags: ["animals", "equestrian", "chess", "knight", "sports"],
    codepoint: 58032,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hospital",
    pascal_name: "Hospital",
    categories: [e.MAP, e.HEALTH],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "places",
      "locations",
      "medical",
      "medicine",
      "emergency",
      "doctor",
      "buildings"
    ],
    codepoint: 59460,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "hourglass",
    pascal_name: "Hourglass",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.TIME,
    tags: [
      "times",
      "timer",
      "alarms",
      "clock",
      "schedule",
      "events",
      "waiting",
      "progress"
    ],
    codepoint: 58034,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hourglass-high",
    pascal_name: "HourglassHigh",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.TIME,
    tags: [
      "times",
      "timer",
      "alarms",
      "clock",
      "schedule",
      "events",
      "waiting",
      "progress"
    ],
    codepoint: 58036,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hourglass-low",
    pascal_name: "HourglassLow",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.TIME,
    tags: [
      "times",
      "timer",
      "alarms",
      "clock",
      "schedule",
      "events",
      "waiting",
      "progress"
    ],
    codepoint: 58038,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hourglass-medium",
    pascal_name: "HourglassMedium",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.TIME,
    tags: [
      "times",
      "timer",
      "alarms",
      "clock",
      "schedule",
      "events",
      "waiting",
      "progress"
    ],
    codepoint: 58040,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hourglass-simple",
    pascal_name: "HourglassSimple",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.TIME,
    tags: [
      "times",
      "timer",
      "alarms",
      "clock",
      "schedule",
      "events",
      "waiting",
      "progress"
    ],
    codepoint: 58042,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hourglass-simple-high",
    pascal_name: "HourglassSimpleHigh",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.TIME,
    tags: [
      "times",
      "timer",
      "alarms",
      "clock",
      "schedule",
      "events",
      "waiting",
      "progress"
    ],
    codepoint: 58044,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hourglass-simple-low",
    pascal_name: "HourglassSimpleLow",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.TIME,
    tags: [
      "times",
      "timer",
      "alarms",
      "clock",
      "schedule",
      "events",
      "waiting",
      "progress"
    ],
    codepoint: 58046,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hourglass-simple-medium",
    pascal_name: "HourglassSimpleMedium",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.TIME,
    tags: [
      "times",
      "timer",
      "alarms",
      "clock",
      "schedule",
      "events",
      "waiting",
      "progress"
    ],
    codepoint: 58048,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "house",
    pascal_name: "House",
    categories: [e.MAP, e.SYSTEM],
    figma_category: a.MAP,
    tags: ["homes", "buildings", "places", "locations"],
    codepoint: 58050,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "house-line",
    pascal_name: "HouseLine",
    categories: [e.MAP, e.SYSTEM],
    figma_category: a.MAP,
    tags: ["*updated*", "homes", "buildings", "places", "locations"],
    codepoint: 58052,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "house-simple",
    pascal_name: "HouseSimple",
    categories: [e.MAP, e.SYSTEM],
    figma_category: a.MAP,
    tags: ["homes", "buildings", "places", "locations"],
    codepoint: 58054,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "hurricane",
    pascal_name: "Hurricane",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["*new*", "meteorology", "cyclone", "storm", "disaster", "wind"],
    codepoint: 59534,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "ice-cream",
    pascal_name: "IceCream",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["food", "dessert", "cone"],
    codepoint: 59396,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "identification-badge",
    pascal_name: "IdentificationBadge",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["license", "credentials", "nametag", "user", "verification"],
    codepoint: 59126,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "identification-card",
    pascal_name: "IdentificationCard",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "license",
      "badge",
      "credentials",
      "nametag",
      "user",
      "verification"
    ],
    codepoint: 58056,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "image",
    pascal_name: "Image",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "*updated*",
      "pictures",
      "photographs",
      "photography",
      "wallpapers",
      "gallery",
      "landscape"
    ],
    codepoint: 58058,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "image-broken",
    pascal_name: "ImageBroken",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "*new*",
      "pictures",
      "photographs",
      "photography",
      "wallpapers",
      "gallery",
      "landscape",
      "missing",
      "error",
      "404"
    ],
    codepoint: 59304,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "image-square",
    pascal_name: "ImageSquare",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "pictures",
      "photographs",
      "photography",
      "wallpapers",
      "gallery",
      "landscape"
    ],
    codepoint: 58060,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "images",
    pascal_name: "Images",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "*updated*",
      "pictures",
      "photographs",
      "photography",
      "wallpapers",
      "gallery",
      "landscape",
      "album"
    ],
    codepoint: 59446,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "images-square",
    pascal_name: "ImagesSquare",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "pictures",
      "photographs",
      "photography",
      "wallpapers",
      "gallery",
      "landscape",
      "album"
    ],
    codepoint: 59444,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "infinity",
    pascal_name: "Infinity",
    alias: { name: "lemniscate", pascal_name: "Lemniscate" },
    categories: [e.DEVELOPMENT, e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "infinite",
      "lemniscate",
      "figure-eight",
      "mathematics",
      "arithmetic",
      "calculator",
      "∞"
    ],
    codepoint: 58932,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "info",
    pascal_name: "Info",
    categories: [e.SYSTEM],
    figma_category: a.SECURITY,
    tags: ["information", "help", "support"],
    codepoint: 58062,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "instagram-logo",
    pascal_name: "InstagramLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "social media", "photography", "camera"],
    codepoint: 58064,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "intersect",
    pascal_name: "Intersect",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: [
      "round",
      "join",
      "union",
      "merge",
      "combine",
      "intersecting",
      "intersection"
    ],
    codepoint: 58066,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "intersect-square",
    pascal_name: "IntersectSquare",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["venn-diagram", "join", "intersection"],
    codepoint: 59514,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "intersect-three",
    pascal_name: "IntersectThree",
    categories: [e.PEOPLE, e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["venn-diagram", "join", "intersection", "gender", "pronouns"],
    codepoint: 60612,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "intersection",
    pascal_name: "Intersection",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "∩",
      "intersection",
      "set",
      "member",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60858,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "invoice",
    pascal_name: "Invoice",
    categories: [
      e.COMMERCE,
      e.FINANCE,
      e.OFFICE
    ],
    figma_category: a.COMMERCE,
    tags: ["*new*", "receipt", "expense", "bill"],
    codepoint: 60994,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "island",
    pascal_name: "Island",
    categories: [e.MAP, e.NATURE],
    figma_category: a.WEATHER,
    tags: [
      "*new*",
      "geography",
      "beach",
      "ocean",
      "tropical",
      "palm",
      "vacation",
      "trip",
      "locations",
      "places"
    ],
    codepoint: 60934,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "jar",
    pascal_name: "Jar",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "mason jar",
      "kitchen",
      "pantry",
      "canning",
      "preserves",
      "food",
      "condiments"
    ],
    codepoint: 59360,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "jar-label",
    pascal_name: "JarLabel",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "mason jar",
      "kitchen",
      "pantry",
      "canning",
      "preserves",
      "food",
      "condiments"
    ],
    codepoint: 59360,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "jeep",
    pascal_name: "Jeep",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "*updated*",
      "vehicles",
      "automobile",
      "suv",
      "cars",
      "trucks",
      "wrangler",
      "off-road",
      "transit",
      "transportation",
      "traveling"
    ],
    codepoint: 58068,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "joystick",
    pascal_name: "Joystick",
    categories: [e.GAMES, e.MEDIA, e.OBJECTS],
    figma_category: a.GAMES,
    tags: [
      "*new*",
      "gaming",
      "game controller",
      "video games",
      "arcade game",
      "atari"
    ],
    codepoint: 59998,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "kanban",
    pascal_name: "Kanban",
    categories: [e.OFFICE],
    figma_category: a.OFFICE,
    tags: [
      "scheduling",
      "tasks",
      "project management",
      "process",
      "lean",
      "agile"
    ],
    codepoint: 60244,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "key",
    pascal_name: "Key",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "padlock",
      "security",
      "secured",
      "authentication",
      "authenticated",
      "login",
      "locked",
      "encrypted",
      "encryption"
    ],
    codepoint: 58070,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "key-return",
    pascal_name: "KeyReturn",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["keyboard", "enter"],
    codepoint: 59266,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "keyboard",
    pascal_name: "Keyboard",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["typing", "type", "keys", "input"],
    codepoint: 58072,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "keyhole",
    pascal_name: "Keyhole",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "lock",
      "security",
      "secured",
      "authentication",
      "authenticated",
      "login",
      "locked",
      "encrypted",
      "encryption",
      "privacy",
      "private"
    ],
    codepoint: 60024,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "knife",
    pascal_name: "Knife",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "tools",
      "food",
      "meal",
      "eating",
      "restaurants",
      "dining",
      "utensils"
    ],
    codepoint: 58934,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "ladder",
    pascal_name: "Ladder",
    categories: [e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["stairs", "steps", "climbing"],
    codepoint: 59876,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "ladder-simple",
    pascal_name: "LadderSimple",
    categories: [e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["stairs", "steps", "climbing"],
    codepoint: 60454,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "lamp",
    pascal_name: "Lamp",
    categories: [e.OBJECTS, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["light", "furniture", "appliances"],
    codepoint: 58936,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "lamp-pendant",
    pascal_name: "LampPendant",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "light", "furniture", "appliances"],
    codepoint: 60974,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "laptop",
    pascal_name: "Laptop",
    categories: [e.DEVELOPMENT, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["computer", "notebook", "pc", "macbook"],
    codepoint: 58758,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "lasso",
    pascal_name: "Lasso",
    categories: [e.DESIGN, e.OBJECTS],
    figma_category: a.DESIGN,
    tags: ["*new*", "select", "selection", "loop", "rope", "cowboy"],
    codepoint: 60870,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "lastfm-logo",
    pascal_name: "LastfmLogo",
    categories: [e.BRAND, e.MEDIA],
    figma_category: a.BRAND,
    tags: ["*new*", "scrobble", "music", "social media"],
    codepoint: 59458,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "layout",
    pascal_name: "Layout",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["wireframe", "sidebar", "ui", "interface"],
    codepoint: 59094,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "leaf",
    pascal_name: "Leaf",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: [
      "plants",
      "trees",
      "branches",
      "leaves",
      "nodes",
      "green",
      "environmental"
    ],
    codepoint: 58074,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "lectern",
    pascal_name: "Lectern",
    categories: [
      e.OBJECTS,
      e.FINANCE,
      e.OFFICE
    ],
    figma_category: a.EDUCATION,
    tags: [
      "*new*",
      "lecture",
      "podium",
      "pulpit",
      "stand",
      "speech",
      "presentation",
      "keynote"
    ],
    codepoint: 59738,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "lego",
    pascal_name: "Lego",
    categories: [e.GAMES],
    figma_category: a.GAMES,
    tags: ["*new*", "toys", "blocks", "bricks"],
    codepoint: 59590,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "lego-smiley",
    pascal_name: "LegoSmiley",
    categories: [
      e.GAMES,
      e.COMMUNICATION,
      e.PEOPLE
    ],
    figma_category: a.GAMES,
    tags: ["*new*", "face", "emoji", "toys", "blocks", "bricks"],
    codepoint: 59590,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "less-than",
    pascal_name: "LessThan",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "<",
      "less than",
      "lt",
      "comparison",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60844,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "less-than-or-equal",
    pascal_name: "LessThanOrEqual",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "≤",
      "less than or equal",
      "lte",
      "comparison",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60836,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "letter-circle-h",
    pascal_name: "LetterCircleH",
    categories: [e.EDITOR, e.MAP, e.DESIGN],
    figma_category: a.COMMUNICATION,
    tags: ["*new*", "hospital", "letter", "glyph", "character"],
    codepoint: 60408,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "letter-circle-p",
    pascal_name: "LetterCircleP",
    categories: [e.EDITOR, e.MAP, e.DESIGN],
    figma_category: a.COMMUNICATION,
    tags: [
      "*new*",
      "parking lot",
      "valet",
      "vehicles",
      "letter",
      "glyph",
      "character"
    ],
    codepoint: 60424,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "letter-circle-v",
    pascal_name: "LetterCircleV",
    categories: [
      e.EDITOR,
      e.DESIGN,
      e.COMMERCE
    ],
    figma_category: a.COMMUNICATION,
    tags: ["*new*", "vegan", "letter", "glyph", "character"],
    codepoint: 60436,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "lifebuoy",
    pascal_name: "Lifebuoy",
    categories: [
      e.HEALTH,
      e.OBJECTS,
      e.SYSTEM
    ],
    figma_category: a.HEALTH,
    tags: [
      "lifebelt",
      "lifesaver",
      "safety",
      "help",
      "support",
      "nautical",
      "boats",
      "ships"
    ],
    codepoint: 58938,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "lightbulb",
    pascal_name: "Lightbulb",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["flashlight", "bulbs", "lighting", "led", "energy", "idea"],
    codepoint: 58076,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "lightbulb-filament",
    pascal_name: "LightbulbFilament",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["flashlight", "bulbs", "lighting", "led", "energy", "idea"],
    codepoint: 58940,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "lighthouse",
    pascal_name: "Lighthouse",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["buildings", "nautical", "navigation", "boats", "ships", "safety"],
    codepoint: 59894,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "lightning",
    pascal_name: "Lightning",
    categories: [e.WEATHER, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "meteorology",
      "stormy",
      "thunderstorm",
      "thunderbolt",
      "charged",
      "charger",
      "charging",
      "power",
      "electricity",
      "flash"
    ],
    codepoint: 58078,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "lightning-a",
    pascal_name: "LightningA",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["flash", "auto"],
    codepoint: 60036,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "lightning-slash",
    pascal_name: "LightningSlash",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "thunderbolt",
      "charged",
      "charger",
      "charging",
      "power",
      "electricity",
      "disabled",
      "flash"
    ],
    codepoint: 58080,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "line-segment",
    pascal_name: "LineSegment",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["shapes", "drawing", "path", "pen", "vector"],
    codepoint: 59090,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "line-segments",
    pascal_name: "LineSegments",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["shapes", "drawing", "path", "pen", "vector"],
    codepoint: 59092,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "line-vertical",
    pascal_name: "LineVertical",
    categories: [e.DESIGN, e.DEVELOPMENT],
    figma_category: a.DESIGN,
    tags: ["*new*", "bar", "pipe", "|", "divider. symbol"],
    codepoint: 60784,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "link",
    pascal_name: "Link",
    categories: [e.COMMUNICATION, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: [
      "*updated*",
      "anchor",
      "hyperlink",
      "hypertext",
      "chains",
      "chained"
    ],
    codepoint: 58082,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "link-break",
    pascal_name: "LinkBreak",
    categories: [e.COMMUNICATION, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: [
      "anchor",
      "hyperlink",
      "hypertext",
      "chains",
      "chained",
      "errors",
      "broken"
    ],
    codepoint: 58084,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "link-simple",
    pascal_name: "LinkSimple",
    categories: [e.COMMUNICATION, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["anchor", "hyperlink", "hypertext", "chains", "chained"],
    codepoint: 58086,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "link-simple-break",
    pascal_name: "LinkSimpleBreak",
    categories: [e.COMMUNICATION, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: [
      "anchor",
      "hyperlink",
      "hypertext",
      "chains",
      "chained",
      "errors",
      "broken"
    ],
    codepoint: 58088,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "link-simple-horizontal",
    pascal_name: "LinkSimpleHorizontal",
    categories: [e.COMMUNICATION, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["anchor", "hyperlink", "hypertext", "chains", "chained"],
    codepoint: 58090,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "link-simple-horizontal-break",
    pascal_name: "LinkSimpleHorizontalBreak",
    categories: [e.COMMUNICATION, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: [
      "anchor",
      "hyperlink",
      "hypertext",
      "chains",
      "chained",
      "errors",
      "broken"
    ],
    codepoint: 58092,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "linkedin-logo",
    pascal_name: "LinkedinLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "jobs", "employment", "social media"],
    codepoint: 58094,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "linktree-logo",
    pascal_name: "LinktreeLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["*new*", "social media", "links"],
    codepoint: 60910,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "linux-logo",
    pascal_name: "LinuxLogo",
    categories: [e.BRAND, e.DEVELOPMENT],
    figma_category: a.BRAND,
    tags: ["penguin", "computer", "animals"],
    codepoint: 60162,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "list",
    pascal_name: "List",
    categories: [e.SYSTEM, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "*updated*",
      "hamburger menu",
      "overflow menu",
      "sidebar",
      "3",
      "ul",
      "ol",
      "unordered list",
      "ordered list",
      "checklist",
      "lines"
    ],
    codepoint: 58096,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "list-bullets",
    pascal_name: "ListBullets",
    categories: [e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["*updated*", "ul", "unordered list", "bulleted list", "checklist"],
    codepoint: 58098,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "list-checks",
    pascal_name: "ListChecks",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["*updated*", "checklist", "todo"],
    codepoint: 60124,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "list-dashes",
    pascal_name: "ListDashes",
    categories: [e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["*updated*", "ul", "unordered list", "dashed list", "checklist"],
    codepoint: 58100,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "list-heart",
    pascal_name: "ListHeart",
    categories: [e.EDITOR, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "favorites", "wishlist", "liked"],
    codepoint: 60382,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "list-magnifying-glass",
    pascal_name: "ListMagnifyingGlass",
    categories: [e.EDITOR, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["search", "find", "locate", "query", "inspect"],
    codepoint: 60384,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "list-numbers",
    pascal_name: "ListNumbers",
    categories: [e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["*updated*", "ol", "ordered list", "numbered list", "checklist"],
    codepoint: 58102,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "list-plus",
    pascal_name: "ListPlus",
    categories: [e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "*updated*",
      "ul",
      "ol",
      "unordered list",
      "ordered list",
      "checklist",
      "add",
      "+"
    ],
    codepoint: 58104,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "list-star",
    pascal_name: "ListStar",
    categories: [e.EDITOR, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "favorites", "wishlist", "liked"],
    codepoint: 60380,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "lock",
    pascal_name: "Lock",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "padlock",
      "security",
      "secured",
      "authentication",
      "authenticated",
      "login",
      "locked",
      "encrypted",
      "encryption",
      "privacy",
      "private"
    ],
    codepoint: 58106,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "lock-key",
    pascal_name: "LockKey",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "padlock",
      "security",
      "secured",
      "authentication",
      "authenticated",
      "login",
      "locked",
      "encrypted",
      "encryption",
      "privacy",
      "private"
    ],
    codepoint: 58110,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "lock-key-open",
    pascal_name: "LockKeyOpen",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "padlock",
      "security",
      "unsecured",
      "authentication",
      "unauthenticated",
      "login",
      "unlocked",
      "unencrypted",
      "encryption",
      "privacy"
    ],
    codepoint: 58112,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "lock-laminated",
    pascal_name: "LockLaminated",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "padlock",
      "security",
      "secured",
      "authentication",
      "authenticated",
      "login",
      "locked",
      "encrypted",
      "encryption",
      "privacy",
      "private"
    ],
    codepoint: 58114,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "lock-laminated-open",
    pascal_name: "LockLaminatedOpen",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "padlock",
      "security",
      "unsecured",
      "authentication",
      "unauthenticated",
      "login",
      "unlocked",
      "unencrypted",
      "encryption",
      "privacy",
      "private"
    ],
    codepoint: 58116,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "lock-open",
    pascal_name: "LockOpen",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "padlock",
      "security",
      "unsecured",
      "authentication",
      "unauthenticated",
      "login",
      "unlocked",
      "unencrypted",
      "encryption",
      "privacy"
    ],
    codepoint: 58118,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "lock-simple",
    pascal_name: "LockSimple",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "padlock",
      "security",
      "secured",
      "authentication",
      "authenticated",
      "login",
      "locked",
      "encrypted",
      "encryption",
      "privacy",
      "private"
    ],
    codepoint: 58120,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "lock-simple-open",
    pascal_name: "LockSimpleOpen",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "padlock",
      "security",
      "unsecured",
      "authentication",
      "unauthenticated",
      "login",
      "unlocked",
      "unencrypted",
      "encryption",
      "privacy",
      "private"
    ],
    codepoint: 58122,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "lockers",
    pascal_name: "Lockers",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["locker room", "gym", "storage"],
    codepoint: 60600,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "log",
    pascal_name: "Log",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["*new*", "tree", "stump", "stick", "branch"],
    codepoint: 60802,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "magic-wand",
    pascal_name: "MagicWand",
    categories: [e.DESIGN, e.GAMES, e.OBJECTS],
    figma_category: a.DESIGN,
    tags: ["selection", "wizard", "games"],
    codepoint: 59062,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "magnet",
    pascal_name: "Magnet",
    categories: [e.DEVELOPMENT, e.OBJECTS],
    figma_category: a.DEVELOPMENT,
    tags: ["magnetism", "science", "physics"],
    codepoint: 59008,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "magnet-straight",
    pascal_name: "MagnetStraight",
    categories: [e.DEVELOPMENT, e.OBJECTS],
    figma_category: a.DEVELOPMENT,
    tags: ["magnetism", "science", "physics"],
    codepoint: 59010,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "magnifying-glass",
    pascal_name: "MagnifyingGlass",
    categories: [e.EDITOR, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["search", "find", "locate", "query", "inspect"],
    codepoint: 58124,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "magnifying-glass-minus",
    pascal_name: "MagnifyingGlassMinus",
    categories: [e.EDITOR, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["search", "find", "locate", "query", "inspect", "zoom out", "-"],
    codepoint: 58126,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "magnifying-glass-plus",
    pascal_name: "MagnifyingGlassPlus",
    categories: [e.EDITOR, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["search", "find", "locate", "query", "inspect", "zoom in", "+"],
    codepoint: 58128,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "mailbox",
    pascal_name: "Mailbox",
    categories: [
      e.COMMUNICATION,
      e.OBJECTS,
      e.MAP
    ],
    figma_category: a.COMMUNICATION,
    tags: ["*new*", "email", "letters", "messaging", "post"],
    codepoint: 60446,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "map-pin",
    pascal_name: "MapPin",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "maps",
      "places",
      "markers",
      "pins",
      "locations",
      "poi",
      "point of interest"
    ],
    codepoint: 58134,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "map-pin-area",
    pascal_name: "MapPinArea",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "maps",
      "places",
      "markers",
      "pins",
      "locations",
      "poi",
      "point of interest"
    ],
    codepoint: 60986,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "map-pin-line",
    pascal_name: "MapPinLine",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "maps",
      "places",
      "markers",
      "pins",
      "locations",
      "poi",
      "point of interest"
    ],
    codepoint: 58136,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "map-pin-plus",
    pascal_name: "MapPinPlus",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "maps",
      "places",
      "markers",
      "pins",
      "locations",
      "add",
      "point of interest"
    ],
    codepoint: 58132,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "map-pin-simple",
    pascal_name: "MapPinSimple",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "maps",
      "places",
      "markers",
      "pins",
      "locations",
      "poi",
      "point of interest"
    ],
    codepoint: 60990,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "map-pin-simple-area",
    pascal_name: "MapPinSimpleArea",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "maps",
      "places",
      "markers",
      "pins",
      "locations",
      "poi",
      "point of interest"
    ],
    codepoint: 60988,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "map-pin-simple-line",
    pascal_name: "MapPinSimpleLine",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "maps",
      "places",
      "markers",
      "pins",
      "locations",
      "poi",
      "point of interest"
    ],
    codepoint: 60984,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "map-trifold",
    pascal_name: "MapTrifold",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["maps", "places", "locations", "cartography", "geography"],
    codepoint: 58138,
    published_in: 1,
    updated_in: 2
  },
  {
    name: "markdown-logo",
    pascal_name: "MarkdownLogo",
    categories: [
      e.DEVELOPMENT,
      e.OFFICE,
      e.MEDIA,
      e.BRAND
    ],
    figma_category: a.DEVELOPMENT,
    tags: ["*new*", "markup", "editor", ".md"],
    codepoint: 58632,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "marker-circle",
    pascal_name: "MarkerCircle",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["write", "writing", "editing", "drawing"],
    codepoint: 58944,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "martini",
    pascal_name: "Martini",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "glass",
      "drinks",
      "beverages",
      "cocktails",
      "places",
      "locations",
      "bars",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 58140,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "mask-happy",
    pascal_name: "MaskHappy",
    categories: [e.COMMUNICATION, e.GAMES],
    figma_category: a.GAMES,
    tags: ["theater", "costume", "smile", "smiling", "thalia"],
    codepoint: 59892,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "mask-sad",
    pascal_name: "MaskSad",
    categories: [e.COMMUNICATION, e.GAMES],
    figma_category: a.GAMES,
    tags: ["theater", "costume", "cry", "crying", "melpomene"],
    codepoint: 60318,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "mastodon-logo",
    pascal_name: "MastodonLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["*new*", "fediverse", "social media", "decentralized"],
    codepoint: 60776,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "math-operations",
    pascal_name: "MathOperations",
    categories: [e.DEVELOPMENT, e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "addition",
      "sum",
      "subtraction",
      "difference",
      "multiply",
      "multiplication",
      "product",
      "divide",
      "division",
      "divisor",
      "dividend",
      "quotient",
      "equals",
      "equality",
      "mathematics",
      "arithmetic",
      "calculator",
      "+",
      "-",
      "±",
      "×",
      "÷",
      "="
    ],
    codepoint: 58142,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "matrix-logo",
    pascal_name: "MatrixLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["*new*", "matrix protocol", "brands", "logos"],
    codepoint: 60772,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "medal",
    pascal_name: "Medal",
    categories: [e.OBJECTS, e.GAMES],
    figma_category: a.GAMES,
    tags: ["ribbons", "winning", "victory", "awards", "rosette"],
    codepoint: 58144,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "medal-military",
    pascal_name: "MedalMilitary",
    categories: [e.OBJECTS, e.GAMES],
    figma_category: a.GAMES,
    tags: ["ribbons", "winning", "victory", "awards", "military"],
    codepoint: 60668,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "medium-logo",
    pascal_name: "MediumLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["logos", "reading", "writing", "news", "social media"],
    codepoint: 58146,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "megaphone",
    pascal_name: "Megaphone",
    categories: [e.COMMUNICATION, e.OBJECTS],
    figma_category: a.COMMUNICATION,
    tags: ["bullhorn", "announcements", "loudspeaker", "broadcast"],
    codepoint: 58148,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "megaphone-simple",
    pascal_name: "MegaphoneSimple",
    categories: [e.COMMUNICATION, e.OBJECTS],
    figma_category: a.COMMUNICATION,
    tags: ["bullhorn", "announcements", "loudspeaker", "broadcast"],
    codepoint: 58946,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "member-of",
    pascal_name: "MemberOf",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "∈",
      "is element of",
      "set",
      "member",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60866,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "memory",
    pascal_name: "Memory",
    categories: [e.DEVELOPMENT],
    figma_category: a.SYSTEM,
    tags: ["*new*", "ram", "microchip", "computer", "circuit", "electronics"],
    codepoint: 59844,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "messenger-logo",
    pascal_name: "MessengerLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "facebook", "social media"],
    codepoint: 59096,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "meta-logo",
    pascal_name: "MetaLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["*updated*", "facebook", "logos", "social media", "logos"],
    codepoint: 60674,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "meteor",
    pascal_name: "Meteor",
    categories: [e.WEATHER, e.NATURE],
    figma_category: a.WEATHER,
    tags: ["*new*", "astronomy", "asteroid", "fireball"],
    codepoint: 59834,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "metronome",
    pascal_name: "Metronome",
    categories: [e.OBJECTS, e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["music", "beat", "tempo", "bpm"],
    codepoint: 60558,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "microphone",
    pascal_name: "Microphone",
    categories: [
      e.COMMUNICATION,
      e.MEDIA,
      e.SYSTEM
    ],
    figma_category: a.MEDIA,
    tags: ["audio", "recording", "music", "sound", "podcast", "studio"],
    codepoint: 58150,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "microphone-slash",
    pascal_name: "MicrophoneSlash",
    categories: [
      e.COMMUNICATION,
      e.MEDIA,
      e.SYSTEM
    ],
    figma_category: a.MEDIA,
    tags: [
      "audio",
      "recording",
      "music",
      "sound",
      "podcast",
      "studio",
      "muted",
      "disabled"
    ],
    codepoint: 58152,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "microphone-stage",
    pascal_name: "MicrophoneStage",
    categories: [
      e.COMMUNICATION,
      e.MEDIA,
      e.SYSTEM
    ],
    figma_category: a.MEDIA,
    tags: ["audio", "recording", "music", "sound", "performance", "concert"],
    codepoint: 59228,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "microscope",
    pascal_name: "Microscope",
    categories: [
      e.NATURE,
      e.DEVELOPMENT,
      e.OBJECTS,
      e.HEALTH
    ],
    figma_category: a.HEALTH,
    tags: ["*new*", "science", "biology", "experiment", "magnify"],
    codepoint: 60538,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "microsoft-excel-logo",
    pascal_name: "MicrosoftExcelLogo",
    categories: [e.BRAND, e.OFFICE],
    figma_category: a.BRAND,
    tags: ["tables", "spreadsheets", "tabular"],
    codepoint: 60268,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "microsoft-outlook-logo",
    pascal_name: "MicrosoftOutlookLogo",
    categories: [
      e.BRAND,
      e.COMMUNICATION,
      e.OFFICE
    ],
    figma_category: a.BRAND,
    tags: ["email", "logos"],
    codepoint: 60272,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "microsoft-powerpoint-logo",
    pascal_name: "MicrosoftPowerpointLogo",
    categories: [e.BRAND, e.OFFICE],
    figma_category: a.BRAND,
    tags: ["slides", "slideshow", "presentation"],
    codepoint: 60110,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "microsoft-teams-logo",
    pascal_name: "MicrosoftTeamsLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["chat", "video conference"],
    codepoint: 60262,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "microsoft-word-logo",
    pascal_name: "MicrosoftWordLogo",
    categories: [e.BRAND, e.EDITOR, e.OFFICE],
    figma_category: a.BRAND,
    tags: ["documents", "word processor", "doc", "docx"],
    codepoint: 60266,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "minus",
    pascal_name: "Minus",
    categories: [
      e.DEVELOPMENT,
      e.FINANCE,
      e.SYSTEM
    ],
    figma_category: a.FINANCE,
    tags: [
      "-",
      "subtraction",
      "difference",
      "mathematics",
      "arithmetic",
      "calculator",
      "line",
      "horizontal",
      "divider"
    ],
    codepoint: 58154,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "minus-circle",
    pascal_name: "MinusCircle",
    categories: [
      e.DEVELOPMENT,
      e.FINANCE,
      e.SYSTEM
    ],
    figma_category: a.FINANCE,
    tags: [
      "-",
      "subtraction",
      "difference",
      "mathematics",
      "arithmetic",
      "calculator",
      "round"
    ],
    codepoint: 58156,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "minus-square",
    pascal_name: "MinusSquare",
    categories: [e.FINANCE, e.SYSTEM],
    figma_category: a.FINANCE,
    tags: [
      "-",
      "subtraction",
      "difference",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60748,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "money",
    pascal_name: "Money",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["cash", "dollars", "paper bills", "payment", "paying", "purchase"],
    codepoint: 58760,
    published_in: 1.1,
    updated_in: 2
  },
  {
    name: "money-wavy",
    pascal_name: "MoneyWavy",
    categories: [e.FINANCE, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "cash",
      "dollars",
      "paper bills",
      "payment",
      "paying",
      "purchase"
    ],
    codepoint: 61032,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "monitor",
    pascal_name: "Monitor",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["screen", "television", "tv", "displays"],
    codepoint: 58158,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "monitor-arrow-up",
    pascal_name: "MonitorArrowUp",
    categories: [e.SYSTEM, e.MEDIA],
    figma_category: a.SYSTEM,
    tags: [
      "*new*",
      "screen",
      "screencast",
      "screenshare",
      "upload",
      "video",
      "movie"
    ],
    codepoint: 58762,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "monitor-play",
    pascal_name: "MonitorPlay",
    categories: [e.SYSTEM, e.MEDIA],
    figma_category: a.SYSTEM,
    tags: [
      "screen",
      "television",
      "tv",
      "displays",
      "screencast",
      "video",
      "movie"
    ],
    codepoint: 58764,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "moon",
    pascal_name: "Moon",
    categories: [
      e.NATURE,
      e.SYSTEM,
      e.WEATHER
    ],
    figma_category: a.WEATHER,
    tags: [
      "night",
      "evening",
      "clear",
      "sleep",
      "snooze",
      "night mode",
      "dark mode",
      "astronomy",
      "stargazing"
    ],
    codepoint: 58160,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "moon-stars",
    pascal_name: "MoonStars",
    categories: [e.NATURE, e.WEATHER],
    figma_category: a.WEATHER,
    tags: [
      "night",
      "evening",
      "clear",
      "sleep",
      "snooze",
      "night mode",
      "dark mode",
      "astronomy",
      "stargazing",
      "constellation"
    ],
    codepoint: 58766,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "moped",
    pascal_name: "Moped",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["scooter", "vehicles", "vespa", "transportation", "travel"],
    codepoint: 59428,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "moped-front",
    pascal_name: "MopedFront",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["scooter", "vehicles", "vespa", "transportation", "travel"],
    codepoint: 59426,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "mosque",
    pascal_name: "Mosque",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["islam", "muslim", "religion", "worship"],
    codepoint: 60654,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "motorcycle",
    pascal_name: "Motorcycle",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["vehicles", "motorbike", "transportation", "travel"],
    codepoint: 59402,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "mountains",
    pascal_name: "Mountains",
    categories: [e.NATURE, e.MAP],
    figma_category: a.WEATHER,
    tags: ["*updated*", "hills", "outdoors", "terrain", "geology", "adventure"],
    codepoint: 59310,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "mouse",
    pascal_name: "Mouse",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*updated*", "clicks", "input"],
    codepoint: 58170,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "mouse-left-click",
    pascal_name: "MouseLeftClick",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "clicks", "input"],
    codepoint: 58164,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "mouse-middle-click",
    pascal_name: "MouseMiddleClick",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "clicks", "input"],
    codepoint: 58168,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "mouse-right-click",
    pascal_name: "MouseRightClick",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "clicks", "input"],
    codepoint: 58166,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "mouse-scroll",
    pascal_name: "MouseScroll",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "clicks", "input"],
    codepoint: 58162,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "mouse-simple",
    pascal_name: "MouseSimple",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["clicks", "input"],
    codepoint: 58948,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "music-note",
    pascal_name: "MusicNote",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["songs", "audio", "playlist", "albums"],
    codepoint: 58172,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "music-note-simple",
    pascal_name: "MusicNoteSimple",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["songs", "audio", "playlist", "albums"],
    codepoint: 58174,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "music-notes",
    pascal_name: "MusicNotes",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["songs", "audio", "playlist", "albums"],
    codepoint: 58176,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "music-notes-minus",
    pascal_name: "MusicNotesMinus",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: [
      "*new*",
      "songs",
      "audio",
      "playlist",
      "albums",
      "remove",
      "subtract"
    ],
    codepoint: 60940,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "music-notes-plus",
    pascal_name: "MusicNotesPlus",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["songs", "audio", "playlist", "albums", "add"],
    codepoint: 60284,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "music-notes-simple",
    pascal_name: "MusicNotesSimple",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["songs", "audio", "playlist", "albums"],
    codepoint: 58178,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "navigation-arrow",
    pascal_name: "NavigationArrow",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["location", "directions", "compass", "gps"],
    codepoint: 60126,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "needle",
    pascal_name: "Needle",
    categories: [e.OBJECTS, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["sewing", "thread", "awl", "tailor"],
    codepoint: 59438,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "network",
    pascal_name: "Network",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "internet", "ethernet", "lan"],
    codepoint: 60894,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "network-slash",
    pascal_name: "NetworkSlash",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "internet", "ethernet", "lan", "error"],
    codepoint: 60892,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "network-x",
    pascal_name: "NetworkX",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "internet", "ethernet", "lan", "disabled"],
    codepoint: 60890,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "newspaper",
    pascal_name: "Newspaper",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["reading", "writing", "journals", "periodicals"],
    codepoint: 58180,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "newspaper-clipping",
    pascal_name: "NewspaperClipping",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["*updated*", "reading", "writing", "journals", "periodicals"],
    codepoint: 58182,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "not-equals",
    pascal_name: "NotEquals",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "≠",
      "equality",
      "equivalent",
      "equivalence",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60838,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "not-member-of",
    pascal_name: "NotMemberOf",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "∉",
      "is not element of",
      "set",
      "member",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60846,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "not-subset-of",
    pascal_name: "NotSubsetOf",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "⊄",
      "not subset of",
      "set",
      "member",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60848,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "not-superset-of",
    pascal_name: "NotSupersetOf",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "⊉",
      "not superset of",
      "set",
      "member",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60850,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "notches",
    pascal_name: "Notches",
    categories: [e.SYSTEM, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["textarea", "resize", "drag handle", "knurling"],
    codepoint: 60730,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "note",
    pascal_name: "Note",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["notes", "note-taking", "memorandum", "post-it", "reminders"],
    codepoint: 58184,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "note-blank",
    pascal_name: "NoteBlank",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["notes", "note-taking", "memorandum", "post-it", "reminders"],
    codepoint: 58186,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "note-pencil",
    pascal_name: "NotePencil",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["notes", "note-taking", "memorandum", "post-it", "reminders"],
    codepoint: 58188,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "notebook",
    pascal_name: "Notebook",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "notes",
      "note-taking",
      "memorandum",
      "journal",
      "diary",
      "logs",
      "logbook"
    ],
    codepoint: 58190,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "notepad",
    pascal_name: "Notepad",
    categories: [e.OFFICE, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "*updated*",
      "logs",
      "logbook",
      "notes",
      "note-taking",
      "memorandum",
      "journal",
      "diary"
    ],
    codepoint: 58942,
    published_in: 1.2,
    updated_in: 2.1
  },
  {
    name: "notification",
    pascal_name: "Notification",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["badge", "pip"],
    codepoint: 59130,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "notion-logo",
    pascal_name: "NotionLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["documentation", "productivity", "wiki", "logos"],
    codepoint: 59808,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "nuclear-plant",
    pascal_name: "NuclearPlant",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "renewable", "energy", "power", "electricity"],
    codepoint: 60796,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "number-circle-eight",
    pascal_name: "NumberCircleEight",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "8",
      "round",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58194,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-circle-five",
    pascal_name: "NumberCircleFive",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "5",
      "round",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58200,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-circle-four",
    pascal_name: "NumberCircleFour",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "*updated*",
      "4",
      "round",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58206,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "number-circle-nine",
    pascal_name: "NumberCircleNine",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "9",
      "round",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58212,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-circle-one",
    pascal_name: "NumberCircleOne",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "1",
      "round",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58218,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-circle-seven",
    pascal_name: "NumberCircleSeven",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "7",
      "round",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58224,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-circle-six",
    pascal_name: "NumberCircleSix",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "6",
      "round",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58230,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-circle-three",
    pascal_name: "NumberCircleThree",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "3",
      "round",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58236,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-circle-two",
    pascal_name: "NumberCircleTwo",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "2",
      "round",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58242,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-circle-zero",
    pascal_name: "NumberCircleZero",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "0",
      "round",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58248,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-eight",
    pascal_name: "NumberEight",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "8",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58192,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-five",
    pascal_name: "NumberFive",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "5",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58198,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-four",
    pascal_name: "NumberFour",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "*updated*",
      "4",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58204,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "number-nine",
    pascal_name: "NumberNine",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "9",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58210,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-one",
    pascal_name: "NumberOne",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "1",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58216,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-seven",
    pascal_name: "NumberSeven",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "7",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58222,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-six",
    pascal_name: "NumberSix",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "6",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58228,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-square-eight",
    pascal_name: "NumberSquareEight",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "8",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58196,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-square-five",
    pascal_name: "NumberSquareFive",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "5",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58202,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-square-four",
    pascal_name: "NumberSquareFour",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "*updated*",
      "4",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58208,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "number-square-nine",
    pascal_name: "NumberSquareNine",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "9",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58214,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-square-one",
    pascal_name: "NumberSquareOne",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "1",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58220,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-square-seven",
    pascal_name: "NumberSquareSeven",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "7",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58226,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-square-six",
    pascal_name: "NumberSquareSix",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "6",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58232,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-square-three",
    pascal_name: "NumberSquareThree",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "3",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58238,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-square-two",
    pascal_name: "NumberSquareTwo",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "2",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58244,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-square-zero",
    pascal_name: "NumberSquareZero",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "0",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58250,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-three",
    pascal_name: "NumberThree",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "3",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58234,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-two",
    pascal_name: "NumberTwo",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "2",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58240,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "number-zero",
    pascal_name: "NumberZero",
    categories: [e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "0",
      "numbers",
      "numerals",
      "digits",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58246,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "numpad",
    pascal_name: "Numpad",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: [
      "*new*",
      "dialer",
      "dialpad",
      "call-center",
      "telephone",
      "landline",
      "password",
      "passcode"
    ],
    codepoint: 58312,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "nut",
    pascal_name: "Nut",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["bolts", "screws", "machinery", "tools", "hexagon"],
    codepoint: 58252,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "ny-times-logo",
    pascal_name: "NyTimesLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: [
      "nyt",
      "new york times",
      "logos",
      "reading",
      "writing",
      "news",
      "newspaper"
    ],
    codepoint: 58950,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "octagon",
    pascal_name: "Octagon",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["8", "shapes", "polygons"],
    codepoint: 58254,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "office-chair",
    pascal_name: "OfficeChair",
    categories: [e.OBJECTS, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["furniture", "seat"],
    codepoint: 59974,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "onigiri",
    pascal_name: "Onigiri",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: ["*new*", "rice ball", "japanese", "food", "restaurant"],
    codepoint: 60972,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "open-ai-logo",
    pascal_name: "OpenAiLogo",
    categories: [e.DEVELOPMENT, e.BRAND],
    figma_category: a.BRAND,
    tags: ["*new*", "artificial intelligence", "ai", "chatgpt", "llm", "logos"],
    codepoint: 59346,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "option",
    pascal_name: "Option",
    categories: [e.SYSTEM, e.EDITOR],
    figma_category: a.SYSTEM,
    tags: ["keyboard", "shortcut", "modifier"],
    codepoint: 59560,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "orange",
    pascal_name: "Orange",
    categories: [e.COMMERCE, e.NATURE],
    figma_category: a.COMMERCE,
    tags: ["*new*", "food", "fruit", "juice", "citrus", "groceries", "market"],
    codepoint: 60992,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "orange-slice",
    pascal_name: "OrangeSlice",
    categories: [e.MAP, e.COMMERCE, e.NATURE],
    figma_category: a.COMMERCE,
    tags: ["food", "fruit", "juice", "citrus", "groceries", "market"],
    codepoint: 60726,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "oven",
    pascal_name: "Oven",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "stove",
      "stovetop",
      "food",
      "cooking",
      "cuisine",
      "kitchen"
    ],
    codepoint: 60812,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "package",
    pascal_name: "Package",
    categories: [e.DEVELOPMENT, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "packages",
      "boxes",
      "delivery",
      "mail",
      "postal service",
      "bundles",
      "library",
      "libraries",
      "shipping"
    ],
    codepoint: 58256,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "paint-brush",
    pascal_name: "PaintBrush",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.OBJECTS
    ],
    figma_category: a.DESIGN,
    tags: ["colors", "color picker", "arts"],
    codepoint: 59120,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "paint-brush-broad",
    pascal_name: "PaintBrushBroad",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.OBJECTS
    ],
    figma_category: a.DESIGN,
    tags: ["fill", "colors", "color picker", "arts"],
    codepoint: 58768,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "paint-brush-household",
    pascal_name: "PaintBrushHousehold",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.OBJECTS
    ],
    figma_category: a.DESIGN,
    tags: ["colors", "color picker", "arts"],
    codepoint: 59122,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "paint-bucket",
    pascal_name: "PaintBucket",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.OBJECTS
    ],
    figma_category: a.DESIGN,
    tags: [
      "*updated*",
      "paintbucket",
      "colors",
      "color picker",
      "fill",
      "arts"
    ],
    codepoint: 58258,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "paint-roller",
    pascal_name: "PaintRoller",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.OBJECTS
    ],
    figma_category: a.DESIGN,
    tags: ["colors", "color picker", "fill", "arts", "theme"],
    codepoint: 59124,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "palette",
    pascal_name: "Palette",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.OBJECTS
    ],
    figma_category: a.DESIGN,
    tags: ["paint", "colors", "color picker", "arts"],
    codepoint: 59080,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "panorama",
    pascal_name: "Panorama",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["*new*", "image", "picture", "photography", "landscape", "360"],
    codepoint: 60066,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "pants",
    pascal_name: "Pants",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["clothing", "clothes", "jeans"],
    codepoint: 60552,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "paper-plane",
    pascal_name: "PaperPlane",
    categories: [
      e.COMMUNICATION,
      e.MAP,
      e.OBJECTS
    ],
    figma_category: a.COMMUNICATION,
    tags: [
      "mail",
      "email",
      "send",
      "sent",
      "messages",
      "messaging",
      "toys",
      "games"
    ],
    codepoint: 58260,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "paper-plane-right",
    pascal_name: "PaperPlaneRight",
    categories: [
      e.COMMUNICATION,
      e.MAP,
      e.OBJECTS
    ],
    figma_category: a.COMMUNICATION,
    tags: [
      "mail",
      "email",
      "send",
      "sent",
      "messages",
      "messaging",
      "toys",
      "games"
    ],
    codepoint: 58262,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "paper-plane-tilt",
    pascal_name: "PaperPlaneTilt",
    categories: [
      e.COMMUNICATION,
      e.MAP,
      e.OBJECTS
    ],
    figma_category: a.COMMUNICATION,
    tags: [
      "mail",
      "email",
      "send",
      "sent",
      "messages",
      "messaging",
      "toys",
      "games"
    ],
    codepoint: 58264,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "paperclip",
    pascal_name: "Paperclip",
    categories: [
      e.COMMUNICATION,
      e.EDITOR,
      e.OFFICE,
      e.OBJECTS
    ],
    figma_category: a.OFFICE,
    tags: ["attachments", "mail", "email", "office"],
    codepoint: 58266,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "paperclip-horizontal",
    pascal_name: "PaperclipHorizontal",
    categories: [
      e.COMMUNICATION,
      e.EDITOR,
      e.OFFICE,
      e.OBJECTS
    ],
    figma_category: a.OFFICE,
    tags: ["attachments", "mail", "email", "office"],
    codepoint: 58770,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "parachute",
    pascal_name: "Parachute",
    categories: [e.OBJECTS, e.DEVELOPMENT],
    figma_category: a.GAMES,
    tags: ["skydiving", "safety"],
    codepoint: 60028,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "paragraph",
    pascal_name: "Paragraph",
    categories: [e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["pilcrow"],
    codepoint: 59744,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "parallelogram",
    pascal_name: "Parallelogram",
    categories: [e.BRAND, e.MEDIA, e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["shapes", "bandcamp", "logos"],
    codepoint: 60614,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "park",
    pascal_name: "Park",
    categories: [e.MAP, e.NATURE],
    figma_category: a.MAP,
    tags: ["bench", "outdoors"],
    codepoint: 60594,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "password",
    pascal_name: "Password",
    categories: [e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "security",
      "secured",
      "authentication",
      "authenticated",
      "login",
      "locked",
      "encrypted",
      "encryption"
    ],
    codepoint: 59218,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "path",
    pascal_name: "Path",
    categories: [e.DESIGN, e.MAP],
    figma_category: a.MAP,
    tags: [
      "transit",
      "travel",
      "trail",
      "gps",
      "navigation",
      "route",
      "destination",
      "vector"
    ],
    codepoint: 58268,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "patreon-logo",
    pascal_name: "PatreonLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["*updated*", "crowdfunding", "logos"],
    codepoint: 59786,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "pause",
    pascal_name: "Pause",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "resume", "start", "stop"],
    codepoint: 58270,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "pause-circle",
    pascal_name: "PauseCircle",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "resume", "start", "stop", "round"],
    codepoint: 58272,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "paw-print",
    pascal_name: "PawPrint",
    categories: [
      e.NATURE,
      e.COMMERCE,
      e.HEALTH
    ],
    figma_category: a.WEATHER,
    tags: [
      "pets",
      "pet store",
      "pet shop",
      "animals",
      "cat",
      "dog",
      "veterinarian"
    ],
    codepoint: 58952,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "paypal-logo",
    pascal_name: "PaypalLogo",
    categories: [
      e.BRAND,
      e.FINANCE,
      e.COMMERCE
    ],
    figma_category: a.BRAND,
    tags: ["payments", "paying", "purchase", "logos"],
    codepoint: 59788,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "peace",
    pascal_name: "Peace",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["love", "hippies", "peace sign", "symbols"],
    codepoint: 58274,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "pen",
    pascal_name: "Pen",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["ink", "write", "writing", "editing", "sign", "signature"],
    codepoint: 58282,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "pen-nib",
    pascal_name: "PenNib",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: [
      "ink",
      "write",
      "writing",
      "editing",
      "sign",
      "signature",
      "fountain pen",
      "illustrator"
    ],
    codepoint: 58284,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "pen-nib-straight",
    pascal_name: "PenNibStraight",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: [
      "ink",
      "write",
      "writing",
      "editing",
      "sign",
      "signature",
      "fountain pen",
      "illustrator"
    ],
    codepoint: 58954,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "pencil",
    pascal_name: "Pencil",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["write", "writing", "editing", "sign", "signature"],
    codepoint: 58286,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "pencil-circle",
    pascal_name: "PencilCircle",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["write", "writing", "editing", "sign", "signature"],
    codepoint: 58288,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "pencil-line",
    pascal_name: "PencilLine",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["write", "writing", "editing", "sign", "signature"],
    codepoint: 58290,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "pencil-ruler",
    pascal_name: "PencilRuler",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["*new*", "drawing", "drafting", "construction", "tools"],
    codepoint: 59654,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "pencil-simple",
    pascal_name: "PencilSimple",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["write", "writing", "editing", "sign", "signature"],
    codepoint: 58292,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "pencil-simple-line",
    pascal_name: "PencilSimpleLine",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["write", "writing", "editing", "sign", "signature"],
    codepoint: 60358,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "pencil-simple-slash",
    pascal_name: "PencilSimpleSlash",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["read-only", "write", "writing", "editing"],
    codepoint: 60662,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "pencil-slash",
    pascal_name: "PencilSlash",
    categories: [e.DESIGN, e.EDITOR, e.OFFICE],
    figma_category: a.DESIGN,
    tags: ["read-only", "write", "writing", "editing"],
    codepoint: 60664,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "pentagon",
    pascal_name: "Pentagon",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["*new*", "shapes", "polygons", "5"],
    codepoint: 60542,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "pentagram",
    pascal_name: "Pentagram",
    categories: [e.GAMES, e.DESIGN],
    figma_category: a.DESIGN,
    tags: [
      "star",
      "wicca",
      "satan",
      "satanism",
      "religion",
      "spirituality",
      "evil",
      "magic"
    ],
    codepoint: 60508,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "pepper",
    pascal_name: "Pepper",
    categories: [e.COMMERCE, e.NATURE],
    figma_category: a.COMMERCE,
    tags: ["food", "spicy", "chile", "vegetable"],
    codepoint: 59722,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "percent",
    pascal_name: "Percent",
    categories: [e.DEVELOPMENT, e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "%",
      "percentage",
      "percentile",
      "ratio",
      "delta",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58294,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "person",
    pascal_name: "Person",
    categories: [e.MAP, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "walking",
      "human",
      "woman",
      "man",
      "body",
      "transit",
      "transportation",
      "travel",
      "commuter",
      "user"
    ],
    codepoint: 58280,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "person-arms-spread",
    pascal_name: "PersonArmsSpread",
    categories: [e.HEALTH, e.MAP, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["accessibility", "vitruvian", "stretch", "sports"],
    codepoint: 60670,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "person-simple",
    pascal_name: "PersonSimple",
    categories: [e.MAP, e.PEOPLE, e.HEALTH],
    figma_category: a.PEOPLE,
    tags: [
      "pedestrian",
      "walking",
      "human",
      "woman",
      "man",
      "body",
      "transit",
      "transportation",
      "travel",
      "commuter",
      "user",
      "exercise"
    ],
    codepoint: 59182,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "person-simple-bike",
    pascal_name: "PersonSimpleBike",
    categories: [e.MAP, e.PEOPLE, e.HEALTH],
    figma_category: a.PEOPLE,
    tags: [
      "pedestrian",
      "biking",
      "bicycle",
      "human",
      "woman",
      "man",
      "body",
      "sports",
      "exercise"
    ],
    codepoint: 59188,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "person-simple-circle",
    pascal_name: "PersonSimpleCircle",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["*new*", "human", "accessibility", "a11y", "vitruvius", "vitruvian"],
    codepoint: 61016,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "person-simple-hike",
    pascal_name: "PersonSimpleHike",
    categories: [
      e.NATURE,
      e.HEALTH,
      e.MAP,
      e.PEOPLE
    ],
    figma_category: a.PEOPLE,
    tags: ["*new*", "pedestrian", "climbing", "mountaineering", "bouldering"],
    codepoint: 60756,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "person-simple-run",
    pascal_name: "PersonSimpleRun",
    categories: [e.MAP, e.PEOPLE, e.HEALTH],
    figma_category: a.PEOPLE,
    tags: [
      "pedestrian",
      "running",
      "human",
      "woman",
      "man",
      "body",
      "transit",
      "transportation",
      "travel",
      "commuter",
      "user",
      "exercise"
    ],
    codepoint: 59184,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "person-simple-ski",
    pascal_name: "PersonSimpleSki",
    categories: [e.GAMES, e.HEALTH],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "skiing", "winter", "mountain"],
    codepoint: 59164,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "person-simple-snowboard",
    pascal_name: "PersonSimpleSnowboard",
    categories: [e.GAMES, e.HEALTH],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "snowboarding", "winter", "mountain"],
    codepoint: 59166,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "person-simple-swim",
    pascal_name: "PersonSimpleSwim",
    categories: [e.MAP, e.PEOPLE, e.HEALTH],
    figma_category: a.PEOPLE,
    tags: [
      "*new*",
      "pedestrian",
      "swimming",
      "human",
      "woman",
      "man",
      "body",
      "sports",
      "exercise"
    ],
    codepoint: 59190,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "person-simple-tai-chi",
    pascal_name: "PersonSimpleTaiChi",
    categories: [e.HEALTH, e.MAP, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "*new*",
      "mindfulness",
      "martial arts",
      "meditation",
      "sports",
      "exercise",
      "yoga"
    ],
    codepoint: 60764,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "person-simple-throw",
    pascal_name: "PersonSimpleThrow",
    categories: [e.MAP, e.PEOPLE, e.HEALTH],
    figma_category: a.PEOPLE,
    tags: [
      "pedestrian",
      "tennis",
      "human",
      "woman",
      "man",
      "body",
      "sports",
      "exercise"
    ],
    codepoint: 59186,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "person-simple-walk",
    pascal_name: "PersonSimpleWalk",
    categories: [e.MAP, e.PEOPLE, e.HEALTH],
    figma_category: a.PEOPLE,
    tags: [
      "pedestrian",
      "walking",
      "human",
      "woman",
      "man",
      "body",
      "transit",
      "transportation",
      "travel",
      "commuter",
      "user",
      "exercise"
    ],
    codepoint: 59194,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "perspective",
    pascal_name: "Perspective",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["3d", "skew", "warp", "trapezoid"],
    codepoint: 60390,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "phone",
    pascal_name: "Phone",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["calls", "telephone", "landline", "talk"],
    codepoint: 58296,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "phone-call",
    pascal_name: "PhoneCall",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["calls", "calling", "ringing", "telephone", "landline", "talk"],
    codepoint: 58298,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "phone-disconnect",
    pascal_name: "PhoneDisconnect",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["calls", "hang up", "disconnected", "telephone", "landline", "talk"],
    codepoint: 58300,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "phone-incoming",
    pascal_name: "PhoneIncoming",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["calls", "calling", "telephone", "landline", "talk"],
    codepoint: 58302,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "phone-list",
    pascal_name: "PhoneList",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["*new*", "calls", "call-center", "telephone", "landline", "talk"],
    codepoint: 58316,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "phone-outgoing",
    pascal_name: "PhoneOutgoing",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["calls", "calling", "telephone", "landline", "talk"],
    codepoint: 58304,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "phone-pause",
    pascal_name: "PhonePause",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: [
      "*new*",
      "calls",
      "hold",
      "call-center",
      "telephone",
      "landline",
      "talk"
    ],
    codepoint: 58314,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "phone-plus",
    pascal_name: "PhonePlus",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["calls", "telephone", "landline", "talk", "conference", "add"],
    codepoint: 60502,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "phone-slash",
    pascal_name: "PhoneSlash",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: [
      "calls",
      "disabled",
      "disconnected",
      "telephone",
      "landline",
      "talk"
    ],
    codepoint: 58306,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "phone-transfer",
    pascal_name: "PhoneTransfer",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["*new*", "calls", "call-center", "telephone", "landline", "talk"],
    codepoint: 58310,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "phone-x",
    pascal_name: "PhoneX",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["calls", "missed", "errors", "telephone", "landline", "talk"],
    codepoint: 58308,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "phosphor-logo",
    pascal_name: "PhosphorLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["logos"],
    codepoint: 58318,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "pi",
    pascal_name: "Pi",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: ["π", "symbol", "mathematics", "circle"],
    codepoint: 60544,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "piano-keys",
    pascal_name: "PianoKeys",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["music", "instrument", "keyboard"],
    codepoint: 59848,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "picnic-table",
    pascal_name: "PicnicTable",
    categories: [e.MAP, e.NATURE],
    figma_category: a.COMMERCE,
    tags: ["*new*", "bench", "park", "outdoors"],
    codepoint: 60966,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "picture-in-picture",
    pascal_name: "PictureInPicture",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["pip", "pop-out", "minimize", "maximize"],
    codepoint: 58956,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "piggy-bank",
    pascal_name: "PiggyBank",
    categories: [e.FINANCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["savings", "deposit", "money", "coins"],
    codepoint: 59908,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "pill",
    pascal_name: "Pill",
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: [
      "capsule",
      "medicine",
      "rx",
      "pharmacy",
      "pharmacist",
      "pharmaceuticals",
      "prescription",
      "drugs"
    ],
    codepoint: 59136,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "ping-pong",
    pascal_name: "PingPong",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "paddle"],
    codepoint: 59970,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "pint-glass",
    pascal_name: "PintGlass",
    categories: [
      e.COMMERCE,
      e.HEALTH,
      e.OBJECTS
    ],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "water",
      "beverage",
      "drinks",
      "beverages",
      "food",
      "dining"
    ],
    codepoint: 60880,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "pinterest-logo",
    pascal_name: "PinterestLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "vision board", "mood board", "social media"],
    codepoint: 58958,
    published_in: 1.2,
    updated_in: 1.4
  },
  {
    name: "pinwheel",
    pascal_name: "Pinwheel",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["toys", "whirligig"],
    codepoint: 60316,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "pipe",
    pascal_name: "Pipe",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "tube", "plumber", "plumbing", "construction"],
    codepoint: 60806,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "pipe-wrench",
    pascal_name: "PipeWrench",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "plumber", "plumbing", "tools", "construction"],
    codepoint: 60808,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "pix-logo",
    pascal_name: "PixLogo",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["*new*", "payments", "paying", "purchase", "logos"],
    codepoint: 60610,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "pizza",
    pascal_name: "Pizza",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: [
      "fast food",
      "party",
      "places",
      "locations",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 59286,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "placeholder",
    pascal_name: "Placeholder",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["empty", "notdef", "tofu", "rectangle slash", "missing"],
    codepoint: 58960,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "planet",
    pascal_name: "Planet",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["saturn", "world", "globe", "astronomy", "space"],
    codepoint: 58962,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "plant",
    pascal_name: "Plant",
    categories: [e.COMMERCE, e.NATURE],
    figma_category: a.WEATHER,
    tags: ["sprout", "vegan", "farm", "farming", "garden", "gardening"],
    codepoint: 60334,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "play",
    pascal_name: "Play",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "resume", "start"],
    codepoint: 58320,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "play-circle",
    pascal_name: "PlayCircle",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "resume", "start", "round"],
    codepoint: 58322,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "play-pause",
    pascal_name: "PlayPause",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "resume", "start", "stop"],
    codepoint: 59582,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "playlist",
    pascal_name: "Playlist",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["*updated*", "music", "audio", "queue"],
    codepoint: 59050,
    published_in: 1.3,
    updated_in: 2.1
  },
  {
    name: "plug",
    pascal_name: "Plug",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["outlet", "socket", "plugin", "integration"],
    codepoint: 59718,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "plug-charging",
    pascal_name: "PlugCharging",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["outlet", "socket", "plugin", "integration", "charge", "charging"],
    codepoint: 60252,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "plugs",
    pascal_name: "Plugs",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["outlet", "socket", "plugin", "integration", "disconnected"],
    codepoint: 60246,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "plugs-connected",
    pascal_name: "PlugsConnected",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SYSTEM,
    tags: ["*updated*", "outlet", "socket", "plugin", "integration"],
    codepoint: 60250,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "plus",
    pascal_name: "Plus",
    categories: [
      e.DEVELOPMENT,
      e.FINANCE,
      e.SYSTEM
    ],
    figma_category: a.FINANCE,
    tags: ["addition", "sum", "mathematics", "arithmetic", "calculator", "+"],
    codepoint: 58324,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "plus-circle",
    pascal_name: "PlusCircle",
    categories: [
      e.DEVELOPMENT,
      e.FINANCE,
      e.SYSTEM
    ],
    figma_category: a.FINANCE,
    tags: [
      "addition",
      "sum",
      "mathematics",
      "arithmetic",
      "calculator",
      "round",
      "+"
    ],
    codepoint: 58326,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "plus-minus",
    pascal_name: "PlusMinus",
    categories: [e.DEVELOPMENT, e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "plus or minus",
      "plus/minus",
      "add/subtract",
      "addition",
      "sum",
      "subtraction",
      "difference",
      "mathematics",
      "arithmetic",
      "calculator",
      "+",
      "-",
      "±"
    ],
    codepoint: 58328,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "plus-square",
    pascal_name: "PlusSquare",
    categories: [
      e.FINANCE,
      e.DEVELOPMENT,
      e.SYSTEM
    ],
    figma_category: a.FINANCE,
    tags: ["addition", "sum", "mathematics", "arithmetic", "calculator", "+"],
    codepoint: 60746,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "poker-chip",
    pascal_name: "PokerChip",
    categories: [e.GAMES],
    figma_category: a.GAMES,
    tags: ["chips", "tokens", "cards", "gambling", "casino"],
    codepoint: 58772,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "police-car",
    pascal_name: "PoliceCar",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["*updated*", "vehicles", "cars", "automobiles", "law enforcement"],
    codepoint: 60490,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "polygon",
    pascal_name: "Polygon",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["shapes", "drawing"],
    codepoint: 59088,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "popcorn",
    pascal_name: "Popcorn",
    categories: [e.MAP, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["food", "movies", "theater"],
    codepoint: 60238,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "popsicle",
    pascal_name: "Popsicle",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: ["*new*", "ice cream", "dessert", "summer", "food"],
    codepoint: 60350,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "potted-plant",
    pascal_name: "PottedPlant",
    categories: [e.COMMERCE, e.NATURE],
    figma_category: a.COMMERCE,
    tags: ["sprout", "vegan", "garden", "gardening"],
    codepoint: 60450,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "power",
    pascal_name: "Power",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "charged",
      "charger",
      "charging",
      "on",
      "off",
      "on/off",
      "switch",
      "power switch"
    ],
    codepoint: 58330,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "prescription",
    pascal_name: "Prescription",
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: [
      "rx",
      "medicine",
      "drugs",
      "pharmacy",
      "pharmacist",
      "pharmaceuticals",
      "doctor"
    ],
    codepoint: 59298,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "presentation",
    pascal_name: "Presentation",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.OFFICE,
    tags: [
      "whiteboard",
      "flipchart",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "meeting"
    ],
    codepoint: 58964,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "presentation-chart",
    pascal_name: "PresentationChart",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.OFFICE,
    tags: [
      "whiteboard",
      "flipchart",
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "meeting"
    ],
    codepoint: 58966,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "printer",
    pascal_name: "Printer",
    categories: [e.EDITOR, e.OFFICE],
    figma_category: a.OFFICE,
    tags: ["printing"],
    codepoint: 58332,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "prohibit",
    pascal_name: "Prohibit",
    categories: [e.MAP, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "forbidden",
      "prohibited",
      "cancelled",
      "prevent",
      "stop",
      "do not enter"
    ],
    codepoint: 58334,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "prohibit-inset",
    pascal_name: "ProhibitInset",
    categories: [e.MAP, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "forbidden",
      "prohibited",
      "cancelled",
      "prevent",
      "stop",
      "do not enter"
    ],
    codepoint: 58336,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "projector-screen",
    pascal_name: "ProjectorScreen",
    categories: [e.FINANCE, e.MEDIA, e.OFFICE],
    figma_category: a.OFFICE,
    tags: [
      "projection",
      "presentation",
      "slideshow",
      "movies",
      "charts",
      "statistics",
      "analyze",
      "analysis"
    ],
    codepoint: 58968,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "projector-screen-chart",
    pascal_name: "ProjectorScreenChart",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.OFFICE,
    tags: [
      "projection",
      "presentation",
      "slideshow",
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis"
    ],
    codepoint: 58970,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "pulse",
    pascal_name: "Pulse",
    alias: { name: "activity", pascal_name: "Activity" },
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: [
      "activity",
      "heartbeat",
      "medical",
      "ecg",
      "ekg",
      "vitals",
      "monitor",
      "medicine"
    ],
    codepoint: 57344,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "push-pin",
    pascal_name: "PushPin",
    categories: [e.OFFICE, e.MAP, e.OBJECTS],
    figma_category: a.OFFICE,
    tags: ["favorites", "favorited", "pushpin"],
    codepoint: 58338,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "push-pin-simple",
    pascal_name: "PushPinSimple",
    categories: [e.OFFICE, e.MAP, e.OBJECTS],
    figma_category: a.OFFICE,
    tags: ["favorites", "favorited", "pushpin"],
    codepoint: 58972,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "push-pin-simple-slash",
    pascal_name: "PushPinSimpleSlash",
    categories: [e.OFFICE, e.MAP, e.OBJECTS],
    figma_category: a.OFFICE,
    tags: ["favorites", "favorited", "pushpin", "disabled"],
    codepoint: 58974,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "push-pin-slash",
    pascal_name: "PushPinSlash",
    categories: [e.OFFICE, e.MAP, e.OBJECTS],
    figma_category: a.OFFICE,
    tags: ["favorites", "favorited", "pushpin", "disabled"],
    codepoint: 58340,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "puzzle-piece",
    pascal_name: "PuzzlePiece",
    categories: [e.GAMES, e.DEVELOPMENT],
    figma_category: a.GAMES,
    tags: ["board game", "element", "component", "extension", "plugin"],
    codepoint: 58774,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "qr-code",
    pascal_name: "QrCode",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["upc", "barcode", "products", "shopping", "scanner"],
    codepoint: 58342,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "question",
    pascal_name: "Question",
    categories: [e.SYSTEM],
    figma_category: a.SECURITY,
    tags: ["information", "help", "support", "questions"],
    codepoint: 58344,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "question-mark",
    pascal_name: "QuestionMark",
    categories: [e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "*new*",
      "?",
      "information",
      "help",
      "support",
      "questions",
      "punctuation",
      "symbol"
    ],
    codepoint: 58344,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "queue",
    pascal_name: "Queue",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["*updated*", "music", "audio", "playlist"],
    codepoint: 59052,
    published_in: 1.3,
    updated_in: 2.1
  },
  {
    name: "quotes",
    pascal_name: "Quotes",
    categories: [
      e.COMMUNICATION,
      e.EDITOR,
      e.MEDIA
    ],
    figma_category: a.COMMUNICATION,
    tags: ["quoations", "quotation marks", "double-quotes", "writing", "books"],
    codepoint: 58976,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "rabbit",
    pascal_name: "Rabbit",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["*new*", "hare", "fast", "animal"],
    codepoint: 60098,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "racquet",
    pascal_name: "Racquet",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "sports", "tennis", "squash", "pickleball"],
    codepoint: 60930,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "radical",
    pascal_name: "Radical",
    categories: [e.DEVELOPMENT, e.FINANCE],
    figma_category: a.FINANCE,
    tags: [
      "√",
      "radix",
      "radicand",
      "square root",
      "squareroot",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58346,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "radio",
    pascal_name: "Radio",
    categories: [
      e.COMMUNICATION,
      e.MEDIA,
      e.OBJECTS
    ],
    figma_category: a.COMMUNICATION,
    tags: ["broadcast", "fm", "am", "xm", "transmitter", "receiver"],
    codepoint: 59262,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "radio-button",
    pascal_name: "RadioButton",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["input", "checkbox", "checked"],
    codepoint: 60168,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "radioactive",
    pascal_name: "Radioactive",
    categories: [e.NATURE, e.HEALTH],
    figma_category: a.SECURITY,
    tags: ["radiation", "danger", "warning", "nuclear", "atomic"],
    codepoint: 59868,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "rainbow",
    pascal_name: "Rainbow",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["meteorology", "rainstorm", "arc", "pride", "lgbtq+", "leprechaun"],
    codepoint: 58776,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "rainbow-cloud",
    pascal_name: "RainbowCloud",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: [
      "meteorology",
      "rainstorm",
      "cloudy",
      "partly cloudy",
      "partly sunny",
      "pride",
      "lgbtq+",
      "leprechaun"
    ],
    codepoint: 58778,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "ranking",
    pascal_name: "Ranking",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*new*", "medal", "rank", "leaderboard", "winner", "sports"],
    codepoint: 60770,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "read-cv-logo",
    pascal_name: "ReadCvLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["resume", "jobs", "logos"],
    codepoint: 60684,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "receipt",
    pascal_name: "Receipt",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["purchase", "money", "clipping", "expense"],
    codepoint: 58348,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "receipt-x",
    pascal_name: "ReceiptX",
    categories: [e.COMMERCE, e.FINANCE],
    figma_category: a.COMMERCE,
    tags: ["purchase", "money", "clipping", "expense", "cancel"],
    codepoint: 60736,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "record",
    pascal_name: "Record",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "recording", "recorder", "voice memo"],
    codepoint: 58350,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "rectangle",
    pascal_name: "Rectangle",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["4", "shapes", "polygons", "box"],
    codepoint: 58352,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "rectangle-dashed",
    pascal_name: "RectangleDashed",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["*new*", "4", "shapes", "polygons", "box", "missing"],
    codepoint: 58354,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "recycle",
    pascal_name: "Recycle",
    categories: [e.ARROWS, e.NATURE],
    figma_category: a.ARROWS,
    tags: ["recycling", "trash", "environmental", "green"],
    codepoint: 59226,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "reddit-logo",
    pascal_name: "RedditLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "subreddit", "snoo", "social media"],
    codepoint: 58780,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "repeat",
    pascal_name: "Repeat",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "recycle"],
    codepoint: 58358,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "repeat-once",
    pascal_name: "RepeatOnce",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "recycle"],
    codepoint: 58360,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "replit-logo",
    pascal_name: "ReplitLogo",
    categories: [e.BRAND, e.DEVELOPMENT],
    figma_category: a.BRAND,
    tags: ["*new*", "logos", "ide", "editor", "coding"],
    codepoint: 60298,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "resize",
    pascal_name: "Resize",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["*new*", "maximize", "expand", "grow"],
    codepoint: 60782,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "rewind",
    pascal_name: "Rewind",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "music",
      "audio",
      "seek",
      "scrub",
      "scan",
      "skip",
      "back",
      "backwards",
      "reverse"
    ],
    codepoint: 59048,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "rewind-circle",
    pascal_name: "RewindCircle",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "music",
      "audio",
      "seek",
      "scrub",
      "scan",
      "skip",
      "back",
      "backwards",
      "reverse"
    ],
    codepoint: 58362,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "road-horizon",
    pascal_name: "RoadHorizon",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["trip", "drive", "road", "travel", "transportation", "highway"],
    codepoint: 59448,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "robot",
    pascal_name: "Robot",
    categories: [e.DEVELOPMENT, e.OBJECTS],
    figma_category: a.DEVELOPMENT,
    tags: ["automaton", "artificial intelligence", "ai"],
    codepoint: 59234,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "rocket",
    pascal_name: "Rocket",
    categories: [
      e.DEVELOPMENT,
      e.MAP,
      e.OBJECTS
    ],
    figma_category: a.MAP,
    tags: ["spaceship", "launch", "deployment", "rocketship"],
    codepoint: 58364,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "rocket-launch",
    pascal_name: "RocketLaunch",
    categories: [
      e.DEVELOPMENT,
      e.MAP,
      e.OBJECTS
    ],
    figma_category: a.MAP,
    tags: [
      "*updated*",
      "spaceship",
      "flying",
      "blastoff",
      "deployment",
      "rocketship"
    ],
    codepoint: 58366,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "rows",
    pascal_name: "Rows",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["2", "shapes", "polygons", "box", "stack", "list", "table", "cards"],
    codepoint: 58786,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "rows-plus-bottom",
    pascal_name: "RowsPlusBottom",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: [
      "*new*",
      "2",
      "shapes",
      "polygons",
      "box",
      "stack",
      "list",
      "table",
      "cards",
      "prepend",
      "insert"
    ],
    codepoint: 58782,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "rows-plus-top",
    pascal_name: "RowsPlusTop",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: [
      "*new*",
      "2",
      "shapes",
      "polygons",
      "box",
      "stack",
      "list",
      "table",
      "cards",
      "prepend",
      "insert"
    ],
    codepoint: 58784,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "rss",
    pascal_name: "Rss",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["radio", "broadcast", "web feed", "news", "aggregator"],
    codepoint: 58368,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "rss-simple",
    pascal_name: "RssSimple",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["radio", "broadcast", "web feed", "news", "aggregator"],
    codepoint: 58370,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "rug",
    pascal_name: "Rug",
    categories: [e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*updated*", "tapestry", "carpet"],
    codepoint: 59930,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "ruler",
    pascal_name: "Ruler",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.OBJECTS
    ],
    figma_category: a.DESIGN,
    tags: ["measure", "scale", "distance"],
    codepoint: 59064,
    published_in: 1.3,
    updated_in: 1.4
  },
  {
    name: "sailboat",
    pascal_name: "Sailboat",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "sailing",
      "ship",
      "vehicles",
      "transportation",
      "sports",
      "places",
      "locations"
    ],
    codepoint: 59274,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "scales",
    pascal_name: "Scales",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["measure", "balance", "law", "justice", "government"],
    codepoint: 59216,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "scan",
    pascal_name: "Scan",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["upc", "barcode", "products", "shopping", "scanner"],
    codepoint: 60342,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "scan-smiley",
    pascal_name: "ScanSmiley",
    categories: [e.SYSTEM, e.PEOPLE],
    figma_category: a.SYSTEM,
    tags: ["*new*", "facial recognition", "face unlock", "scanner"],
    codepoint: 60340,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "scissors",
    pascal_name: "Scissors",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.OFFICE,
      e.SYSTEM
    ],
    figma_category: a.DESIGN,
    tags: ["*updated*", "cut", "snip", "clipboard"],
    codepoint: 60128,
    published_in: 1.1,
    updated_in: 2.1
  },
  {
    name: "scooter",
    pascal_name: "Scooter",
    categories: [e.MAP, e.HEALTH],
    figma_category: a.MAP,
    tags: ["vehicles", "transportation", "travel", "transit"],
    codepoint: 59424,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "screencast",
    pascal_name: "Screencast",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "apple",
      "airplay",
      "screencasting",
      "screen share",
      "television",
      "tv"
    ],
    codepoint: 58372,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "screwdriver",
    pascal_name: "Screwdriver",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "tools", "construction", "flathead", "drill"],
    codepoint: 59502,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "scribble",
    pascal_name: "Scribble",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["*new*", "doodles", "squiggle", "drawing", "sign", "signature"],
    codepoint: 59398,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "scribble-loop",
    pascal_name: "ScribbleLoop",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["doodles", "drawing", "sign", "signature"],
    codepoint: 58978,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "scroll",
    pascal_name: "Scroll",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*updated*", "parchment", "paper", "script", "spell", "fantasy"],
    codepoint: 60282,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "seal",
    pascal_name: "Seal",
    alias: { name: "circle-wavy", pascal_name: "CircleWavy" },
    categories: [e.DESIGN],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "verified",
      "verification",
      "shapes",
      "polygons",
      "circle-wavy"
    ],
    codepoint: 58884,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "seal-check",
    pascal_name: "SealCheck",
    alias: { name: "circle-wavy-check", pascal_name: "CircleWavyCheck" },
    categories: [e.DESIGN],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "verified",
      "verification",
      "shapes",
      "polygons",
      "circle-wavy"
    ],
    codepoint: 58886,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "seal-percent",
    pascal_name: "SealPercent",
    categories: [e.DESIGN],
    figma_category: a.SECURITY,
    tags: [
      "*new*",
      "badge",
      "discount",
      "sale",
      "shapes",
      "polygons",
      "circle-wavy"
    ],
    codepoint: 58890,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "seal-question",
    pascal_name: "SealQuestion",
    alias: { name: "circle-wavy-question", pascal_name: "CircleWavyQuestion" },
    categories: [e.DESIGN],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "unverified",
      "verification",
      "shapes",
      "polygons",
      "circle-wavy"
    ],
    codepoint: 58888,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "seal-warning",
    pascal_name: "SealWarning",
    alias: { name: "circle-wavy-warning", pascal_name: "CircleWavyWarning" },
    categories: [e.DESIGN],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "unverified",
      "verification",
      "errors",
      "shapes",
      "polygons",
      "circle-wavy"
    ],
    codepoint: 58892,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "seat",
    pascal_name: "Seat",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "chair",
      "car seat",
      "airplane seat",
      "transit",
      "transportation",
      "traveling"
    ],
    codepoint: 60302,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "seatbelt",
    pascal_name: "Seatbelt",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "vehicles", "safety"],
    codepoint: 60926,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "security-camera",
    pascal_name: "SecurityCamera",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "*new*",
      "cctv",
      "surveillance",
      "video",
      "monitor",
      "motion detector",
      "safety"
    ],
    codepoint: 60580,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "selection",
    pascal_name: "Selection",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["marquis", "select", "square dashed"],
    codepoint: 59034,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "selection-all",
    pascal_name: "SelectionAll",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["marquis", "select all"],
    codepoint: 59206,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "selection-background",
    pascal_name: "SelectionBackground",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["marquis"],
    codepoint: 60152,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "selection-foreground",
    pascal_name: "SelectionForeground",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["marquis"],
    codepoint: 60150,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "selection-inverse",
    pascal_name: "SelectionInverse",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["marquis", "invert"],
    codepoint: 59204,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "selection-plus",
    pascal_name: "SelectionPlus",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["marquis", "add"],
    codepoint: 59036,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "selection-slash",
    pascal_name: "SelectionSlash",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["marquis", "unselect"],
    codepoint: 59038,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "shapes",
    pascal_name: "Shapes",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["geometry", "square", "circle", "triangle"],
    codepoint: 60510,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "share",
    pascal_name: "Share",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["send to", "export", "arrows"],
    codepoint: 58374,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "share-fat",
    pascal_name: "ShareFat",
    categories: [
      e.ARROWS,
      e.SYSTEM,
      e.COMMUNICATION
    ],
    figma_category: a.COMMUNICATION,
    tags: ["export", "send to"],
    codepoint: 60754,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "share-network",
    pascal_name: "ShareNetwork",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["send to", "export"],
    codepoint: 58376,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shield",
    pascal_name: "Shield",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "security",
      "secured",
      "defense",
      "defended",
      "authentication",
      "authenticated",
      "guarded",
      "locked",
      "encrypted",
      "encryption"
    ],
    codepoint: 58378,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shield-check",
    pascal_name: "ShieldCheck",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "security",
      "defense",
      "authentication",
      "authenticated",
      "guarded",
      "locked",
      "encrypted",
      "encryption"
    ],
    codepoint: 58380,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shield-checkered",
    pascal_name: "ShieldCheckered",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "security",
      "defense",
      "authentication",
      "authenticated",
      "guarded",
      "locked",
      "encrypted",
      "encryption"
    ],
    codepoint: 59144,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "shield-chevron",
    pascal_name: "ShieldChevron",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "security",
      "defense",
      "authentication",
      "authenticated",
      "guarded",
      "locked",
      "encrypted",
      "encryption"
    ],
    codepoint: 58382,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shield-plus",
    pascal_name: "ShieldPlus",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "security",
      "defense",
      "authentication",
      "authenticated",
      "guarded",
      "locked",
      "encrypted",
      "encryption"
    ],
    codepoint: 59142,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "shield-slash",
    pascal_name: "ShieldSlash",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "security",
      "unsecured",
      "defense",
      "undefended",
      "authentication",
      "unauthenticated",
      "unguarded",
      "unlocked",
      "unencrypted",
      "encryption",
      "disabled"
    ],
    codepoint: 58384,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shield-star",
    pascal_name: "ShieldStar",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "security",
      "defense",
      "authentication",
      "authenticated",
      "guarded",
      "locked",
      "encrypted",
      "encryption"
    ],
    codepoint: 60468,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "shield-warning",
    pascal_name: "ShieldWarning",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.SECURITY,
    tags: [
      "badge",
      "security",
      "unsecured",
      "defense",
      "undefended",
      "authentication",
      "unauthenticated",
      "unguarded",
      "unlocked",
      "unencrypted",
      "encryption",
      "errors"
    ],
    codepoint: 58386,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shipping-container",
    pascal_name: "ShippingContainer",
    categories: [e.MAP, e.OBJECTS, e.COMMERCE],
    figma_category: a.MAP,
    tags: ["*new*", "shipping", "transportation", "places", "locations"],
    codepoint: 59276,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "shirt-folded",
    pascal_name: "ShirtFolded",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["clothes", "clothing"],
    codepoint: 60050,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "shooting-star",
    pascal_name: "ShootingStar",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["wish", "comet", "meteor"],
    codepoint: 60666,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "shopping-bag",
    pascal_name: "ShoppingBag",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "ecommerce",
      "market",
      "basket",
      "cart",
      "buying",
      "checkout",
      "places",
      "locations"
    ],
    codepoint: 58390,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shopping-bag-open",
    pascal_name: "ShoppingBagOpen",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "ecommerce",
      "market",
      "basket",
      "cart",
      "buying",
      "checkout",
      "places",
      "locations"
    ],
    codepoint: 58392,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shopping-cart",
    pascal_name: "ShoppingCart",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "ecommerce",
      "market",
      "basket",
      "buying",
      "groceries",
      "checkout",
      "places",
      "locations"
    ],
    codepoint: 58398,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shopping-cart-simple",
    pascal_name: "ShoppingCartSimple",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "ecommerce",
      "market",
      "basket",
      "buying",
      "groceries",
      "checkout",
      "places",
      "locations"
    ],
    codepoint: 58400,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shovel",
    pascal_name: "Shovel",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "tools", "digging", "construction"],
    codepoint: 59878,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "shower",
    pascal_name: "Shower",
    categories: [e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["bath", "bathtub", "bathroom", "faucet"],
    codepoint: 59254,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "shrimp",
    pascal_name: "Shrimp",
    categories: [e.COMMERCE, e.NATURE],
    figma_category: a.WEATHER,
    tags: ["food", "seafood", "prawn"],
    codepoint: 60084,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "shuffle",
    pascal_name: "Shuffle",
    categories: [e.MEDIA, e.ARROWS, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "randomize", "crossed"],
    codepoint: 58402,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shuffle-angular",
    pascal_name: "ShuffleAngular",
    categories: [e.MEDIA, e.ARROWS, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "randomize", "crossed"],
    codepoint: 58404,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "shuffle-simple",
    pascal_name: "ShuffleSimple",
    categories: [e.MEDIA, e.ARROWS, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "randomize", "crossed"],
    codepoint: 58406,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "sidebar",
    pascal_name: "Sidebar",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["left rail", "wireframe", "ui", "interface"],
    codepoint: 60086,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "sidebar-simple",
    pascal_name: "SidebarSimple",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["left rail", "wireframe", "ui", "interface"],
    codepoint: 60452,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "sigma",
    pascal_name: "Sigma",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: ["σ", "symbol", "mathematics", "sum"],
    codepoint: 60088,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "sign-in",
    pascal_name: "SignIn",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*updated*", "signin", "login", "log in", "enter"],
    codepoint: 58408,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "sign-out",
    pascal_name: "SignOut",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*updated*", "signout", "logout", "log out", "exit"],
    codepoint: 58410,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "signature",
    pascal_name: "Signature",
    categories: [e.COMMUNICATION, e.OFFICE],
    figma_category: a.COMMUNICATION,
    tags: ["*updated*", "sign", "autograph", "verify"],
    codepoint: 60332,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "signpost",
    pascal_name: "Signpost",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["direction", "traffic", "road sign", "transit", "transportation"],
    codepoint: 59548,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "sim-card",
    pascal_name: "SimCard",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*updated*", "cellular", "cellphone", "mobile"],
    codepoint: 58980,
    published_in: 1.2,
    updated_in: 2.1
  },
  {
    name: "siren",
    pascal_name: "Siren",
    categories: [e.OBJECTS, e.MAP],
    figma_category: a.SECURITY,
    tags: ["alarm", "police", "lights", "warning"],
    codepoint: 59832,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "sketch-logo",
    pascal_name: "SketchLogo",
    categories: [e.DESIGN],
    figma_category: a.BRAND,
    tags: [
      "drawing",
      "art",
      "illustration",
      "ui",
      "interface",
      "prototype",
      "prototyping",
      "gemstone",
      "diamond"
    ],
    codepoint: 58412,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "skip-back",
    pascal_name: "SkipBack",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "music",
      "audio",
      "seek",
      "scrub",
      "scan",
      "back",
      "backwards",
      "reverse",
      "previous"
    ],
    codepoint: 58788,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "skip-back-circle",
    pascal_name: "SkipBackCircle",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "music",
      "audio",
      "seek",
      "scrub",
      "scan",
      "back",
      "backwards",
      "reverse",
      "previous"
    ],
    codepoint: 58414,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "skip-forward",
    pascal_name: "SkipForward",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "seek", "scrub", "scan", "ahead", "next"],
    codepoint: 58790,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "skip-forward-circle",
    pascal_name: "SkipForwardCircle",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "seek", "scrub", "scan", "ahead", "next"],
    codepoint: 58416,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "skull",
    pascal_name: "Skull",
    categories: [e.GAMES],
    figma_category: a.GAMES,
    tags: ["death", "dead", "kill"],
    codepoint: 59670,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "skype-logo",
    pascal_name: "SkypeLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["*new*", "chat", "video conference"],
    codepoint: 59612,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "slack-logo",
    pascal_name: "SlackLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "messaging"],
    codepoint: 58792,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "sliders",
    pascal_name: "Sliders",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "music",
      "audio",
      "faders",
      "filters",
      "equalizer",
      "volume",
      "settings",
      "preferences"
    ],
    codepoint: 58418,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "sliders-horizontal",
    pascal_name: "SlidersHorizontal",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "music",
      "audio",
      "faders",
      "filters",
      "equalizer",
      "volume",
      "settings",
      "preferences"
    ],
    codepoint: 58420,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "slideshow",
    pascal_name: "Slideshow",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["pictures", "images", "photography", "gallery", "carousel"],
    codepoint: 60722,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "smiley",
    pascal_name: "Smiley",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["face", "emoji", "happy", "grinning", "smiling"],
    codepoint: 58422,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "smiley-angry",
    pascal_name: "SmileyAngry",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["face", "emoji", "mad", "frown"],
    codepoint: 60514,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "smiley-blank",
    pascal_name: "SmileyBlank",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["face", "emoji", "unimpressed", "no face"],
    codepoint: 58424,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "smiley-meh",
    pascal_name: "SmileyMeh",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["face", "emoji", "unimpressed", "neutral"],
    codepoint: 58426,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "smiley-melting",
    pascal_name: "SmileyMelting",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "*new*",
      "face",
      "emoji",
      "embarrassment",
      "sarcasm",
      "shame",
      "hot",
      "heat"
    ],
    codepoint: 61014,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "smiley-nervous",
    pascal_name: "SmileyNervous",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "*updated*",
      "face",
      "emoji",
      "anxious",
      "uncomfortable",
      "uneasy",
      "queasy",
      "sick",
      "ill"
    ],
    codepoint: 58428,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "smiley-sad",
    pascal_name: "SmileySad",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["face", "emoji", "unhappy", "frowning"],
    codepoint: 58430,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "smiley-sticker",
    pascal_name: "SmileySticker",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["face", "emoji", "happy", "grinning", "smiling"],
    codepoint: 58432,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "smiley-wink",
    pascal_name: "SmileyWink",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["face", "emoji", "winking", "flirting", "cute"],
    codepoint: 58982,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "smiley-x-eyes",
    pascal_name: "SmileyXEyes",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["face", "emoji", "dead", "killed", "unconscious"],
    codepoint: 58434,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "snapchat-logo",
    pascal_name: "SnapchatLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "messaging", "social media"],
    codepoint: 58984,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "sneaker",
    pascal_name: "Sneaker",
    categories: [
      e.COMMERCE,
      e.OBJECTS,
      e.HEALTH
    ],
    figma_category: a.COMMERCE,
    tags: ["clothes", "clothing", "shoes", "trainers", "sports"],
    codepoint: 59404,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "sneaker-move",
    pascal_name: "SneakerMove",
    categories: [
      e.COMMERCE,
      e.OBJECTS,
      e.HEALTH
    ],
    figma_category: a.COMMERCE,
    tags: ["*updated*", "clothes", "clothing", "shoes", "trainers", "sports"],
    codepoint: 60768,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "snowflake",
    pascal_name: "Snowflake",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["meteorology", "snowy", "snowing", "snowstorm"],
    codepoint: 58794,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "soccer-ball",
    pascal_name: "SoccerBall",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["*updated*", "sports", "football", "mls"],
    codepoint: 59158,
    published_in: 1.3,
    updated_in: 2.1
  },
  {
    name: "sock",
    pascal_name: "Sock",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "clothes", "clothing"],
    codepoint: 60622,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "solar-panel",
    pascal_name: "SolarPanel",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "renewable", "energy", "power", "electricity"],
    codepoint: 60794,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "solar-roof",
    pascal_name: "SolarRoof",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "renewable", "energy", "power", "electricity"],
    codepoint: 60794,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "sort-ascending",
    pascal_name: "SortAscending",
    categories: [e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "*updated*",
      "sorted",
      "sorting",
      "increasing",
      "a to z",
      "arrows",
      "list"
    ],
    codepoint: 58436,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "sort-descending",
    pascal_name: "SortDescending",
    categories: [e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "*updated*",
      "sorted",
      "sorting",
      "decreasing",
      "z to a",
      "arrows",
      "list"
    ],
    codepoint: 58438,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "soundcloud-logo",
    pascal_name: "SoundcloudLogo",
    categories: [e.BRAND, e.MEDIA],
    figma_category: a.BRAND,
    tags: ["music", "social media", "logos"],
    codepoint: 59614,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "spade",
    pascal_name: "Spade",
    categories: [e.GAMES],
    figma_category: a.GAMES,
    tags: ["spades", "suits", "cards", "gambling", "casino", "gaming"],
    codepoint: 58440,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "sparkle",
    pascal_name: "Sparkle",
    categories: [e.COMMUNICATION, e.NATURE],
    figma_category: a.WEATHER,
    tags: ["star", "rate", "ratings", "favorites", "favorited"],
    codepoint: 59042,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "speaker-hifi",
    pascal_name: "SpeakerHifi",
    categories: [e.MEDIA, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "sound", "stereo"],
    codepoint: 59912,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "speaker-high",
    pascal_name: "SpeakerHigh",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["*updated*", "music", "audio", "volume", "sound"],
    codepoint: 58442,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "speaker-low",
    pascal_name: "SpeakerLow",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["*updated*", "music", "audio", "volume", "sound"],
    codepoint: 58444,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "speaker-none",
    pascal_name: "SpeakerNone",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["*updated*", "music", "audio", "muted", "volume", "sound"],
    codepoint: 58446,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "speaker-simple-high",
    pascal_name: "SpeakerSimpleHigh",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "volume", "sound"],
    codepoint: 58448,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "speaker-simple-low",
    pascal_name: "SpeakerSimpleLow",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "volume", "sound"],
    codepoint: 58450,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "speaker-simple-none",
    pascal_name: "SpeakerSimpleNone",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "muted", "volume", "sound"],
    codepoint: 58452,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "speaker-simple-slash",
    pascal_name: "SpeakerSimpleSlash",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "muted", "volume", "sound", "disabled"],
    codepoint: 58454,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "speaker-simple-x",
    pascal_name: "SpeakerSimpleX",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "muted", "volume", "sound", "disabled", "errors"],
    codepoint: 58456,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "speaker-slash",
    pascal_name: "SpeakerSlash",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "*updated*",
      "music",
      "audio",
      "muted",
      "volume",
      "sound",
      "disabled"
    ],
    codepoint: 58458,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "speaker-x",
    pascal_name: "SpeakerX",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: [
      "*updated*",
      "music",
      "audio",
      "muted",
      "volume",
      "sound",
      "disabled",
      "errors"
    ],
    codepoint: 58460,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "speedometer",
    pascal_name: "Speedometer",
    categories: [
      e.DEVELOPMENT,
      e.OBJECTS,
      e.SYSTEM
    ],
    figma_category: a.SYSTEM,
    tags: [
      "*new*",
      "gauge",
      "dashboard",
      "meter",
      "speed",
      "odometer",
      "performance"
    ],
    codepoint: 61044,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "sphere",
    pascal_name: "Sphere",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["*new*", "circle", "ball", "3d", "mesh", "cad", "model"],
    codepoint: 61030,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "spinner",
    pascal_name: "Spinner",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["loading", "loader", "waiting", "progress"],
    codepoint: 58986,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "spinner-ball",
    pascal_name: "SpinnerBall",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "loading", "loader", "waiting", "progress"],
    codepoint: 60968,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "spinner-gap",
    pascal_name: "SpinnerGap",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["loading", "loader", "waiting", "progress"],
    codepoint: 58988,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "spiral",
    pascal_name: "Spiral",
    categories: [e.COMMUNICATION, e.DESIGN],
    figma_category: a.GAMES,
    tags: ["*updated*", "spin", "rotate", "dizzy"],
    codepoint: 59898,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "split-horizontal",
    pascal_name: "SplitHorizontal",
    categories: [e.ARROWS, e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["resize", "columns"],
    codepoint: 59506,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "split-vertical",
    pascal_name: "SplitVertical",
    categories: [e.ARROWS, e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["resize", "rows"],
    codepoint: 59510,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "spotify-logo",
    pascal_name: "SpotifyLogo",
    categories: [e.BRAND, e.MEDIA],
    figma_category: a.BRAND,
    tags: ["music", "player", "streaming"],
    codepoint: 58990,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "spray-bottle",
    pascal_name: "SprayBottle",
    categories: [e.OBJECTS, e.HEALTH],
    figma_category: a.DESIGN,
    tags: ["*new*", "cleaner", "cleaning"],
    codepoint: 59364,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "square",
    pascal_name: "Square",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["4", "shapes", "polygons", "box"],
    codepoint: 58462,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "square-half",
    pascal_name: "SquareHalf",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: [
      "4",
      "shapes",
      "polygons",
      "box",
      "columns",
      "sidebar",
      "split vertical"
    ],
    codepoint: 58466,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "square-half-bottom",
    pascal_name: "SquareHalfBottom",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: [
      "4",
      "shapes",
      "polygons",
      "box",
      "columns",
      "sidebar",
      "split vertical"
    ],
    codepoint: 60182,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "square-logo",
    pascal_name: "SquareLogo",
    categories: [
      e.BRAND,
      e.COMMERCE,
      e.FINANCE
    ],
    figma_category: a.BRAND,
    tags: ["squareup", "payment"],
    codepoint: 59024,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "square-split-horizontal",
    pascal_name: "SquareSplitHorizontal",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["shapes", "polygons", "columns"],
    codepoint: 59504,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "square-split-vertical",
    pascal_name: "SquareSplitVertical",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["shapes", "polygons", "rows"],
    codepoint: 59508,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "squares-four",
    pascal_name: "SquaresFour",
    categories: [e.DESIGN, e.SYSTEM],
    figma_category: a.DESIGN,
    tags: [
      "4",
      "shapes",
      "polygons",
      "apps",
      "applications",
      "grid",
      "table",
      "microsoft",
      "logos"
    ],
    codepoint: 58468,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "stack",
    pascal_name: "Stack",
    categories: [e.DESIGN, e.OFFICE, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["cards", "layers"],
    codepoint: 58470,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "stack-minus",
    pascal_name: "StackMinus",
    categories: [e.DESIGN, e.OFFICE, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["*new*", "cards", "layers", "remove", "delete"],
    codepoint: 60916,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "stack-overflow-logo",
    pascal_name: "StackOverflowLogo",
    categories: [e.BRAND, e.DEVELOPMENT],
    figma_category: a.BRAND,
    tags: ["logos", "code"],
    codepoint: 60280,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "stack-plus",
    pascal_name: "StackPlus",
    categories: [e.DESIGN, e.OFFICE, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["*new*", "cards", "layers", "add"],
    codepoint: 60918,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "stack-simple",
    pascal_name: "StackSimple",
    categories: [e.DESIGN, e.OFFICE, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["cards", "layers"],
    codepoint: 58472,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "stairs",
    pascal_name: "Stairs",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["staircase", "steps", "escalator", "exit", "signs"],
    codepoint: 59628,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "stamp",
    pascal_name: "Stamp",
    categories: [e.DESIGN, e.OBJECTS],
    figma_category: a.DESIGN,
    tags: ["clone", "seal", "official"],
    codepoint: 59976,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "standard-definition",
    pascal_name: "StandardDefinition",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["*new*", "sd", "resolution", "video"],
    codepoint: 60048,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "star",
    pascal_name: "Star",
    categories: [
      e.COMMUNICATION,
      e.MAP,
      e.NATURE
    ],
    figma_category: a.COMMUNICATION,
    tags: ["rate", "ratings", "favorites", "favorited"],
    codepoint: 58474,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "star-and-crescent",
    pascal_name: "StarAndCrescent",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.COMMUNICATION,
    tags: ["islam", "muslim", "moon", "religion", "worship", "symbol"],
    codepoint: 60660,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "star-four",
    pascal_name: "StarFour",
    categories: [e.COMMUNICATION, e.NATURE],
    figma_category: a.WEATHER,
    tags: ["rate", "ratings", "favorites", "favorited"],
    codepoint: 59044,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "star-half",
    pascal_name: "StarHalf",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["rate", "ratings"],
    codepoint: 59146,
    published_in: 1.3,
    updated_in: 1.4
  },
  {
    name: "star-of-david",
    pascal_name: "StarOfDavid",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.COMMUNICATION,
    tags: ["judaism", "jewish", "hexagram", "religion", "worship", "symbol"],
    codepoint: 59550,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "steam-logo",
    pascal_name: "SteamLogo",
    categories: [e.BRAND, e.GAMES],
    figma_category: a.BRAND,
    tags: ["*new*", "gaming", "games"],
    codepoint: 60116,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "steering-wheel",
    pascal_name: "SteeringWheel",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["cars", "vehicles", "automobiles", "driving"],
    codepoint: 59820,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "steps",
    pascal_name: "Steps",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["stairs", "staircase", "exit", "signs"],
    codepoint: 60606,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "stethoscope",
    pascal_name: "Stethoscope",
    categories: [e.HEALTH, e.OBJECTS],
    figma_category: a.HEALTH,
    tags: [
      "hospital",
      "medical",
      "medicine",
      "injury",
      "safety",
      "emergency",
      "doctor",
      "heart"
    ],
    codepoint: 59370,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "sticker",
    pascal_name: "Sticker",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["stickers", "sticker pack", "labels"],
    codepoint: 58796,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "stool",
    pascal_name: "Stool",
    categories: [e.OBJECTS, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["chair", "seat", "furniture"],
    codepoint: 59972,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "stop",
    pascal_name: "Stop",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio"],
    codepoint: 58476,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "stop-circle",
    pascal_name: "StopCircle",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["music", "audio", "round"],
    codepoint: 58478,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "storefront",
    pascal_name: "Storefront",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: [
      "shops",
      "shopping",
      "markets",
      "stores",
      "buildings",
      "places",
      "locations"
    ],
    codepoint: 58480,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "strategy",
    pascal_name: "Strategy",
    categories: [e.GAMES, e.FINANCE],
    figma_category: a.GAMES,
    tags: ["sports", "strategem", "plan", "tic-tac-toe"],
    codepoint: 59962,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "stripe-logo",
    pascal_name: "StripeLogo",
    categories: [
      e.BRAND,
      e.COMMERCE,
      e.FINANCE
    ],
    figma_category: a.BRAND,
    tags: ["payment"],
    codepoint: 59032,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "student",
    pascal_name: "Student",
    categories: [e.PEOPLE],
    figma_category: a.EDUCATION,
    tags: [
      "pupil",
      "graduate",
      "classroom",
      "teacher",
      "education",
      "school",
      "college",
      "university"
    ],
    codepoint: 59198,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "subset-of",
    pascal_name: "SubsetOf",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "⊆",
      "subset of",
      "set",
      "member",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60864,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "subset-proper-of",
    pascal_name: "SubsetProperOf",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "⊂",
      "proper subset of",
      "set",
      "member",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60854,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "subtitles",
    pascal_name: "Subtitles",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: [
      "subtitles",
      "television",
      "tv",
      "transcribed",
      "transcription",
      "accessibility",
      "a11y"
    ],
    codepoint: 57768,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "subtitles-slash",
    pascal_name: "SubtitlesSlash",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: [
      "*new*",
      "subtitles",
      "television",
      "tv",
      "transcribed",
      "transcription",
      "accessibility",
      "a11y",
      "disabled"
    ],
    codepoint: 57766,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "subtract",
    pascal_name: "Subtract",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["boolean", "intersection", "combine", "split", "merge", "union"],
    codepoint: 60374,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "subtract-square",
    pascal_name: "SubtractSquare",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["boolean", "intersection", "combine", "split", "merge", "union"],
    codepoint: 60372,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "subway",
    pascal_name: "Subway",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "*new*",
      "vehicles",
      "underground",
      "train",
      "tunnel",
      "metro",
      "light rail",
      "public transit",
      "transportation",
      "commuter",
      "traveling",
      "places",
      "locations"
    ],
    codepoint: 58520,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "suitcase",
    pascal_name: "Suitcase",
    categories: [e.OFFICE, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["briefcase", "valise", "baggage", "folders", "portfolio"],
    codepoint: 58798,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "suitcase-rolling",
    pascal_name: "SuitcaseRolling",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["suitcase", "luggage", "travel", "transportation"],
    codepoint: 59824,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "suitcase-simple",
    pascal_name: "SuitcaseSimple",
    categories: [e.OFFICE, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["briefcase", "valise", "baggage", "folders", "portfolio"],
    codepoint: 58800,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "sun",
    pascal_name: "Sun",
    categories: [
      e.NATURE,
      e.SYSTEM,
      e.WEATHER
    ],
    figma_category: a.WEATHER,
    tags: [
      "day",
      "daytime",
      "daylight",
      "clear",
      "sunny",
      "sunshine",
      "light mode",
      "brightness",
      "lighten",
      "brighten"
    ],
    codepoint: 58482,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "sun-dim",
    pascal_name: "SunDim",
    categories: [
      e.NATURE,
      e.SYSTEM,
      e.WEATHER
    ],
    figma_category: a.WEATHER,
    tags: [
      "day",
      "daytime",
      "daylight",
      "clear",
      "sunny",
      "sunshine",
      "light mode",
      "brightness",
      "darken"
    ],
    codepoint: 58484,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "sun-horizon",
    pascal_name: "SunHorizon",
    categories: [e.NATURE, e.WEATHER],
    figma_category: a.WEATHER,
    tags: [
      "day",
      "daytime",
      "daylight",
      "clear",
      "sunny",
      "sunshine",
      "sunrise",
      "sunset"
    ],
    codepoint: 58806,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "sunglasses",
    pascal_name: "Sunglasses",
    categories: [e.HEALTH, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["vision", "sun", "spectacles"],
    codepoint: 59414,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "superset-of",
    pascal_name: "SupersetOf",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "⊇",
      "superset of",
      "set",
      "member",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60856,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "superset-proper-of",
    pascal_name: "SupersetProperOf",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "⊃",
      "proper superset of",
      "set",
      "member",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60852,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "swap",
    pascal_name: "Swap",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.SYSTEM,
    tags: ["layers", "replace", "exchange", "reverse"],
    codepoint: 59452,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "swatches",
    pascal_name: "Swatches",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.OBJECTS
    ],
    figma_category: a.DESIGN,
    tags: ["colors", "color picker", "samples", "pantone"],
    codepoint: 58808,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "swimming-pool",
    pascal_name: "SwimmingPool",
    categories: [e.HEALTH, e.MAP, e.GAMES],
    figma_category: a.MAP,
    tags: ["swim", "sports", "exercise", "olympics", "aquatics"],
    codepoint: 60598,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "sword",
    pascal_name: "Sword",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: [
      "weapon",
      "knife",
      "dagger",
      "gladius",
      "video games",
      "rpg",
      "gaming",
      "war"
    ],
    codepoint: 58810,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "synagogue",
    pascal_name: "Synagogue",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["jewish", "judaism", "temple", "religion", "worship"],
    codepoint: 60652,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "syringe",
    pascal_name: "Syringe",
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: [
      "needle",
      "hypodermic",
      "vaccine",
      "medicine",
      "doctor",
      "shot",
      "hospital"
    ],
    codepoint: 59752,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "t-shirt",
    pascal_name: "TShirt",
    categories: [e.OBJECTS, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["clothes", "clothing"],
    codepoint: 58992,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "table",
    pascal_name: "Table",
    categories: [
      e.FINANCE,
      e.OFFICE,
      e.EDITOR
    ],
    figma_category: a.FINANCE,
    tags: ["tables", "tabular", "speadsheets", "excel", "grid", "form"],
    codepoint: 58486,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "tabs",
    pascal_name: "Tabs",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*updated*", "browser", "window", "folders", "files"],
    codepoint: 59256,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "tag",
    pascal_name: "Tag",
    categories: [
      e.COMMERCE,
      e.DEVELOPMENT,
      e.OBJECTS
    ],
    figma_category: a.COMMERCE,
    tags: ["tags", "hashtag", "labels", "sale", "sell", "price", "discount"],
    codepoint: 58488,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "tag-chevron",
    pascal_name: "TagChevron",
    categories: [
      e.COMMERCE,
      e.DEVELOPMENT,
      e.OBJECTS
    ],
    figma_category: a.COMMERCE,
    tags: ["tags", "hashtag", "labels", "sale"],
    codepoint: 58994,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "tag-simple",
    pascal_name: "TagSimple",
    categories: [
      e.COMMERCE,
      e.DEVELOPMENT,
      e.OBJECTS
    ],
    figma_category: a.COMMERCE,
    tags: ["tags", "hashtag", "labels", "sale", "sell", "price", "discount"],
    codepoint: 58490,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "target",
    pascal_name: "Target",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["bullseye", "radar", "archery", "accuracy", "precision"],
    codepoint: 58492,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "taxi",
    pascal_name: "Taxi",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "*updated*",
      "vehicles",
      "cars",
      "automobiles",
      "livery",
      "limousine",
      "uber"
    ],
    codepoint: 59650,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "tea-bag",
    pascal_name: "TeaBag",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "drinks",
      "beverages",
      "sachet",
      "caffeine",
      "places",
      "locations",
      "bars",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 59622,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "telegram-logo",
    pascal_name: "TelegramLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "messages", "messaging"],
    codepoint: 58812,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "television",
    pascal_name: "Television",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["screen", "tv", "displays"],
    codepoint: 59220,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "television-simple",
    pascal_name: "TelevisionSimple",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["*updated*", "screen", "tv", "displays"],
    codepoint: 60134,
    published_in: 1.3,
    updated_in: 2.1
  },
  {
    name: "tennis-ball",
    pascal_name: "TennisBall",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["sports", "mlb"],
    codepoint: 59168,
    published_in: 1.3,
    updated_in: 1.4
  },
  {
    name: "tent",
    pascal_name: "Tent",
    categories: [
      e.HEALTH,
      e.OBJECTS,
      e.NATURE,
      e.MAP
    ],
    figma_category: a.MAP,
    tags: ["camping", "outdoors", "tarp"],
    codepoint: 59578,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "terminal",
    pascal_name: "Terminal",
    categories: [e.DEVELOPMENT, e.SYSTEM],
    figma_category: a.DEVELOPMENT,
    tags: ["command line", "cli", "bash", "shell", "caret", "console"],
    codepoint: 58494,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "terminal-window",
    pascal_name: "TerminalWindow",
    categories: [e.DEVELOPMENT, e.SYSTEM],
    figma_category: a.DEVELOPMENT,
    tags: ["command line", "cli", "bash", "shell", "caret", "console"],
    codepoint: 60136,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "test-tube",
    pascal_name: "TestTube",
    categories: [
      e.DEVELOPMENT,
      e.NATURE,
      e.HEALTH,
      e.OBJECTS
    ],
    figma_category: a.HEALTH,
    tags: ["science", "chemistry", "experiment", "vial"],
    codepoint: 59296,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "text-a-underline",
    pascal_name: "TextAUnderline",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["typography", "typeface", "print", "font", "underscore", "emphasis"],
    codepoint: 60724,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "text-aa",
    pascal_name: "TextAa",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["typography", "typeface", "print", "font"],
    codepoint: 59118,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "text-align-center",
    pascal_name: "TextAlignCenter",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["*updated*", "typography", "print", "font", "alignment", "centered"],
    codepoint: 58496,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "text-align-justify",
    pascal_name: "TextAlignJustify",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "*updated*",
      "typography",
      "print",
      "font",
      "alignment",
      "justified"
    ],
    codepoint: 58498,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "text-align-left",
    pascal_name: "TextAlignLeft",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "*updated*",
      "typography",
      "print",
      "font",
      "alignment",
      "flush left"
    ],
    codepoint: 58500,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "text-align-right",
    pascal_name: "TextAlignRight",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "*updated*",
      "typography",
      "print",
      "font",
      "alignment",
      "flush right"
    ],
    codepoint: 58502,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "text-b",
    pascal_name: "TextB",
    alias: { name: "text-bolder", pascal_name: "TextBolder" },
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "typography",
      "typeface",
      "print",
      "font",
      "bold",
      "boldface",
      "emphasis"
    ],
    codepoint: 58814,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "text-columns",
    pascal_name: "TextColumns",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["*updated*", "typography", "print", "font", "alignment", "article"],
    codepoint: 60566,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "text-h",
    pascal_name: "TextH",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["heading", "typography", "print"],
    codepoint: 59066,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "text-h-five",
    pascal_name: "TextHFive",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["heading", "h5", "typography", "print"],
    codepoint: 59076,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "text-h-four",
    pascal_name: "TextHFour",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["*updated*", "heading", "h4", "typography", "print"],
    codepoint: 59074,
    published_in: 1.3,
    updated_in: 2.1
  },
  {
    name: "text-h-one",
    pascal_name: "TextHOne",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["heading", "h1", "typography", "print"],
    codepoint: 59068,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "text-h-six",
    pascal_name: "TextHSix",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["heading", "h6", "typography", "print"],
    codepoint: 59078,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "text-h-three",
    pascal_name: "TextHThree",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["heading", "h3", "typography", "print"],
    codepoint: 59072,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "text-h-two",
    pascal_name: "TextHTwo",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["heading", "h2", "typography", "print"],
    codepoint: 59070,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "text-indent",
    pascal_name: "TextIndent",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["*updated*", "alignment", "tab", "menu"],
    codepoint: 59934,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "text-italic",
    pascal_name: "TextItalic",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "typography",
      "typeface",
      "print",
      "font",
      "slant",
      "oblique",
      "stress",
      "emphasis",
      "calligraphy"
    ],
    codepoint: 58816,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "text-outdent",
    pascal_name: "TextOutdent",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["*updated*", "alignment", "tab", "unindent", "dedent", "menu"],
    codepoint: 59932,
    published_in: 1.4,
    updated_in: 2.1
  },
  {
    name: "text-strikethrough",
    pascal_name: "TextStrikethrough",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "typography",
      "typeface",
      "print",
      "font",
      "struck",
      "remove",
      "delete",
      "change"
    ],
    codepoint: 58818,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "text-subscript",
    pascal_name: "TextSubscript",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.FINANCE
    ],
    figma_category: a.OFFICE,
    tags: [
      "*new*",
      "typography",
      "font",
      "formatting",
      "mathematics",
      "power",
      "exponent",
      "calculator"
    ],
    codepoint: 60568,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "text-superscript",
    pascal_name: "TextSuperscript",
    categories: [
      e.DESIGN,
      e.EDITOR,
      e.FINANCE
    ],
    figma_category: a.OFFICE,
    tags: [
      "*new*",
      "typography",
      "font",
      "formatting",
      "mathematics",
      "calculator"
    ],
    codepoint: 60570,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "text-t",
    pascal_name: "TextT",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["typography", "typeface", "print", "font"],
    codepoint: 58506,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "text-t-slash",
    pascal_name: "TextTSlash",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: [
      "*new*",
      "typography",
      "typeface",
      "print",
      "font",
      "formatting",
      "clear"
    ],
    codepoint: 58504,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "text-underline",
    pascal_name: "TextUnderline",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.OFFICE,
    tags: ["typography", "typeface", "print", "font", "underscore", "emphasis"],
    codepoint: 58820,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "textbox",
    pascal_name: "Textbox",
    categories: [e.EDITOR, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["input", "cursor", "field"],
    codepoint: 60170,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "thermometer",
    pascal_name: "Thermometer",
    categories: [
      e.WEATHER,
      e.HEALTH,
      e.OBJECTS
    ],
    figma_category: a.WEATHER,
    tags: [
      "meteorology",
      "temperature",
      "degrees",
      "°",
      "celcius",
      "centigrade",
      "kelvin",
      "fahrenheit",
      "hot",
      "warm",
      "cold"
    ],
    codepoint: 58822,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "thermometer-cold",
    pascal_name: "ThermometerCold",
    categories: [
      e.WEATHER,
      e.HEALTH,
      e.OBJECTS
    ],
    figma_category: a.WEATHER,
    tags: [
      "meteorology",
      "temperature",
      "degrees",
      "°",
      "celcius",
      "centigrade",
      "kelvin",
      "fahrenheit"
    ],
    codepoint: 58824,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "thermometer-hot",
    pascal_name: "ThermometerHot",
    categories: [
      e.WEATHER,
      e.HEALTH,
      e.OBJECTS
    ],
    figma_category: a.WEATHER,
    tags: [
      "meteorology",
      "temperature",
      "degrees",
      "°",
      "celcius",
      "centigrade",
      "kelvin",
      "fahrenheit",
      "warm"
    ],
    codepoint: 58826,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "thermometer-simple",
    pascal_name: "ThermometerSimple",
    categories: [
      e.WEATHER,
      e.HEALTH,
      e.OBJECTS
    ],
    figma_category: a.WEATHER,
    tags: [
      "meteorology",
      "temperature",
      "degrees",
      "°",
      "celcius",
      "centigrade",
      "kelvin",
      "fahrenheit",
      "hot",
      "warm",
      "cold"
    ],
    codepoint: 58828,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "threads-logo",
    pascal_name: "ThreadsLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["*new*", "meta", "instagram", "social media"],
    codepoint: 60830,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "three-d",
    pascal_name: "ThreeD",
    categories: [e.MEDIA, e.DEVELOPMENT],
    figma_category: a.MEDIA,
    tags: ["*new*", "3d", "cad", "model"],
    codepoint: 59994,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "thumbs-down",
    pascal_name: "ThumbsDown",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.COMMUNICATION,
    tags: ["dislike", "hate", "emoji", "no"],
    codepoint: 58508,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "thumbs-up",
    pascal_name: "ThumbsUp",
    categories: [e.COMMUNICATION, e.PEOPLE],
    figma_category: a.COMMUNICATION,
    tags: ["like", "love", "favorited", "favorites", "emoji", "yes"],
    codepoint: 58510,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "ticket",
    pascal_name: "Ticket",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["ticketstub", "movie ticket", "entry", "admissions", "events"],
    codepoint: 58512,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "tidal-logo",
    pascal_name: "TidalLogo",
    categories: [e.BRAND, e.MEDIA],
    figma_category: a.BRAND,
    tags: ["music", "logos"],
    codepoint: 60700,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "tiktok-logo",
    pascal_name: "TiktokLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "social media"],
    codepoint: 60146,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "tilde",
    pascal_name: "Tilde",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "~",
      "∼",
      "proportional",
      "comparison",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60840,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "timer",
    pascal_name: "Timer",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.TIME,
    tags: ["clock", "alarm", "schedule", "events", "stopwatch", "sports"],
    codepoint: 58514,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "tip-jar",
    pascal_name: "TipJar",
    categories: [
      e.COMMERCE,
      e.FINANCE,
      e.OBJECTS
    ],
    figma_category: a.COMMERCE,
    tags: ["*new*", "give", "deposit", "donation", "savings", "money"],
    codepoint: 59360,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "tipi",
    pascal_name: "Tipi",
    categories: [e.NATURE, e.OBJECTS, e.MAP],
    figma_category: a.MAP,
    tags: ["teepee", "lodge", "tent", "outdoors", "camping", "tarp"],
    codepoint: 60720,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "tire",
    pascal_name: "Tire",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "wheel", "vehicles", "transportation"],
    codepoint: 60882,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "toggle-left",
    pascal_name: "ToggleLeft",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["switch", "controls", "settings", "preferences"],
    codepoint: 58996,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "toggle-right",
    pascal_name: "ToggleRight",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["switch", "controls", "settings", "preferences"],
    codepoint: 58998,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "toilet",
    pascal_name: "Toilet",
    categories: [e.HEALTH, e.OBJECTS],
    figma_category: a.HEALTH,
    tags: ["bathroom", "restroom", "lavatory", "water closet"],
    codepoint: 59290,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "toilet-paper",
    pascal_name: "ToiletPaper",
    categories: [e.HEALTH, e.OBJECTS],
    figma_category: a.HEALTH,
    tags: ["bathroom", "restroom", "lavatory", "water closet"],
    codepoint: 59292,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "toolbox",
    pascal_name: "Toolbox",
    categories: [
      e.OBJECTS,
      e.SYSTEM,
      e.COMMERCE
    ],
    figma_category: a.COMMERCE,
    tags: ["tools", "carpentry", "construction"],
    codepoint: 60576,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "tooth",
    pascal_name: "Tooth",
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: ["teeth", "dentistry", "medical", "medicine", "doctor", "cavity"],
    codepoint: 59852,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "tornado",
    pascal_name: "Tornado",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["*new*", "meteorology", "twister", "storm", "wind", "disaster"],
    codepoint: 59532,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "tote",
    pascal_name: "Tote",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["suitcases", "valises", "baggage", "tote-bag", "portfolios"],
    codepoint: 58516,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "tote-simple",
    pascal_name: "ToteSimple",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["suitcases", "valises", "baggage", "tote-bag", "portfolios"],
    codepoint: 59e3,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "towel",
    pascal_name: "Towel",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "clothing",
      "linen",
      "hotel",
      "beach",
      "pool",
      "swimming",
      "shower",
      "bath"
    ],
    codepoint: 60902,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "tractor",
    pascal_name: "Tractor",
    categories: [e.COMMERCE, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "vehicles", "farmer", "field", "farming", "agriculture"],
    codepoint: 60526,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "trademark",
    pascal_name: "Trademark",
    categories: [e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["tm", "®", "™", "intellectual property"],
    codepoint: 59888,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "trademark-registered",
    pascal_name: "TrademarkRegistered",
    categories: [e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["®", "™", "intellectual property"],
    codepoint: 58356,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "traffic-cone",
    pascal_name: "TrafficCone",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["pylon", "safety", "transit", "transportation"],
    codepoint: 59816,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "traffic-sign",
    pascal_name: "TrafficSign",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["road signs", "transit", "transportation"],
    codepoint: 59002,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "traffic-signal",
    pascal_name: "TrafficSignal",
    categories: [e.MAP],
    figma_category: a.MAP,
    tags: ["stop light", "safety", "transit", "transportation"],
    codepoint: 59818,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "train",
    pascal_name: "Train",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "vehicles",
      "subway",
      "light rail",
      "public transit",
      "transportation",
      "commuter",
      "traveling",
      "places",
      "locations"
    ],
    codepoint: 58518,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "train-regional",
    pascal_name: "TrainRegional",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "vehicles",
      "subway",
      "railroad",
      "public transit",
      "transportation",
      "commuter",
      "freight",
      "shipping",
      "traveling",
      "places",
      "locations"
    ],
    codepoint: 58526,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "train-simple",
    pascal_name: "TrainSimple",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "vehicles",
      "subway",
      "light rail",
      "public transit",
      "transportation",
      "commuter",
      "traveling",
      "places",
      "locations"
    ],
    codepoint: 58528,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "tram",
    pascal_name: "Tram",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "vehicles",
      "subway",
      "railroad",
      "public transit",
      "transportation",
      "commuter",
      "light rail",
      "shipping",
      "traveling",
      "places",
      "locations"
    ],
    codepoint: 59884,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "translate",
    pascal_name: "Translate",
    categories: [e.COMMUNICATION, e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: [
      "translation",
      "languages",
      "internationalization",
      "i18n",
      "speech"
    ],
    codepoint: 58530,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "trash",
    pascal_name: "Trash",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["garbage", "remove", "delete", "destroy", "recycle", "recycling"],
    codepoint: 58534,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "trash-simple",
    pascal_name: "TrashSimple",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["garbage", "remove", "delete", "destroy", "recycle", "recycling"],
    codepoint: 58536,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "tray",
    pascal_name: "Tray",
    categories: [
      e.OFFICE,
      e.COMMUNICATION,
      e.SYSTEM
    ],
    figma_category: a.OFFICE,
    tags: ["inbox", "mailbox", "bin"],
    codepoint: 58538,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "tray-arrow-down",
    pascal_name: "TrayArrowDown",
    alias: { name: "archive-tray", pascal_name: "ArchiveTray" },
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: [
      "inbox",
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "downloaded",
      "downloading"
    ],
    codepoint: 57360,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "tray-arrow-up",
    pascal_name: "TrayArrowUp",
    categories: [e.OFFICE, e.SYSTEM],
    figma_category: a.OFFICE,
    tags: ["*new*", "outbox", "archival", "unarchive", "uploaded", "uploading"],
    codepoint: 61010,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "treasure-chest",
    pascal_name: "TreasureChest",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: [
      "*new*",
      "loot",
      "lootbox",
      "inventory",
      "rewards",
      "gaming",
      "pirate"
    ],
    codepoint: 60898,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "tree",
    pascal_name: "Tree",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: ["plants", "branches", "leaves", "green", "environmental"],
    codepoint: 59098,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "tree-evergreen",
    pascal_name: "TreeEvergreen",
    categories: [e.NATURE],
    figma_category: a.WEATHER,
    tags: [
      "plants",
      "branches",
      "leaves",
      "pine",
      "conifer",
      "green",
      "environmental"
    ],
    codepoint: 59100,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "tree-palm",
    pascal_name: "TreePalm",
    categories: [e.NATURE],
    figma_category: a.GAMES,
    tags: [
      "tropical",
      "beach",
      "plants",
      "branches",
      "leaves",
      "green",
      "environmental"
    ],
    codepoint: 59674,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "tree-structure",
    pascal_name: "TreeStructure",
    categories: [e.DEVELOPMENT, e.OFFICE],
    figma_category: a.DEVELOPMENT,
    tags: [
      "data structures",
      "family tree",
      "genealogy",
      "hierarchy",
      "taxonomy",
      "charts",
      "flowchart"
    ],
    codepoint: 59004,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "tree-view",
    pascal_name: "TreeView",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["*new*", "hierarchy"],
    codepoint: 61e3,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "trend-down",
    pascal_name: "TrendDown",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "decrease",
      "arrows"
    ],
    codepoint: 58540,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "trend-up",
    pascal_name: "TrendUp",
    categories: [e.FINANCE, e.OFFICE],
    figma_category: a.FINANCE,
    tags: [
      "graphs",
      "graphing",
      "charts",
      "statistics",
      "analyze",
      "analysis",
      "increase",
      "arrows"
    ],
    codepoint: 58542,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "triangle",
    pascal_name: "Triangle",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["3", "shapes", "polygons"],
    codepoint: 58544,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "triangle-dashed",
    pascal_name: "TriangleDashed",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["*new*", "3", "shapes", "polygons", "missing"],
    codepoint: 58546,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "trolley",
    pascal_name: "Trolley",
    categories: [e.OFFICE, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["*new*", "airport", "briefcase", "valise", "baggage"],
    codepoint: 58802,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "trolley-suitcase",
    pascal_name: "TrolleySuitcase",
    categories: [e.OFFICE, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["*new*", "airport", "briefcase", "valise", "baggage"],
    codepoint: 58804,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "trophy",
    pascal_name: "Trophy",
    categories: [e.GAMES, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["ribbons", "medals", "winning", "victory", "awards", "prize"],
    codepoint: 59006,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "truck",
    pascal_name: "Truck",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: ["trucks", "cars", "vehicles", "automobile", "shipping", "delivery"],
    codepoint: 58548,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "truck-trailer",
    pascal_name: "TruckTrailer",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "vehicles", "automobile", "shipping", "tractor", "semi"],
    codepoint: 58550,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "tumblr-logo",
    pascal_name: "TumblrLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["*new*", "social media", "logos"],
    codepoint: 59604,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "twitch-logo",
    pascal_name: "TwitchLogo",
    categories: [
      e.BRAND,
      e.COMMUNICATION,
      e.GAMES
    ],
    figma_category: a.BRAND,
    tags: [
      "logos",
      "streaming",
      "livestream",
      "gaming",
      "video games",
      "social media"
    ],
    codepoint: 58830,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "twitter-logo",
    pascal_name: "TwitterLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "social media", "tweets", "birds"],
    codepoint: 58554,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "umbrella",
    pascal_name: "Umbrella",
    categories: [e.OBJECTS, e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["raining", "rainy", "insurance"],
    codepoint: 59012,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "umbrella-simple",
    pascal_name: "UmbrellaSimple",
    categories: [e.OBJECTS, e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["raining", "rainy", "insurance"],
    codepoint: 59014,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "union",
    pascal_name: "Union",
    categories: [e.FINANCE, e.DEVELOPMENT],
    figma_category: a.FINANCE,
    tags: [
      "*new*",
      "∪",
      "union",
      "set",
      "member",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 60862,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "unite",
    pascal_name: "Unite",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: [
      "*updated*",
      "round",
      "join",
      "union",
      "merge",
      "combine",
      "intersecting",
      "intersection"
    ],
    codepoint: 59518,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "unite-square",
    pascal_name: "UniteSquare",
    categories: [e.DESIGN, e.EDITOR],
    figma_category: a.DESIGN,
    tags: ["join", "union", "merge", "combine", "intersecting", "intersection"],
    codepoint: 59512,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "upload",
    pascal_name: "Upload",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "uploaded",
      "uploading",
      "hard drive",
      "disk"
    ],
    codepoint: 58558,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "upload-simple",
    pascal_name: "UploadSimple",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "*updated*",
      "saved",
      "saving",
      "archived",
      "archiving",
      "archival",
      "uploaded",
      "uploading",
      "hard drive",
      "disk"
    ],
    codepoint: 58560,
    published_in: 1,
    updated_in: 2.1
  },
  {
    name: "usb",
    pascal_name: "Usb",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["serial", "port", "plug", "peripheral", "device"],
    codepoint: 59734,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "user",
    pascal_name: "User",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["person", "users", "profile", "account", "contact", "login"],
    codepoint: 58562,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "user-check",
    pascal_name: "UserCheck",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "*new*",
      "person",
      "users",
      "profile",
      "account",
      "contact",
      "login",
      "verified"
    ],
    codepoint: 60154,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "user-circle",
    pascal_name: "UserCircle",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["person", "users", "profile", "account", "contact", "login"],
    codepoint: 58564,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "user-circle-check",
    pascal_name: "UserCircleCheck",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "*new*",
      "person",
      "users",
      "profile",
      "account",
      "contact",
      "login",
      "verified"
    ],
    codepoint: 60472,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "user-circle-dashed",
    pascal_name: "UserCircleDashed",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "*new*",
      "person",
      "users",
      "profile",
      "account",
      "contact",
      "login",
      "pending",
      "missing",
      "removed"
    ],
    codepoint: 60470,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "user-circle-gear",
    pascal_name: "UserCircleGear",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "person",
      "users",
      "profile",
      "account",
      "contact",
      "settings",
      "preferences"
    ],
    codepoint: 58566,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "user-circle-minus",
    pascal_name: "UserCircleMinus",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "person",
      "users",
      "profile",
      "account",
      "contact",
      "delete",
      "remove",
      "-"
    ],
    codepoint: 58568,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "user-circle-plus",
    pascal_name: "UserCirclePlus",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "person",
      "users",
      "profile",
      "account",
      "contact",
      "add",
      "create",
      "+"
    ],
    codepoint: 58570,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "user-focus",
    pascal_name: "UserFocus",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "identification",
      "biometrics",
      "facial recognition",
      "profile",
      "person",
      "account",
      "autofocus"
    ],
    codepoint: 59132,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "user-gear",
    pascal_name: "UserGear",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "person",
      "users",
      "profile",
      "account",
      "contact",
      "settings",
      "preferences"
    ],
    codepoint: 58572,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "user-list",
    pascal_name: "UserList",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "person",
      "users",
      "profiles",
      "accounts",
      "members",
      "address book"
    ],
    codepoint: 59196,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "user-minus",
    pascal_name: "UserMinus",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "person",
      "users",
      "profile",
      "account",
      "contact",
      "delete",
      "remove",
      "-"
    ],
    codepoint: 58574,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "user-plus",
    pascal_name: "UserPlus",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "person",
      "users",
      "profile",
      "account",
      "contact",
      "add",
      "create",
      "+"
    ],
    codepoint: 58576,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "user-rectangle",
    pascal_name: "UserRectangle",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["person", "users", "profile", "account", "contact", "login"],
    codepoint: 58578,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "user-sound",
    pascal_name: "UserSound",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "*new*",
      "person",
      "users",
      "profile",
      "speech",
      "speaking",
      "voice"
    ],
    codepoint: 60584,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "user-square",
    pascal_name: "UserSquare",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: ["person", "users", "profile", "account", "contact", "login"],
    codepoint: 58580,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "user-switch",
    pascal_name: "UserSwitch",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "person",
      "users",
      "profile",
      "account",
      "login",
      "logout",
      "signin",
      "signout",
      "settings",
      "preferences"
    ],
    codepoint: 59222,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "users",
    pascal_name: "Users",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "user",
      "group",
      "team",
      "people",
      "profiles",
      "accounts",
      "contacts"
    ],
    codepoint: 58582,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "users-four",
    pascal_name: "UsersFour",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "user",
      "group",
      "team",
      "department",
      "community",
      "people",
      "profiles",
      "accounts",
      "contacts"
    ],
    codepoint: 59020,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "users-three",
    pascal_name: "UsersThree",
    categories: [e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "user",
      "group",
      "team",
      "community",
      "people",
      "profiles",
      "accounts",
      "contacts"
    ],
    codepoint: 59022,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "van",
    pascal_name: "Van",
    categories: [e.MAP, e.OBJECTS],
    figma_category: a.MAP,
    tags: [
      "westfalia",
      "microbus",
      "vanagon",
      "cars",
      "vehicles",
      "automobile",
      "transit",
      "transportation",
      "traveling"
    ],
    codepoint: 59430,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "vault",
    pascal_name: "Vault",
    categories: [
      e.OBJECTS,
      e.SYSTEM,
      e.FINANCE
    ],
    figma_category: a.SECURITY,
    tags: [
      "safe",
      "bank",
      "security",
      "secured",
      "authentication",
      "authenticated",
      "locked",
      "encrypted",
      "encryption"
    ],
    codepoint: 59246,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "vector-three",
    pascal_name: "VectorThree",
    categories: [
      e.ARROWS,
      e.DEVELOPMENT,
      e.DESIGN
    ],
    figma_category: a.ARROWS,
    tags: [
      "*new*",
      "3d",
      "xyz",
      "cartesian",
      "coordinates",
      "plane",
      "volume",
      "dimensions",
      "mathematics"
    ],
    codepoint: 61026,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "vector-two",
    pascal_name: "VectorTwo",
    categories: [
      e.ARROWS,
      e.DEVELOPMENT,
      e.DESIGN
    ],
    figma_category: a.ARROWS,
    tags: [
      "*new*",
      "2d",
      "xy",
      "cartesian",
      "coordinates",
      "plane",
      "dimensions",
      "mathematics"
    ],
    codepoint: 61028,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "vibrate",
    pascal_name: "Vibrate",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "audio",
      "volume",
      "viration",
      "ringer",
      "calls",
      "silent",
      "silenced"
    ],
    codepoint: 58584,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "video",
    pascal_name: "Video",
    categories: [e.PEOPLE],
    figma_category: a.EDUCATION,
    tags: ["training", "course", "education", "tutorial"],
    codepoint: 59200,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "video-camera",
    pascal_name: "VideoCamera",
    categories: [e.MEDIA, e.SYSTEM, e.OBJECTS],
    figma_category: a.MEDIA,
    tags: ["videography", "films", "movies", "recording"],
    codepoint: 58586,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "video-camera-slash",
    pascal_name: "VideoCameraSlash",
    categories: [e.MEDIA, e.SYSTEM],
    figma_category: a.MEDIA,
    tags: ["videography", "films", "movies", "recording", "disabled"],
    codepoint: 58588,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "video-conference",
    pascal_name: "VideoConference",
    categories: [
      e.MEDIA,
      e.SYSTEM,
      e.COMMUNICATION
    ],
    figma_category: a.MEDIA,
    tags: [
      "*new*",
      "video call",
      "zoom",
      "skype",
      "discord",
      "facetime",
      "meeting"
    ],
    codepoint: 60878,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "vignette",
    pascal_name: "Vignette",
    categories: [e.DESIGN],
    figma_category: a.DESIGN,
    tags: ["photography", "darkroom", "movie", "analog"],
    codepoint: 60322,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "vinyl-record",
    pascal_name: "VinylRecord",
    categories: [e.MEDIA, e.OFFICE],
    figma_category: a.MEDIA,
    tags: ["recording", "audio", "album", "music", "ep", "lp"],
    codepoint: 60588,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "virtual-reality",
    pascal_name: "VirtualReality",
    categories: [e.GAMES, e.MEDIA],
    figma_category: a.GAMES,
    tags: ["virtual reality", "vr", "headset", "metaverse"],
    codepoint: 59320,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "virus",
    pascal_name: "Virus",
    categories: [e.HEALTH],
    figma_category: a.HEALTH,
    tags: ["germs", "disease", "illness"],
    codepoint: 59350,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "visor",
    pascal_name: "Visor",
    categories: [
      e.DEVELOPMENT,
      e.MEDIA,
      e.OBJECTS
    ],
    figma_category: a.MEDIA,
    tags: ["*new*", "goggles", "vision"],
    codepoint: 60970,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "voicemail",
    pascal_name: "Voicemail",
    categories: [e.SYSTEM],
    figma_category: a.COMMUNICATION,
    tags: ["phonecalls", "missed", "recording", "telephone", "landline"],
    codepoint: 58590,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "volleyball",
    pascal_name: "Volleyball",
    categories: [e.GAMES, e.HEALTH, e.OBJECTS],
    figma_category: a.GAMES,
    tags: ["sports"],
    codepoint: 59174,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "wall",
    pascal_name: "Wall",
    categories: [e.OBJECTS, e.SYSTEM],
    figma_category: a.SECURITY,
    tags: ["firewall", "security", "secured", "blocks", "bricks"],
    codepoint: 59016,
    published_in: 1.2,
    updated_in: 1.4
  },
  {
    name: "wallet",
    pascal_name: "Wallet",
    categories: [
      e.COMMERCE,
      e.FINANCE,
      e.OBJECTS
    ],
    figma_category: a.COMMERCE,
    tags: ["money", "payment", "paying", "purchase"],
    codepoint: 59018,
    published_in: 1.2,
    updated_in: 1.2
  },
  {
    name: "warehouse",
    pascal_name: "Warehouse",
    categories: [e.COMMERCE, e.MAP],
    figma_category: a.COMMERCE,
    tags: [
      "storage",
      "industry",
      "manufacture",
      "buildings",
      "places",
      "locations"
    ],
    codepoint: 60628,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "warning",
    pascal_name: "Warning",
    categories: [e.SYSTEM],
    figma_category: a.SECURITY,
    tags: ["alert", "danger", "dangerous", "caution", "errors"],
    codepoint: 58592,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "warning-circle",
    pascal_name: "WarningCircle",
    categories: [e.SYSTEM],
    figma_category: a.SECURITY,
    tags: ["alert", "danger", "dangerous", "caution", "errors", "round"],
    codepoint: 58594,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "warning-diamond",
    pascal_name: "WarningDiamond",
    categories: [e.SYSTEM],
    figma_category: a.SECURITY,
    tags: ["alert", "danger", "dangerous", "caution", "errors"],
    codepoint: 59388,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "warning-octagon",
    pascal_name: "WarningOctagon",
    categories: [e.SYSTEM],
    figma_category: a.SECURITY,
    tags: ["alert", "danger", "dangerous", "caution", "errors", "8", "eight"],
    codepoint: 58596,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "washing-machine",
    pascal_name: "WashingMachine",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: ["*new*", "clothing", "laundry", "cleaning"],
    codepoint: 60904,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "watch",
    pascal_name: "Watch",
    categories: [e.SYSTEM, e.OBJECTS],
    figma_category: a.TIME,
    tags: [
      "times",
      "timer",
      "alarm",
      "schedule",
      "events",
      "clock",
      "wristwatch",
      "wearable"
    ],
    codepoint: 58598,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "wave-sawtooth",
    pascal_name: "WaveSawtooth",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["synth", "synthesizer", "sound", "audio", "music", "waveform"],
    codepoint: 60060,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "wave-sine",
    pascal_name: "WaveSine",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["synth", "synthesizer", "sound", "audio", "music", "waveform"],
    codepoint: 60058,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "wave-square",
    pascal_name: "WaveSquare",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["synth", "synthesizer", "sound", "audio", "music", "waveform"],
    codepoint: 60062,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "wave-triangle",
    pascal_name: "WaveTriangle",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["synth", "synthesizer", "sound", "audio", "music", "waveform"],
    codepoint: 60064,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "waveform",
    pascal_name: "Waveform",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["*updated*", "audio", "sound", "spectrum", "spectrograph", "music"],
    codepoint: 59394,
    published_in: 2,
    updated_in: 2.1
  },
  {
    name: "waveform-slash",
    pascal_name: "WaveformSlash",
    categories: [e.MEDIA],
    figma_category: a.MEDIA,
    tags: ["*new*", "audio", "sound", "spectrum", "spectrograph", "music"],
    codepoint: 59392,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "waves",
    pascal_name: "Waves",
    categories: [e.NATURE, e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["ocean", "tides", "surf"],
    codepoint: 59102,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "webcam",
    pascal_name: "Webcam",
    categories: [
      e.OBJECTS,
      e.SYSTEM,
      e.COMMUNICATION
    ],
    figma_category: a.MEDIA,
    tags: ["camera", "video conference"],
    codepoint: 59826,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "webcam-slash",
    pascal_name: "WebcamSlash",
    categories: [
      e.COMMUNICATION,
      e.OBJECTS,
      e.SYSTEM
    ],
    figma_category: a.MEDIA,
    tags: ["camera", "video conference"],
    codepoint: 60636,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "webhooks-logo",
    pascal_name: "WebhooksLogo",
    categories: [e.DEVELOPMENT, e.BRAND],
    figma_category: a.DEVELOPMENT,
    tags: ["api"],
    codepoint: 60590,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "wechat-logo",
    pascal_name: "WechatLogo",
    categories: [e.BRAND],
    figma_category: a.BRAND,
    tags: ["weixin", "logos"],
    codepoint: 59602,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "whatsapp-logo",
    pascal_name: "WhatsappLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["logos", "messages", "messaging"],
    codepoint: 58832,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "wheelchair",
    pascal_name: "Wheelchair",
    categories: [e.HEALTH, e.MAP, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "handicapped",
      "medical",
      "disabled",
      "differently abled",
      "accessible",
      "accessibility",
      "a11y"
    ],
    codepoint: 58600,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "wheelchair-motion",
    pascal_name: "WheelchairMotion",
    categories: [e.HEALTH, e.MAP, e.PEOPLE],
    figma_category: a.PEOPLE,
    tags: [
      "handicapped",
      "medical",
      "disabled",
      "differently abled",
      "accessible",
      "accessibility",
      "a11y"
    ],
    codepoint: 59546,
    published_in: 2,
    updated_in: 2
  },
  {
    name: "wifi-high",
    pascal_name: "WifiHigh",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["wireless", "internet", "network", "connection", "connectivity"],
    codepoint: 58602,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "wifi-low",
    pascal_name: "WifiLow",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["wireless", "internet", "network", "connection", "connectivity"],
    codepoint: 58604,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "wifi-medium",
    pascal_name: "WifiMedium",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["wireless", "internet", "network", "connection", "connectivity"],
    codepoint: 58606,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "wifi-none",
    pascal_name: "WifiNone",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: ["wireless", "internet", "network", "connection", "connectivity"],
    codepoint: 58608,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "wifi-slash",
    pascal_name: "WifiSlash",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "wireless",
      "internet",
      "network",
      "connection",
      "connectivity",
      "disabled",
      "disconnected"
    ],
    codepoint: 58610,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "wifi-x",
    pascal_name: "WifiX",
    categories: [e.SYSTEM],
    figma_category: a.SYSTEM,
    tags: [
      "wireless",
      "internet",
      "network",
      "connection",
      "connectivity",
      "disconnected",
      "errors"
    ],
    codepoint: 58612,
    published_in: 1,
    updated_in: 1.4
  },
  {
    name: "wind",
    pascal_name: "Wind",
    categories: [e.WEATHER],
    figma_category: a.WEATHER,
    tags: ["meteorology", "windy", "stormy", "blustery", "gusty", "air"],
    codepoint: 58834,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "windmill",
    pascal_name: "Windmill",
    categories: [e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: [
      "*new*",
      "turbine",
      "energy",
      "renewable",
      "sustainability",
      "countryside",
      "landscape",
      "green",
      "power",
      "buildings"
    ],
    codepoint: 59896,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "windows-logo",
    pascal_name: "WindowsLogo",
    categories: [e.BRAND, e.DEVELOPMENT],
    figma_category: a.BRAND,
    tags: ["microsoft", "computers"],
    codepoint: 59026,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "wine",
    pascal_name: "Wine",
    categories: [e.COMMERCE, e.MAP, e.OBJECTS],
    figma_category: a.COMMERCE,
    tags: [
      "drinks",
      "beverages",
      "vineyard",
      "places",
      "locations",
      "bars",
      "restaurants",
      "food",
      "dining"
    ],
    codepoint: 59058,
    published_in: 1.3,
    updated_in: 1.3
  },
  {
    name: "wrench",
    pascal_name: "Wrench",
    categories: [
      e.SYSTEM,
      e.OBJECTS,
      e.COMMERCE
    ],
    figma_category: a.COMMERCE,
    tags: [
      "settings",
      "setup",
      "preferences",
      "tools",
      "machinery",
      "mechanical",
      "repairs"
    ],
    codepoint: 58836,
    published_in: 1.1,
    updated_in: 1.1
  },
  {
    name: "x",
    pascal_name: "X",
    categories: [
      e.DEVELOPMENT,
      e.FINANCE,
      e.SYSTEM
    ],
    figma_category: a.FINANCE,
    tags: [
      "×",
      "closed",
      "cancelled",
      "dismissed",
      "times",
      "multiply",
      "mulitplication",
      "product",
      "mathematics",
      "arithmetic",
      "calculator"
    ],
    codepoint: 58614,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "x-circle",
    pascal_name: "XCircle",
    categories: [e.SYSTEM],
    figma_category: a.FINANCE,
    tags: ["closed", "cancelled", "dismissed", "round"],
    codepoint: 58616,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "x-logo",
    pascal_name: "XLogo",
    categories: [e.BRAND, e.COMMUNICATION],
    figma_category: a.BRAND,
    tags: ["*new*", "twitter", "logos", "social media", "tweets"],
    codepoint: 58556,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "x-square",
    pascal_name: "XSquare",
    categories: [e.SYSTEM],
    figma_category: a.FINANCE,
    tags: ["closed", "cancelled", "dismissed"],
    codepoint: 58618,
    published_in: 1,
    updated_in: 1
  },
  {
    name: "yarn",
    pascal_name: "Yarn",
    categories: [e.GAMES, e.COMMERCE],
    figma_category: a.COMMERCE,
    tags: ["*new*", "knitting", "sewing"],
    codepoint: 60826,
    published_in: 2.1,
    updated_in: 2.1
  },
  {
    name: "yin-yang",
    pascal_name: "YinYang",
    categories: [e.COMMUNICATION],
    figma_category: a.COMMUNICATION,
    tags: ["symbol", "good", "evil", "black", "white"],
    codepoint: 59690,
    published_in: 1.4,
    updated_in: 1.4
  },
  {
    name: "youtube-logo",
    pascal_name: "YoutubeLogo",
    categories: [
      e.BRAND,
      e.COMMUNICATION,
      e.MEDIA
    ],
    figma_category: a.BRAND,
    tags: ["logos", "google", "videos", "movies", "social media"],
    codepoint: 58620,
    published_in: 1,
    updated_in: 1
  }
];
export {
  a as FigmaCategory,
  e as IconCategory,
  t as IconStyle,
  n as icons
};
